import {
  Paper,
  FormControl,
  Button,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  FormControlLabel,
  Switch,
  Tooltip, Drawer, Dialog
} from "@material-ui/core";
import {preventDoubleClick} from "./preventDC.js"
import {CSVLink} from "react-csv"
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { makeStyles } from "@material-ui/core/styles";
import { useState, useEffect } from "react";
import emailjs from "@emailjs/browser";
import { init } from "@emailjs/browser";
import GetRole from "./user";
import { DataGrid } from "@mui/x-data-grid";
import {
  overrideTripsbyDate,
  fetchworkdoneleadsbydate,
  searchTripsbyDate,
  searchQCbyDate,
  getluxury,
  fetchcommentedbydate,
  fetchactivetripscount,
  gmailSend,
  newsearchQEbyDate,
  dupcustCheck,
  duphotelCheck,
  dupleadCheck,
  fetchDest,
  duptripCheck,
  fetchtripcallbyauditdate,
  fetchauditleadcallbydate,
  duptourCheck,
  dupquoteCheck,
  dupcustnumberCheck,
  fetchtodayfup,
  fetchtodayhottrips,
  fetchtodaycanctrips,
  fetchtodayconvtrips,
  fetchtodaypostponedtrips,
  searchconvTripsbyDate,
  fetchtodayquotes,
  fetchtodayeditquotes,
  fetchActiveTrips,
  fetchtodaytrips,
  searchcancTripsbyDate,
  fetchtodayassignedleads,
  fetchworkfalseleads,
  fetchtodayupdatedleadsTL,
  fetchtodayupdatedleads,
  searchupdatedLeadsbyDate,
  fetchupdatedtripsbyDate,
  fetchupdatedtodaytrips,
  fetchupdatedtripstodayTL,
  searchpotentialTripsbyDate,
  fetchtodaycust,
  searchclosedTripsbyDate,
  fetchEmployees,
  searchLeadsbyDate,
  searchhotTripsbyDate,
  fetchActiveTripsTL,
  fetchtodayassignedleadsTL,
  fetchtodaycustTL,
  fetchtodaytripsTL,
  fetchtodayquotesTL,
  fetchtodayeditquotesTL,
  fetchtodaypostponedtripsTL,
  fetchtodayfupTL,
  fetchtodayhottripsTL,
  fetchtodaycanctripsTL,
  fetchtodayconvtripsTL,
  fetchTeambyName,
  searchboTripsbyDate,
  fetchfupbydate,
  fetchpotentialhot,
  fetchReftrips,
  fetchtripcallbydate,
  fetchleadcallbydate,
  fetchaudittripcallbydate,
  fetchaudittripcallbydate2,
  fetchleadcallbyauditdate,
  fetchtripcalltoday,
  fetchleadcalltoday,
  fetchtripcallbydateTL,
  fetchleadcallbydateTL,
  fetchQuotebyId,
  findtripbypayment
} from "../api/customerapi";
import DateCalc from "./date";
import {getquality, newgetqualitylead, removeDuplicates2, removeDuplicates, DateCalc2, sslist, getconvdate, total, removeDuplicatesmulti, removeExistingFromArray2multi} from "./date";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginLeft: theme.spacing(10),
    marginRight: theme.spacing(10),
    marginBottom: theme.spacing(5),
    marginTop: theme.spacing(4),
    justifyContent: "center",
    backgroundColor: "#fffcfa",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(2),
    width: theme.spacing(30),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    textAlign: "left",
  },
  headertext: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(3),
  },
  button: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: theme.spacing(24),
    height: theme.spacing(5),
    marginTop: theme.spacing(2.5),
    marginBottom: theme.spacing(1),
    fontSize: 14,
  },
  button2: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: theme.spacing(24),
    height: theme.spacing(5),
    marginTop: theme.spacing(2.5),
    marginBottom: theme.spacing(1),
    fontSize: 14,
  },
}));

const Analyticsdata = () => {
  const classes = useStyles();

  const width = window.innerWidth - 200;
  //console.log(width);
  const columns = [
    {
      field: "employee",
      headerName: " Employee",
      width: width / 12,
      cellClassName: "gridcell",
    },
    {
      field: "created_leads",
      headerName: "Leads Created",
      width: width / 12,
    },
    {
      field: "potential_leads",
      headerName: "Potential Leads",
      width: width / 12,
    },
    {
      field: "created_trips",
      headerName: "Trips Created",
      width: width / 12,
    },
    {
      field: "cancelled_trips",
      headerName: "Cancelled Trips",
      width: (width / 12) ,
    },
    {
      field: "bo_trips",
      headerName: "BO Trips",
      width: (width / 12) ,
    },
    {
      field: "active_trips",
      headerName: "Active Trips",
      width: width / 12,
    },
    {
      field: "hot_trips",
      headerName: "Hot Trips",
      width: width / 12,
    },
    {
      field: "converted_trips",
      headerName: "Converted Trips",
      width: width / 12,
    },
    {
      field: "closed_l2c",
      headerName: "T2C Closed",
      width: width / 12,
    },
    {
      field: "closed_l2c_noref",
      headerName: "T2C w/o ref",
      width: width / 12,
    },
    
  ];

  const columns2 = [
    {
      field: "employee",
      headerName: " Employee",
      width: width / 12,
      cellClassName: "gridcell",
    },

    {
      field: "converted_trips",
      headerName: "Converted Trips",
      width: (width / 12) * 2,
    },
    {
      field: "t2c",
      headerName: "T2C Converted",
      width: (width / 12) * 2,
    },
    {
      field: "closed_l2c_noref",
      headerName: "T2C w/o ref",
      width: (width / 12) * 2,
    },
    {
      field: "revenue",
      headerName: "Revenue",
      width: (width / 12) * 1.5,
    },
    {
      field: "land_revenue",
      headerName: "Land Revenue",
      width: (width / 12) * 1.5,
    },
    {
      field: "profit",
      headerName: "Profit",
      width: width / 12,
    },
    {
      field: "margin",
      headerName: "Margin",
      width: width / 12,
    },
  ];

  const columns3 = [
    {
      field: "employee",
      headerName: " Employee",
      width: width / 12,
      cellClassName: "gridcell",
    },
    {
      field: "total_trips",
      headerName: "Total trips",
      width: width / 12,
    },

    {
      field: "active_trips",
      headerName: "Active Trips",
      width: width / 12,
    },
    {
      field: "hot_trips",
      headerName: "Hot Trips",
      width: width / 12,
    },
     {
      field: "active_hot",
      headerName: "A+H",
      width: width / 12,
    },
    {
      field: "converted_trips",
      headerName: "Converted Trips",
      width: width / 12,
    },
    {
      field: "postponed_trips",
      headerName: "Postponed Trips",
      width: width / 12,
    },
    
    {
      field: "fup_nextday",
      headerName: "Fup till tomorrow",
      width: width / 12,
    },
    {
      field: "fup_dayafter",
      headerName: "Fup Day After",
      width: width / 12,
    },
    {
      field: "fup_thirdday",
      headerName: "Fup 3rd Day",
      width: width / 12,
    },
    {
      field: "fup_4to7days",
      headerName: "Fup 4to7",
      width: width / 12,
    },
    {
      field: "fup_share",
      headerName: "3-Fup Coverage",
      width: (width / 12) * 1,
    },
    {
      field: "fup_share2",
      headerName: "7-Fup Coverage",
      width: (width / 12) * 1,
    },
    {
      field: "fup_today",
      headerName: "Fup today",
      width: width / 12,
    },
  ];

  const columns4 = [
    {
      field: "employee",
      headerName: " Employee",
      width: width / 12,
      cellClassName: "gridcell",
    },

    {
      field: "daily_lead",
      headerName: "Leads",
      width: width / 12,
    },
    {
      field: "total_lead",
      headerName: "Total Leads",
      width: width / 12,
    },
    {
      field: "daily_pot_lead",
      headerName: "Pot Leads",
      width: width / 12,
    },
    {
      field: "daily_cust",
      headerName: "Customers",
      width: width / 12,
    },
    {
      field: "daily_trips",
      headerName: "Trips",
      width: width / 12,
    },
    {
      field: "daily_canc_trips",
      headerName: "Cancelled Trips",
      width: width / 12,
    },
    {
      field: "daily_postponed_trips",
      headerName: "Postponed Trips",
      width: width / 12,
    },
    {
      field: "daily_conv_trips",
      headerName: "Converted Trips",
      width: width / 12,
    },
    {
      field: "daily_hot_trips",
      headerName: "Hot Trips",
      width: width / 12,
    },
    {
      field: "daily_quotes",
      headerName: "Quotes Create",
      width: width / 12,
    },
    {
      field: "daily_edit_quotes",
      headerName: "Quotes Edit",
      width: width / 12,
    },
    {
      field: "daily_fup",
      headerName: "Fups",
      width: width / 12,
    },
    {
      field: "qe_fup_ratio",
      headerName: "Ratio",
      width: width / 12,
    },
    {
      field: "avg_lead_time",
      headerName: "TTL",
      width: width / 12,
    },
    {
      field: "avg_fup_time",
      headerName: "Delay in Fups",
      width: width / 12,
    },
    {
      field: "daily_trips_unique",
      headerName: "UTs",
      width: width / 12,
    },
    {
      field: "daily_leads_unique",
      headerName: "ULs",
      width: width / 12,
    },
    {
      field: "daily_called",
      headerName: "Called",
      width: width / 12,
    },
    {
      field: "daily_answered",
      headerName: "Answered",
      width: width / 12,
    },
    {
      field: "daily_talktime",
      headerName: "Talktime",
      width: width / 12,
    },
    {
      field: "daily_eff_calls",
      headerName: "Eff. Calls",
      width: width / 12,
    },
  ];

  const columns5 = [
    {
      field: "employee",
      headerName: " Employee",
      width: width / 12,
      cellClassName: "gridcell",
    },

    {
      field: "closed_trips",
      headerName: "Closed Trips",
      width: (width / 12) * 2,
    },
    {
      field: "has_review",
      headerName: "Review",
      width: (width / 12) * 2,
    },

    {
      field: "review_percentage",
      headerName: "Review %",
      width: (width / 12) * 2,
    },
    {
      field: "review_score",
      headerName: " Avg. Review Score",
      width: (width / 12) * 2,
    },
  ];

  const columns6 = [
    {
      field: "employee",
      headerName: " Employee",
      width: width / 12,
      cellClassName: "gridcell",
    },

    {
      field: "hot_trips",
      headerName: "Hot Trips",
      width: (width / 12) * 2,
    },
    {
      field: "converted_trips",
      headerName: "Converted Trips",
      width: (width / 12) * 2,
    },

    {
      field: "h2c",
      headerName: "H2C",
      width: (width / 12) * 2,
    },
  ];

  const columns7 = [
    {
      field: "employee",
      headerName: " Employee",
      width: width / 12,
      cellClassName: "gridcell",
    },

    {
      field: "trips_created",
      headerName: "Trips Created",
      width: (width / 12),
    },
    {
      field: "quotes_created",
      headerName: "Quotes Created",
      width: (width / 12),
    },

    {
      field: "quotes_edited",
      headerName: "Quotes Edited",
      width: (width / 12),
    },
    
    {
      field: "calc_quotes_edited",
      headerName: "Estimated QE",
      width: (width / 12),
    },
    {
      field: "qe_perc",
      headerName: "QE %",
      width: (width / 12),
    },
    {
      field: "time_to_travel",
      headerName: "TTT",
      width: (width / 12),
    },
  ];

  const columns8 = [
    {
      field: "employee",
      headerName: " Employee",
      width: width / 12,
      cellClassName: "gridcell",
    },

    {
      field: "fups_created",
      headerName: "Closed Fups",
      width: (width / 12),
    },
    {
      field: "nr_fups_created",
      headerName: "NR Fups",
      width: (width / 12),
    },
    {
      field: "ne_perc",
      headerName: "NR %",
      width: (width / 12),
    },
    {
      field: "fupnormal",
      headerName: "Normal",
      width: (width / 12),
    },
    {
      field: "fupnormal_perc",
      headerName: "Normal %",
      width: (width / 12),
    },
    {
      field: "fupprog",
      headerName: "Prog",
      width: (width / 12),
    },
    {
      field: "fupprog_perc",
      headerName: "Prog %",
      width: (width / 12),
    },
    {
      field: "fupmanual",
      headerName: "Manual",
      width: (width / 12),
    },
    {
      field: "fupmanual_perc",
      headerName: "Manual %",
      width: (width / 12),
    },
    {
      field: "fuppost",
      headerName: "Post",
      width: (width / 12),
    },
    {
      field: "fuppost_perc",
      headerName: "Post %",
      width: (width / 12),
    },
    {
      field: "total_perc",
      headerName: "Total %",
      width: (width / 12),
    },
    
  ];

  const columns9 = [
    {
      field: "employee",
      headerName: " Employee",
      width: width / 12*1,
      cellClassName: "gridcell",
    },

    
    {
      field: "daily_trips_unique",
      headerName: "Unique Trips",
      width: width / 12*1.5,
    },
    {
      field: "daily_leads_unique",
      headerName: "Unique Leads",
      width: width / 12*1,
    },
    {
      field: "daily_called",
      headerName: "Called",
      width: width / 12*1,
    },
    {
      field: "daily_answered",
      headerName: "Answered",
      width: width / 12*1,
    },
    {
      field: "answered_per",
      headerName: " % Answered",
      width: width / 12*1,
    },
    {
      field: "daily_talktime",
      headerName: "Talktime",
      width: width / 12*1,
    },
    {
      field: "avg_talk_time",
      headerName: "Avg. TalkTime",
      width: width / 12,
    },
    {
      field: "daily_eff_calls",
      headerName: "Eff. Calls",
      width: width / 12,
    },
    {
      field: "eff_calls_per_answered",
      headerName: "Eff./Answered",
      width: width / 12,
    },
    {
      field: "comment_number",
      headerName: "Comment Number",
      width: width / 12,
    },
  ];

  const columns10 = [
    {
      field: "lead_id",
      headerName: " Lead Id",
      width: width / 12*1,
      cellClassName: "gridcell",
    },

    
    {
      field: "name",
      headerName: "Name",
      width: width / 12,
    },
    {
      field: "dest",
      headerName: "Destination",
      width: width / 12,
    },
    {
      field: "lead_owner",
      headerName: "Owner",
      width: width / 12*1,
    },
    {
      field: "talk_time",
      headerName: "Talk Time",
      width: width / 12*1,
    },
    {
      field: "effective",
      headerName: "Effective",
      width: width / 12*1,
    },
    {
      field: "disconnected_by",
      headerName: "Disconnected By",
      width: width / 12*2,
    },
    {
      field: "caller",
      headerName: "Caller",
      width: width / 12,
    },
     {
      field: "customer",
      headerName: "Customer",
      width: width / 12*1.5,
    },
     {
      field: "call_time",
      headerName: "Call Time",
      width: width / 12*2,
    },
    {
      field: "qs",
      headerName: "Score",
      width: width / 12,
    },
    {
      field: "quality",
      headerName: "Quality",
      width: width / 12,
    },
    {
      field: "audit_date",
      headerName: "Audit Date",
      width: width / 12,
    },
    {
      field: "tl",
      headerName: "TL",
      width: width / 12,
    },
    {
      field: "opening_script",
      headerName: "Opening Script",
      width: width / 12,
    },
     {
      field: "closing_script",
      headerName: "Closing Script",
      width: width / 12,
    },
     {
      field: "hold_script",
      headerName: "Hold Script",
      width: width / 12,
    },
     
     {
      field: "interruption",
      headerName: "Interruption",
      width: width / 12,
    },
     {
      field: "rate_of_speech",
      headerName: "Rate of Speech",
      width: width / 12,
    },
     {
      field: "personalization",
      headerName: "Personalization",
      width: width / 12,
    },
     {
      field: "tone",
      headerName: "Tone",
      width: width / 12,
    },
     {
      field: "language",
      headerName: "Language",
      width: width / 12,
    },
     {
      field: "fillers",
      headerName: "Fillers",
      width: width / 12,
    },
     {
      field: "active_listening",
      headerName: "Actove Listening",
      width: width / 12,
    },
     {
      field: "rapport",
      headerName: "Rapport",
      width: width / 12,
    },
     {
      field: "basic_information",
      headerName: "Basic Info",
      width: width / 12,
    },
     {
      field: "empathy",
      headerName: "Empathy",
      width: width / 12,
    },
     {
      field: "explanation",
      headerName: "Explanation",
      width: width / 12,
    },
     {
      field: "guidance",
      headerName: "Guidance",
      width: width / 12,
    },
     {
      field: "sales_pitch",
      headerName: "Sales Pitch",
      width: width / 12,
    },
     {
      field: "closing",
      headerName: "Closing",
      width: width / 12,
    },
    //  {
    //   field: "oh_delay",
    //   headerName: "OH Delay",
    //   width: width / 12,
    // },
    //  {
    //   field: "oh_price",
    //   headerName: "OH Price",
    //   width: width / 12,
    // },
    //  {
    //   field: "oh_probing",
    //   headerName: "OH Probing",
    //   width: width / 12,
    // },
    //  {
    //   field: "oh_permission",
    //   headerName: "OH Permission",
    //   width: width / 12,
    // },
    //  {
    //   field: "oh_trust",
    //   headerName: "OH Trust",
    //   width: width / 12,
    // },
     {
      field: "improvement",
      headerName: "Improvement",
      width: width / 12,
    },
     {
      field: "description",
      headerName: "Description",
      width: width / 12,
    },
     
   
  ];

  const columns10b = [
    {
      field: "lead_id",
      headerName: "Trip Id",
      width: width / 12*1,
      cellClassName: "gridcell",
    },

    
    {
      field: "name",
      headerName: "Name",
      width: width / 12,
    },
    {
      field: "dest",
      headerName: "Destination",
      width: width / 12,
    },
    {
      field: "lead_owner",
      headerName: "Owner",
      width: width / 12*1,
    },
    {
      field: "talk_time",
      headerName: "Talk Time",
      width: width / 12*1,
    },
    {
      field: "effective",
      headerName: "Effective",
      width: width / 12*1,
    },
    {
      field: "disconnected_by",
      headerName: "Disconnected By",
      width: width / 12*2,
    },
    
    {
      field: "caller",
      headerName: "Caller",
      width: width / 12,
    },
      {
      field: "customer",
      headerName: "Customer",
      width: width / 12*1.5,
    },
     {
      field: "call_time",
      headerName: "Call Time",
      width: width / 12*2,
    },
    {
      field: "qs",
      headerName: "Score",
      width: width / 12,
    },
    {
      field: "audit_date",
      headerName: "Audit Date",
      width: width / 12,
    },
     {
      field: "tl",
      headerName: "TL",
      width: width / 12,
    },
    {
      field: "opening_script",
      headerName: "Opening Script",
      width: width / 12,
    },
     {
      field: "closing_script",
      headerName: "Closing Script",
      width: width / 12,
    },
    //  {
    //   field: "hold_script",
    //   headerName: "Hold Script",
    //   width: width / 12,
    // },
     
     {
      field: "interruption",
      headerName: "Interruption",
      width: width / 12,
    },
     {
      field: "rate_of_speech",
      headerName: "Rate of Speech",
      width: width / 12,
    },
     {
      field: "personalization",
      headerName: "Personalization",
      width: width / 12,
    },
     {
      field: "tone",
      headerName: "Tone",
      width: width / 12,
    },
     {
      field: "language",
      headerName: "Language",
      width: width / 12,
    },
     {
      field: "fillers",
      headerName: "Fillers",
      width: width / 12,
    },
    //  {
    //   field: "active_listening",
    //   headerName: "Actove Listening",
    //   width: width / 12,
    // },
    //  {
    //   field: "rapport",
    //   headerName: "Rapport",
    //   width: width / 12,
    // },
    //  {
    //   field: "basic_information",
    //   headerName: "Basic Info",
    //   width: width / 12,
    // },
     {
      field: "empathy",
      headerName: "Empathy",
      width: width / 12,
    },
    //  {
    //   field: "explanation",
    //   headerName: "Explanation",
    //   width: width / 12,
    // },
     {
      field: "guidance",
      headerName: "Guidance",
      width: width / 12,
    },
    //  {
    //   field: "sales_pitch",
    //   headerName: "Sales Pitch",
    //   width: width / 12,
    // },
     {
      field: "closing",
      headerName: "Closing",
      width: width / 12,
    },
     {
      field: "oh_delay",
      headerName: "OH Delay",
      width: width / 12,
    },
     {
      field: "oh_price",
      headerName: "OH Price",
      width: width / 12,
    },
     {
      field: "oh_probing",
      headerName: "OH Probing",
      width: width / 12,
    },
     {
      field: "oh_permission",
      headerName: "OH Permission",
      width: width / 12,
    },
     {
      field: "oh_trust",
      headerName: "OH Trust",
      width: width / 12,
    },
     {
      field: "improvement",
      headerName: "Improvement",
      width: width / 12,
    },
     {
      field: "description",
      headerName: "Description",
      width: width / 12,
    },
  ];

  const columns11 = [
    {
      field: "lead_id",
      headerName: " Lead Id",
      width: width / 12*1,
      cellClassName: "gridcell",
    },

    
    {
      field: "name",
      headerName: "Name",
      width: width / 12,
    },
    {
      field: "dest",
      headerName: "Destination",
      width: width / 12,
    },
    {
      field: "lead_owner",
      headerName: "Owner",
      width: width / 12*1,
    },
    {
      field: "call1",
      headerName: "Call N",
      width: width / 12*2,
    },
    {
      field: "call2",
      headerName: "Call N-1",
      width: width / 12*2,
    },
    {
      field: "call3",
      headerName: "Call N-2",
      width: width / 12*2,
    },
    {
      field: "skip_second_call",
      headerName: "Skip Call",
      width: width / 12*2,
    },
    {
      field: "canc_reason",
      headerName: "Canc Reason",
      width: width / 12*2,
    },
    
   
  ];

  const columns12 = [
    {
      field: "hour",
      headerName: "Hour",
      width: width / 12*1,
      cellClassName: "gridcell",
    },

    
    {
      field: "called",
      headerName: "Calls Made",
      width: width / 12,
    },
    {
      field: "answered",
      headerName: "Answered",
      width: width / 12*1,
    },
    {
      field: "effective",
      headerName: "Effective",
      width: width / 12*1,
    },
    
   
  ];

    const columns14 = [
    
    {
      field: "lead_owner",
      headerName: "Owner",
      width: width / 12*1,
    },
    {
      field: "total",
      headerName: "Total",
      width: width / 12*1,
    },
    {
      field: "talk_time",
      headerName: "Talk Time",
      width: width / 12*2,
    },
    {
      field: "effective",
      headerName: "Effective",
      width: width / 12*2,
    },
  
    {
      field: "qs",
      headerName: "Score",
      width: width / 12*2,
    },
   
     {
      field: "tl",
      headerName: "TL",
      width: width / 12,
    },
   
  ];

  const headers=[
    {label:"Owner", key:"lead_owner"},
    {label:"Name", key:"name"},
    {label:"Lead Id", key:"lead_id"},
    {label:"Talk Time", key:"talk_time"},
    {label:"Effective", key:"effective"},
    {label:"Disconnected By", key:"disconnected_by"},
    {label:"Dest", key:"dest"},
    {label:"Quality", key:"quality"},
    {label:"Caller", key:"caller"},
    {label:"Call Start Time", key:"call_time"},
    {label:"Customer", key:"customer"},
    {label:"Score", key:"qs"},
    {label:"Audit Date", key:"audit_date"},
      {label:"TL", key:"tl"},
    {label:"Opening Script", key:"opening_script"},
    {label:"Closing Script", key:"closing_script"},
    {label:"Hold Script", key:"hold_script"},
    {label:"Interruption", key:"interruption"},
    {label:"Rate of Speech", key:"rate_of_speech"},
    {label:"Personalization", key:"personalization"},
    {label:"Tone", key:"tone"},
    {label:"Language", key:"language"},
    {label:"Fillers", key:"fillers"},
    {label:"Active Listening", key:"active_listening"},
    {label:"Rapport", key:"rapport"},
    {label:"Basic Info", key:"basic_information"},
    {label:"Empathy", key:"empathy"},
    {label:"Explanation", key:"explanation"},
    {label:"Guidance", key:"guidance"},
    {label:"Sales Pitch", key:"sales_pitch"},
    {label:"Closing", key:"closing"},
    {label:"OH Delay", key:"oh_delay"},
    {label:"OH Price", key:"oh_price"},
    {label:"OH Probing", key:"oh_probing"},
    {label:"OH Permission", key:"oh_permission"},
    {label:"OH Trust", key:"oh_trust"},
    // {label:"Improvement", key:"improvement"},
    // {label:"Description", key:"description"},
]

const headers14=[
    {label:"Owner", key:"lead_owner"},
    {label:"Total", key:"total"},
    {label:"Talk Time", key:"talk_time"},
    {label:"Effective", key:"effective"},
    {label:"Score", key:"qs"},
    {label:"TL", key:"tl"},
]
  const { cuser, role, employeelist, destinationlist, loading } = GetRole();
  const [value, setValue] = useState(0);
  const [searchData, setsearchData] = useState([{}]);
  const [searchData2, setsearchData2] = useState([{}]);
  const [searchData3, setsearchData3] = useState([{}]);
  const [searchData4, setsearchData4] = useState([{}]);
  const [searchData5, setsearchData5] = useState([{}]);
  const [searchData6, setsearchData6] = useState([{}]);
  const [searchData7, setsearchData7] = useState([{}]);
  const [searchData8, setsearchData8] = useState([{}]);
  const [searchData14, setsearchData14] = useState([{}]);
  const [custData, setcustData] = useState([{}]);
  const [commentdata, setcommentdata] = useState([{}]);
  const [quoteData, setquoteData] = useState([{}]);
  const [quoteeditData, setquoteeditData] = useState([{}]);
  const [fupData, setfupData] = useState([{}]);
  var [fupData11, setfupData11] = useState([{}]);
  const [ssfilter, setssfilter] = useState(false);
  const [leadData, setleadData] = useState([
    {
      lead_name: "",
      mobile_number: 0,
      email_id: "",
      lead_status: "",
      lead_campaign: "",
      lead_platform: "",
      lead_destination: "",
      lead_pax: "",
      lead_travel_date: "",
      lead_travel_date_decided: "",
      lead_id: 0,
      lead_owner: "",
      canc_reason_notes: "",
      work_complete: false,
    },
  ]);
  const [dest, setdest] = useState([]);
  const [open7, setopen7] = useState(false);
  const [showsupport, setshowsupport] = useState(false);
  const [showattempted, setshowattempted] = useState(false);
  const [showauditdate, setshowauditdate] = useState(false);
  const [showfupaudit, setshowfupaudit] = useState(false);
  const [drawer, setdrawer] = useState(false);
  const [splist, setsplist] = useState([]);
  const [splist2, setsplist2] = useState([]);
  const [splist3, setsplist3] = useState([]);
  const [splist4, setsplist4] = useState([]);
  const [channelData, setchannelData] = useState([]);
  const [destData, setdestData] = useState([]);
  const [destData2, setdestData2] = useState([]);
  const [destData3, setdestData3] = useState([]);
  const [loadfunnel, setloadfunnel] = useState(false);
  const [createdleadData, setcreatedleadData] = useState([]);
  const [triparr, settriparr] = useState([]);
  const [leadarr, setleadarr] = useState([]);
  const [hotleadData, sethotleadData] = useState([]);
  const [cancleadData, setcancleadData] = useState([]);
  const [convleadData, setconvleadData] = useState([]);
  const [potentialleadData, setpotentialleadData] = useState([]);
  const [boleadData, setboleadData] = useState([]);
  const [listupdatedtripData, setlistupdatedtripData] = useState([]);
  const [listupdatedleadData, setlistupdatedleadData] = useState([]);
  const [calldatatrips, setcalldatatrips] = useState([]);
  const [calldatatrips2, setcalldatatrips2] = useState([]);
  const [calldatatrips4, setcalldatatrips4] = useState([]);
  const [calldataleads, setcalldataleads] = useState([]);
  const [calldataleads2, setcalldataleads2] = useState([]);
  const [calldataleads3, setcalldataleads3] = useState([]);
   const [calldataleads4, setcalldataleads4] = useState([]);
  const [totalleads, settotalleads] = useState([]);
  const [listtripData, setlisttripData] = useState([
    {
      start_date_undecided: "No",

      primary_destination: "",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "",
      createdAt: "",
      trip_owner: "",
      follow_up: [
        {
          status: "Open",
          notes: "",
        },
      ],
    },
  ]);
  const [listtrip2Data, setlisttrip2Data] = useState([
    {
      start_date_undecided: "No",

      primary_destination: "",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "",
      createdAt: "",
      trip_owner: "",
      follow_up: [
        {
          status: "Open",
          notes: "",
        },
      ],
    },
  ]);
  var [listtripData3, setlisttripData3] = useState([
    {
      start_date_undecided: "No",

      primary_destination: "",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "",
      createdAt: "",
      trip_owner: "",
      follow_up: [
        {
          status: "Open",
          notes: "",
        },
      ],
    },
  ]);
  var [quoteData2, setquoteData2] = useState([{}]);
  var [quoteeditData2, setquoteeditData2] = useState([{}]);

  const [listconvtripData, setlistconvtripData] = useState([
    {
      start_date_undecided: "No",

      primary_destination: "",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "",
      createdAt: "",
      trip_owner: "",
      follow_up: [
        {
          status: "Open",
          notes: "",
        },
      ],
    },
  ]);
  const [listclosedtripData, setlistclosedtripData] = useState([
    {
      start_date_undecided: "No",

      primary_destination: "",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "",
      createdAt: "",
      trip_owner: "",
      follow_up: [
        {
          status: "Open",
          notes: "",
        },
      ],
    },
  ]);
  const [listtodaytripData, setlisttodaytripData] = useState([
    {
      start_date_undecided: "No",

      primary_destination: "",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "",
      createdAt: "",
      trip_owner: "",
      follow_up: [
        {
          status: "Open",
          notes: "",
        },
      ],
    },
  ]);

  const [funnelData, setfunnelData] = useState([
    {
      start_date_undecided: "No",

      primary_destination: "",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "",
      createdAt: "",
      trip_owner: "",
      follow_up: [
        {
          status: "Open",
          notes: "",
        },
      ],
    },
  ]);

  const [listtodayconvtripData, setlisttodayconvtripData] = useState([
    {
      start_date_undecided: "No",

      primary_destination: "",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "",
      createdAt: "",
      trip_owner: "",
      follow_up: [
        {
          status: "Open",
          notes: "",
        },
      ],
    },
  ]);
  const [listtodaypostponedtripData, setlisttodaypostponedtripData] = useState([
    {
      start_date_undecided: "No",

      primary_destination: "",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "",
      createdAt: "",
      trip_owner: "",
      follow_up: [
        {
          status: "Open",
          notes: "",
        },
      ],
    },
  ]);
  const [listtodaycanctripData, setlisttodaycanctripData] = useState([
    {
      start_date_undecided: "No",

      primary_destination: "",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "",
      createdAt: "",
      trip_owner: "",
      follow_up: [
        {
          status: "Open",
          notes: "",
        },
      ],
    },
  ]);
  const [listtodayhottripData, setlisttodayhottripData] = useState([
    {
      start_date_undecided: "No",

      primary_destination: "",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "",
      createdAt: "",
      trip_owner: "",
      follow_up: [
        {
          status: "Open",
          notes: "",
        },
      ],
    },
  ]);
  const [listhottripData, setlisthottripData] = useState([
    {
      start_date_undecided: "No",

      primary_destination: "",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "",
      createdAt: "",
      trip_owner: "",
      follow_up: [
        {
          status: "Open",
          notes: "",
        },
      ],
    },
  ]);
//const { appData, loading } = useAppData();
 // var { cuser, role } = GetRole();
  const getDest = async () => {
    try{
    const data = await fetchDest();
    const temp=data.data.filter(d=>"order" in d)
    setdest(temp[0].dest);
  }catch(err){
    console.log(err)
  }
  }
  //
  const getEmployees = async () => {
    try{
    var data=[]
    if(value==0){
      data = await fetchEmployees();
    }else if(value==1){
      data = await fetchTeambyName("Sidharth");
    }else if(value==2){
      data = await fetchTeambyName("Hitesh");
    }else if(value==3){
      data = await fetchTeambyName("Yadvinder");
    }else if(value==4){
      data = await fetchTeambyName("Tulsi");
    }else if(value==5){
      data = await fetchTeambyName("Tarun");
    }else if(value==6){
      data = await fetchTeambyName("NitinK");
    }else if(value==7){
      data = await fetchTeambyName("Manish");
    }else if(value==8){
      data = await fetchTeambyName("Qausain");
    }
    const empsplist = data.data.filter((emp) => emp.role == "Sales" || emp.role == "SME");
    const empsplist4 = data.data.filter((emp) => emp.role == "Sales Support");
    const empsplist2 = data.data.filter((emp) => emp.role == "Sales" || emp.role == "TL" || emp.role == "SME");
    var empshortname = empsplist.map((emp) => emp.short_name);
    var empshortname2 = empsplist2.map((emp) => emp.short_name);
    var empshortname3 = data.data.map((emp) => emp.short_name);
    var empshortname4 = empsplist4.map((emp) => emp.short_name);
    if(empshortname.length==0){
      empshortname=["Amit"]
    }
    let sortedemp = empshortname.sort()
    setsplist3(empshortname3);
    setsplist(sortedemp);
    setsplist2(empshortname2);
    setsplist4(empshortname4);
  }catch(err){
    console.log(err)
  }
  };
  //console.log(splist)
  const getEmployeesTL = async () => {
    try{
    const data = await fetchTeambyName(cuser);
    //const custdatalistfromdb= data.data
    const empsplist = data.data.filter((emp) => emp.role == "Sales" || emp.role == "TL" || emp.role == "SME");
    //const empsplist = data.data.filter((emp) => emp.role == "Sales" || emp.role == "TL");
    const empshortname = empsplist.map((emp) => emp.short_name);
    setsplist(empshortname);
  }catch(err){
    console.log(err)
  }
  };

  useEffect(() => {
    if(!loading){
    getDest()
    // if (role == "TL") {
    //   getEmployeesTL();
    // } else if (role == "Sales") {
    //   getEmployees();
    // } else if (role == "Admin" || role == "Support") {
    //   getEmployees();
    // }
    if (role == "Sales" || role == "SME") {
      getEmployees()
    } else if (role == "Admin" || role == "Support" || role=="Marketing" || role=="Manager" || role=="TL" || role=="Operations" || role=="Operations-TL" || role=="Product") {
      getEmployees()
    }
  }
  }, [cuser, role, employeelist, destinationlist, loading]);

  //console.log(splist)

  const handleSearch = async (e) => {
    try{
    //console.log(searchData.start_date)
    if (searchData.start_date && searchData.end_date) {
      const data = await searchTripsbyDate(
        searchData.start_date,
        searchData.end_date
      );
      setlisttripData(data.data);
      const data2 = await searchLeadsbyDate(
        searchData.start_date,
        searchData.end_date
      );
      setcreatedleadData(data2.data);
      const data3 = await searchconvTripsbyDate(
        searchData.start_date,
        searchData.end_date
      );
      setconvleadData(data3.data);
      const data4 = await searchboTripsbyDate(
        searchData.start_date,
        searchData.end_date
      );
      setboleadData(data4.data);
      const data5 = await searchcancTripsbyDate(
        searchData.start_date,
        searchData.end_date
      );
      //console.log(data5.data)
      setcancleadData(data5.data);
      const data6 = await searchhotTripsbyDate(
        searchData.start_date,
        searchData.end_date
      );
      sethotleadData(data6.data);
      const data7 = await searchpotentialTripsbyDate(
        searchData.start_date,
        searchData.end_date
      );
      setpotentialleadData(data7.data);

      
     
    } else {
      alert(
        "Please enter all parameters -start date and end date before search"
      );
    }
  }catch(err){
    console.log(err)
  }
  };

  const handleconvSearch = async (e) => {
    try{
    if (searchData2.start_date && searchData2.end_date) {
      const data = await searchconvTripsbyDate(
        searchData2.start_date,
        searchData2.end_date
      );
      setlistconvtripData(data.data);
      const data2 = await searchTripsbyDate(
        searchData2.start_date,
        searchData2.end_date
      );

      setlisttrip2Data(data2.data);

      console.log(data.data);
    } else {
      alert(
        "Please enter all parameters -start date and end date before search"
      );
    }
  }catch(err){
    console.log(err)
  }
  };

  const handleclosedSearch = async (e) => {
    try{
    if (searchData3.start_date && searchData3.end_date) {
      const data = await searchclosedTripsbyDate(
        searchData3.start_date,
        searchData3.end_date
      );
      setlistclosedtripData(data.data);

      // console.log(data.data)
    } else {
      alert(
        "Please enter all parameters -start date and end date before search"
      );
    }
  }catch(err){
    console.log(err)
  }
  };

  const handlehotSearch = async (e) => {
    try{
    if (searchData4.start_date && searchData4.end_date) {
      const data = await searchhotTripsbyDate(
        searchData4.start_date,
        searchData4.end_date
      );
      setlisthottripData(data.data);

      //console.log(data.data)
    } else {
      alert(
        "Please enter all parameters -start date and end date before search"
      );
    }
  }catch(err){
    console.log(err)
  }
  };

  const handlefunnelSearch = async (e) => {
    try{
    // if (role == "TL") {
    //   //console.log("ABC")
    //   const data = await fetchActiveTripsTL(cuser);

    //   setfunnelData(data.data);
    //   const data2 = await fetchtodayassignedleadsTL(cuser);
    //   setleadData(data2.data);
    //   const data3 = await fetchtodaycustTL(cuser);
    //   setcustData(data3.data);
    //   const data4 = await fetchtodaytripsTL(cuser);
    //   setlisttodaytripData(data4.data);
    //   const data5 = await fetchtodayquotesTL(cuser);
    //   setquoteData(data5.data);
    //   const data6 = await fetchtodayeditquotesTL(cuser);
    //   setquoteeditData(data6.data);
    //   const data7 = await fetchtodayconvtripsTL(cuser);
    //   setlisttodayconvtripData(data7.data);
    //   const data8 = await fetchtodaycanctripsTL(cuser);
    //   setlisttodaycanctripData(data8.data);
    //   const data9 = await fetchtodayhottripsTL(cuser);
    //   setlisttodayhottripData(data9.data);
    //   const data10 = await fetchtodayfupTL(cuser);
    //   setfupData(data10.data);
    //   const data11 = await fetchtodaypostponedtripsTL(cuser);
    //   setlisttodaypostponedtripData(data11.data);
    // } else {
      const data = await fetchActiveTrips();

      setfunnelData(data.data);
      const data2 = await fetchtodayassignedleads();
      setleadData(data2.data);
      const data3 = await fetchtodaycust();
      setcustData(data3.data);
      const data4 = await fetchtodaytrips();
      setlisttodaytripData(data4.data);
      const data5 = await fetchtodayquotes();
      setquoteData(data5.data);
      const data6 = await fetchtodayeditquotes();
      setquoteeditData(data6.data);
      const data7 = await fetchtodayconvtrips();
      setlisttodayconvtripData(data7.data);
      const data8 = await fetchtodaycanctrips();
      setlisttodaycanctripData(data8.data);
      //console.log(data8.data)
      const data9 = await fetchtodayhottrips();
      setlisttodayhottripData(data9.data);
      //console.log(data9.data)
      const data10 = await fetchtodayfup();
      setfupData(data10.data);
      const data11 = await fetchtodaypostponedtrips();
      setlisttodaypostponedtripData(data11.data);
      console.log(data11.data)
      let sd=new Date(DateCalc(-1))
      let ed=new Date(DateCalc(0))
      const data12 = await fetchtripcallbydate(sd, ed)
      setlistupdatedtripData(data12.data);
      const data13 = await fetchleadcallbydate(sd, ed)
      setlistupdatedleadData(data13.data);
      
      
      //console.log(data6.data.filter(quote=>quote.trip_owner=="Aakansha"))
    }catch(err){
      console.log(err)
    }
    //console.log()
  };

  const newhandlefunnelSearch = async (e) => {
    try{
    // if (role == "TL") {
    //   //console.log("ABC")
    //   const data = await fetchActiveTripsTL(cuser);

    //   setfunnelData(data.data);
    //   const data2 = await fetchtodayassignedleadsTL(cuser);
    //   setleadData(data2.data);
    //   const data3 = await fetchtodaycustTL(cuser);
    //   setcustData(data3.data);
    //   const data4 = await fetchtodaytripsTL(cuser);
    //   setlisttodaytripData(data4.data);
    //   const data5 = await fetchtodayquotesTL(cuser);
    //   setquoteData(data5.data);
    //   const data6 = await fetchtodayeditquotesTL(cuser);
    //   setquoteeditData(data6.data);
    //   const data7 = await fetchtodayconvtripsTL(cuser);
    //   setlisttodayconvtripData(data7.data);
    //   const data8 = await fetchtodaycanctripsTL(cuser);
    //   setlisttodaycanctripData(data8.data);
    //   const data9 = await fetchtodayhottripsTL(cuser);
    //   setlisttodayhottripData(data9.data);
    //   const data10 = await fetchtodayfupTL(cuser);
    //   setfupData(data10.data);
    //   const data11 = await fetchtodaypostponedtripsTL(cuser);
    //   setlisttodaypostponedtripData(data11.data);
    // } else {
      setloadfunnel(true)
      const data2 = await fetchtodayassignedleads();
      //console.log(data2.data.filter(l=>l.lead_owner=="Bipin"))
      setleadData(data2.data);
      const data3 = await fetchtodaycust();
      setcustData(data3.data);
      const data4 = await fetchtodaytrips();
      setlisttodaytripData(data4.data);
      const data5 = await fetchtodayquotes();
      setquoteData(data5.data);
      const data6 = await fetchtodayeditquotes();
      setquoteeditData(data6.data);
      const data7 = await fetchtodayconvtrips();
      setlisttodayconvtripData(data7.data);
      const data8 = await fetchtodaycanctrips();
      setlisttodaycanctripData(data8.data);
      const data9 = await fetchtodayhottrips();
      setlisttodayhottripData(data9.data);
      const data10 = await fetchtodayfup();
      setfupData(data10.data);
      const data11 = await fetchtodaypostponedtrips();
      setlisttodaypostponedtripData(data11.data);
      const data14 = await fetchworkfalseleads();
      settotalleads(data14.data);
      let sd=new Date(DateCalc(-1))
      let ed=new Date(DateCalc(0))
      const data12 = await fetchtripcallbydate(sd, ed)
      setlistupdatedtripData(data12.data);
      const data13 = await fetchleadcallbydate(sd, ed)
      setlistupdatedleadData(data13.data);
      //console.log(data12.data)
      //console.log(data6.data.filter(quote=>quote.trip_owner=="Aakansha"))
    }catch(err){
      console.log(err)
    }
    //console.log()
  };
  const newhandlefunnelSearch1 = async (e) => {
    try{
      //console.log("ABC")
      setloadfunnel(true)
      const data2 = await fetchtodayassignedleadsTL("Sidharth");
      setleadData(data2.data);
      const data3 = await fetchtodaycustTL("Sidharth");
      setcustData(data3.data);
      const data4 = await fetchtodaytripsTL("Sidharth");
      setlisttodaytripData(data4.data);
      const data5 = await fetchtodayquotesTL("Sidharth");
      setquoteData(data5.data);
      const data6 = await fetchtodayeditquotesTL("Sidharth");
      setquoteeditData(data6.data);
      const data7 = await fetchtodayconvtripsTL("Sidharth");
      setlisttodayconvtripData(data7.data);
      const data8 = await fetchtodaycanctripsTL("Sidharth");
      setlisttodaycanctripData(data8.data);
      const data9 = await fetchtodayhottripsTL("Sidharth");
      setlisttodayhottripData(data9.data);
      const data10 = await fetchtodayfupTL("Sidharth");
      setfupData(data10.data);
      const data11 = await fetchtodaypostponedtripsTL("Sidharth");
      setlisttodaypostponedtripData(data11.data);
      let sd=new Date(DateCalc(-1))
      let ed=new Date(DateCalc(0))
      const data12 = await fetchtripcallbydate(sd, ed, "Sidharth")
      setlistupdatedtripData(data12.data);
      const data13 = await fetchleadcallbydate(sd, ed, "Sidharth")
      setlistupdatedleadData(data13.data);
     
    
    }catch(err){
      console.log(err)
    }
    //console.log()
  };
  const newhandlefunnelSearch2 = async (e) => {
    try{
    //console.log("ABC")
    setloadfunnel(true)
    const data2 = await fetchtodayassignedleadsTL("Hitesh");
    setleadData(data2.data);
    const data3 = await fetchtodaycustTL("Hitesh");
    setcustData(data3.data);
    const data4 = await fetchtodaytripsTL("Hitesh");
    setlisttodaytripData(data4.data);
    const data5 = await fetchtodayquotesTL("Hitesh");
    setquoteData(data5.data);
    const data6 = await fetchtodayeditquotesTL("Hitesh");
    setquoteeditData(data6.data);
    const data7 = await fetchtodayconvtripsTL("Hitesh");
    setlisttodayconvtripData(data7.data);
    const data8 = await fetchtodaycanctripsTL("Hitesh");
    setlisttodaycanctripData(data8.data);
    const data9 = await fetchtodayhottripsTL("Hitesh");
    setlisttodayhottripData(data9.data);
    const data10 = await fetchtodayfupTL("Hitesh");
    setfupData(data10.data);
    const data11 = await fetchtodaypostponedtripsTL("Hitesh");
    setlisttodaypostponedtripData(data11.data);
    let sd=new Date(DateCalc(-1))
      let ed=new Date(DateCalc(0))
      const data12 = await fetchtripcallbydate(sd, ed, "Hitesh")
      setlistupdatedtripData(data12.data);
      const data13 = await fetchleadcallbydate(sd, ed, "Hitesh")
      setlistupdatedleadData(data13.data);
  }catch(err){
    console.log(err)
  }

  //console.log()
};

const newhandlefunnelSearch5 = async (e) => {
  try{
  //console.log("ABC")
  setloadfunnel(true)
  const data2 = await fetchtodayassignedleadsTL("Tarun");
  setleadData(data2.data);
  const data3 = await fetchtodaycustTL("Tarun");
  setcustData(data3.data);
  const data4 = await fetchtodaytripsTL("Tarun");
  setlisttodaytripData(data4.data);
  const data5 = await fetchtodayquotesTL("Tarun");
  setquoteData(data5.data);
  const data6 = await fetchtodayeditquotesTL("Tarun");
  setquoteeditData(data6.data);
  const data7 = await fetchtodayconvtripsTL("Tarun");
  setlisttodayconvtripData(data7.data);
  const data8 = await fetchtodaycanctripsTL("Tarun");
  setlisttodaycanctripData(data8.data);
  const data9 = await fetchtodayhottripsTL("Tarun");
  setlisttodayhottripData(data9.data);
  const data10 = await fetchtodayfupTL("Tarun");
  setfupData(data10.data);
  const data11 = await fetchtodaypostponedtripsTL("Tarun");
  setlisttodaypostponedtripData(data11.data);
  let sd=new Date(DateCalc(-1))
    let ed=new Date(DateCalc(0))
    const data12 = await fetchtripcallbydate(sd, ed, "Tarun")
    setlistupdatedtripData(data12.data);
    const data13 = await fetchleadcallbydate(sd, ed, "Tarun")
    setlistupdatedleadData(data13.data);
}catch(err){
  console.log(err)
}

//console.log()
};

const newhandlefunnelSearch7 = async (e) => {
  try{
  //console.log("ABC")
  setloadfunnel(true)
  const data2 = await fetchtodayassignedleadsTL("Manish");
  setleadData(data2.data);
  const data3 = await fetchtodaycustTL("Manish");
  setcustData(data3.data);
  const data4 = await fetchtodaytripsTL("Manish");
  setlisttodaytripData(data4.data);
  const data5 = await fetchtodayquotesTL("Manish");
  setquoteData(data5.data);
  const data6 = await fetchtodayeditquotesTL("Manish");
  setquoteeditData(data6.data);
  const data7 = await fetchtodayconvtripsTL("Manish");
  setlisttodayconvtripData(data7.data);
  const data8 = await fetchtodaycanctripsTL("Manish");
  setlisttodaycanctripData(data8.data);
  const data9 = await fetchtodayhottripsTL("Manish");
  setlisttodayhottripData(data9.data);
  const data10 = await fetchtodayfupTL("Manish");
  setfupData(data10.data);
  const data11 = await fetchtodaypostponedtripsTL("Manish");
  setlisttodaypostponedtripData(data11.data);
  let sd=new Date(DateCalc(-1))
    let ed=new Date(DateCalc(0))
    const data12 = await fetchtripcallbydate(sd, ed, "Manish")
    setlistupdatedtripData(data12.data);
    const data13 = await fetchleadcallbydate(sd, ed, "Manish")
    setlistupdatedleadData(data13.data);
}catch(err){
  console.log(err)
}

//console.log()
};

const newhandlefunnelSearch8 = async (e) => {
  try{
  //console.log("ABC")
  setloadfunnel(true)
  const data2 = await fetchtodayassignedleadsTL("Qausain");
  setleadData(data2.data);
  const data3 = await fetchtodaycustTL("Qausain");
  setcustData(data3.data);
  const data4 = await fetchtodaytripsTL("Qausain");
  setlisttodaytripData(data4.data);
  const data5 = await fetchtodayquotesTL("Qausain");
  setquoteData(data5.data);
  const data6 = await fetchtodayeditquotesTL("Qausain");
  setquoteeditData(data6.data);
  const data7 = await fetchtodayconvtripsTL("Qausain");
  setlisttodayconvtripData(data7.data);
  const data8 = await fetchtodaycanctripsTL("Qausain");
  setlisttodaycanctripData(data8.data);
  const data9 = await fetchtodayhottripsTL("Qausain");
  setlisttodayhottripData(data9.data);
  const data10 = await fetchtodayfupTL("Qausain");
  setfupData(data10.data);
  const data11 = await fetchtodaypostponedtripsTL("Qausain");
  setlisttodaypostponedtripData(data11.data);
  let sd=new Date(DateCalc(-1))
    let ed=new Date(DateCalc(0))
    const data12 = await fetchtripcallbydate(sd, ed, "Qausain")
    setlistupdatedtripData(data12.data);
    const data13 = await fetchleadcallbydate(sd, ed, "Qausain")
    setlistupdatedleadData(data13.data);
}catch(err){
  console.log(err)
}

//console.log()
};
const newhandlefunnelSearch3 = async (e) => {
  try{
  //console.log("ABC")
  setloadfunnel(true)
  const data2 = await fetchtodayassignedleadsTL("Yadvinder");
  setleadData(data2.data);
  const data3 = await fetchtodaycustTL("Yadvinder");
  setcustData(data3.data);
  const data4 = await fetchtodaytripsTL("Yadvinder");
  setlisttodaytripData(data4.data);
  const data5 = await fetchtodayquotesTL("Yadvinder");
  setquoteData(data5.data);
  const data6 = await fetchtodayeditquotesTL("Yadvinder");
  setquoteeditData(data6.data);
  const data7 = await fetchtodayconvtripsTL("Yadvinder");
  setlisttodayconvtripData(data7.data);
  const data8 = await fetchtodaycanctripsTL("Yadvinder");
  setlisttodaycanctripData(data8.data);
  const data9 = await fetchtodayhottripsTL("Yadvinder");
  setlisttodayhottripData(data9.data);
  const data10 = await fetchtodayfupTL("Yadvinder");
  setfupData(data10.data);
  const data11 = await fetchtodaypostponedtripsTL("Yadvinder");
  setlisttodaypostponedtripData(data11.data);
  let sd=new Date(DateCalc(-1))
    let ed=new Date(DateCalc(0))
    const data12 = await fetchtripcallbydate(sd, ed, "Yadvinder")
    setlistupdatedtripData(data12.data);
    const data13 = await fetchleadcallbydate(sd, ed, "Yadvinder")
    setlistupdatedleadData(data13.data);
}catch(err){
  console.log(err)
}

//console.log()
};

const newhandlefunnelSearch4 = async (e) => {
  try{
  //console.log("ABC")
  setloadfunnel(true)
  const data2 = await fetchtodayassignedleadsTL("Tulsi");
  setleadData(data2.data);
  const data3 = await fetchtodaycustTL("Tulsi");
  setcustData(data3.data);
  const data4 = await fetchtodaytripsTL("Tulsi");
  setlisttodaytripData(data4.data);
  const data5 = await fetchtodayquotesTL("Tulsi");
  setquoteData(data5.data);
  const data6 = await fetchtodayeditquotesTL("Tulsi");
  setquoteeditData(data6.data);
  const data7 = await fetchtodayconvtripsTL("Tulsi");
  setlisttodayconvtripData(data7.data);
  const data8 = await fetchtodaycanctripsTL("Tulsi");
  setlisttodaycanctripData(data8.data);
  const data9 = await fetchtodayhottripsTL("Tulsi");
  setlisttodayhottripData(data9.data);
  const data10 = await fetchtodayfupTL("Tulsi");
  setfupData(data10.data);
  const data11 = await fetchtodaypostponedtripsTL("Tulsi");
  setlisttodaypostponedtripData(data11.data);
  let sd=new Date(DateCalc(-1))
    let ed=new Date(DateCalc(0))
    const data12 = await fetchtripcallbydate(sd, ed, "Tulsi")
    setlistupdatedtripData(data12.data);
    const data13 = await fetchleadcallbydate(sd, ed, "Tulsi")
    setlistupdatedleadData(data13.data);
}catch(err){
  console.log(err)
}

//console.log()
};

const newhandlefunnelSearch6 = async (e) => {
  try{
  //console.log("ABC")
  setloadfunnel(true)
  const data2 = await fetchtodayassignedleadsTL("NitinK");
  setleadData(data2.data);
  const data3 = await fetchtodaycustTL("NitinK");
  setcustData(data3.data);
  const data4 = await fetchtodaytripsTL("NitinK");
  setlisttodaytripData(data4.data);
  const data5 = await fetchtodayquotesTL("NitinK");
  setquoteData(data5.data);
  const data6 = await fetchtodayeditquotesTL("NitinK");
  setquoteeditData(data6.data);
  const data7 = await fetchtodayconvtripsTL("NitinK");
  setlisttodayconvtripData(data7.data);
  const data8 = await fetchtodaycanctripsTL("NitinK");
  setlisttodaycanctripData(data8.data);
  const data9 = await fetchtodayhottripsTL("NitinK");
  setlisttodayhottripData(data9.data);
  const data10 = await fetchtodayfupTL("NitinK");
  setfupData(data10.data);
  const data11 = await fetchtodaypostponedtripsTL("NitinK");
  setlisttodaypostponedtripData(data11.data);
  let sd=new Date(DateCalc(-1))
    let ed=new Date(DateCalc(0))
    const data12 = await fetchtripcallbydate(sd, ed, "NitinK")
    setlistupdatedtripData(data12.data);
    const data13 = await fetchleadcallbydate(sd, ed, "NitinK")
    setlistupdatedleadData(data13.data);
}catch(err){
  console.log(err)
}

//console.log()
};

  const handlefunnelSearch1 = async (e) => {
    try{
      //console.log("ABC")
      const data = await fetchActiveTripsTL("Sidharth");

      setfunnelData(data.data);
      const data2 = await fetchtodayassignedleadsTL("Sidharth");
      setleadData(data2.data);
      const data3 = await fetchtodaycustTL("Sidharth");
      setcustData(data3.data);
      const data4 = await fetchtodaytripsTL("Sidharth");
      setlisttodaytripData(data4.data);
      const data5 = await fetchtodayquotesTL("Sidharth");
      setquoteData(data5.data);
      const data6 = await fetchtodayeditquotesTL("Sidharth");
      setquoteeditData(data6.data);
      const data7 = await fetchtodayconvtripsTL("Sidharth");
      setlisttodayconvtripData(data7.data);
      const data8 = await fetchtodaycanctripsTL("Sidharth");
      setlisttodaycanctripData(data8.data);
      const data9 = await fetchtodayhottripsTL("Sidharth");
      setlisttodayhottripData(data9.data);
      const data10 = await fetchtodayfupTL("Sidharth");
      setfupData(data10.data);
      const data11 = await fetchtodaypostponedtripsTL("Sidharth");
      setlisttodaypostponedtripData(data11.data);
      let sd=new Date(DateCalc(-1))
      let ed=new Date(DateCalc(0))
      const data12 = await fetchtripcallbydate(sd, ed, "Sidharth")
      setlistupdatedtripData(data12.data);
      const data13 = await fetchleadcallbydate(sd, ed, "Sidharth")
      setlistupdatedleadData(data13.data);
    
    }catch(err){
      console.log(err)
    }
    //console.log()
  };
  const handlefunnelSearch2 = async (e) => {
    try{
    //console.log("ABC")
    const data = await fetchActiveTripsTL("Hitesh");

    setfunnelData(data.data);
    const data2 = await fetchtodayassignedleadsTL("Hitesh");
    setleadData(data2.data);
    const data3 = await fetchtodaycustTL("Hitesh");
    setcustData(data3.data);
    const data4 = await fetchtodaytripsTL("Hitesh");
    setlisttodaytripData(data4.data);
    const data5 = await fetchtodayquotesTL("Hitesh");
    setquoteData(data5.data);
    const data6 = await fetchtodayeditquotesTL("Hitesh");
    setquoteeditData(data6.data);
    const data7 = await fetchtodayconvtripsTL("Hitesh");
    setlisttodayconvtripData(data7.data);
    const data8 = await fetchtodaycanctripsTL("Hitesh");
    setlisttodaycanctripData(data8.data);
    const data9 = await fetchtodayhottripsTL("Hitesh");
    setlisttodayhottripData(data9.data);
    const data10 = await fetchtodayfupTL("Hitesh");
    setfupData(data10.data);
    const data11 = await fetchtodaypostponedtripsTL("Hitesh");
    setlisttodaypostponedtripData(data11.data);
    let sd=new Date(DateCalc(-1))
      let ed=new Date(DateCalc(0))
      const data12 = await fetchtripcallbydate(sd, ed, "Hitesh")
      setlistupdatedtripData(data12.data);
      const data13 = await fetchleadcallbydate(sd, ed, "Hitesh")
      setlistupdatedleadData(data13.data);
  }catch(err){
    console.log(err)
  }

  //console.log()
};

const handlefunnelSearch5 = async (e) => {
  try{
  //console.log("ABC")
  const data = await fetchActiveTripsTL("Tarun");

  setfunnelData(data.data);
  const data2 = await fetchtodayassignedleadsTL("Tarun");
  setleadData(data2.data);
  const data3 = await fetchtodaycustTL("Tarun");
  setcustData(data3.data);
  const data4 = await fetchtodaytripsTL("Tarun");
  setlisttodaytripData(data4.data);
  const data5 = await fetchtodayquotesTL("Tarun");
  setquoteData(data5.data);
  const data6 = await fetchtodayeditquotesTL("Tarun");
  setquoteeditData(data6.data);
  const data7 = await fetchtodayconvtripsTL("Tarun");
  setlisttodayconvtripData(data7.data);
  const data8 = await fetchtodaycanctripsTL("Tarun");
  setlisttodaycanctripData(data8.data);
  const data9 = await fetchtodayhottripsTL("Tarun");
  setlisttodayhottripData(data9.data);
  const data10 = await fetchtodayfupTL("Tarun");
  setfupData(data10.data);
  const data11 = await fetchtodaypostponedtripsTL("Tarun");
  setlisttodaypostponedtripData(data11.data);
  let sd=new Date(DateCalc(-1))
    let ed=new Date(DateCalc(0))
    const data12 = await fetchtripcallbydate(sd, ed, "Tarun")
    setlistupdatedtripData(data12.data);
    const data13 = await fetchleadcallbydate(sd, ed, "Tarun")
    setlistupdatedleadData(data13.data);
}catch(err){
  console.log(err)
}

//console.log()
};

const handlefunnelSearch3 = async (e) => {
  try{
  //console.log("ABC")
  const data = await fetchActiveTripsTL("Yadvinder");

  setfunnelData(data.data);
  const data2 = await fetchtodayassignedleadsTL("Yadvinder");
  setleadData(data2.data);
  const data3 = await fetchtodaycustTL("Yadvinder");
  setcustData(data3.data);
  const data4 = await fetchtodaytripsTL("Yadvinder");
  setlisttodaytripData(data4.data);
  const data5 = await fetchtodayquotesTL("Yadvinder");
  setquoteData(data5.data);
  const data6 = await fetchtodayeditquotesTL("Yadvinder");
  setquoteeditData(data6.data);
  const data7 = await fetchtodayconvtripsTL("Yadvinder");
  setlisttodayconvtripData(data7.data);
  const data8 = await fetchtodaycanctripsTL("Yadvinder");
  setlisttodaycanctripData(data8.data);
  const data9 = await fetchtodayhottripsTL("Yadvinder");
  setlisttodayhottripData(data9.data);
  const data10 = await fetchtodayfupTL("Yadvinder");
  setfupData(data10.data);
  const data11 = await fetchtodaypostponedtripsTL("Yadvinder");
  setlisttodaypostponedtripData(data11.data);
  let sd=new Date(DateCalc(-1))
    let ed=new Date(DateCalc(0))
    const data12 = await fetchtripcallbydate(sd, ed, "Yadvinder")
    setlistupdatedtripData(data12.data);
    const data13 = await fetchleadcallbydate(sd, ed, "Yadvinder")
    setlistupdatedleadData(data13.data);
}catch(err){
  console.log(err)
}

//console.log()
};

const handlefunnelSearch4 = async (e) => {
  try{
  //console.log("ABC")
  const data = await fetchActiveTripsTL("Tulsi");

  setfunnelData(data.data);
  const data2 = await fetchtodayassignedleadsTL("Tulsi");
  setleadData(data2.data);
  const data3 = await fetchtodaycustTL("Tulsi");
  setcustData(data3.data);
  const data4 = await fetchtodaytripsTL("Tulsi");
  setlisttodaytripData(data4.data);
  const data5 = await fetchtodayquotesTL("Tulsi");
  setquoteData(data5.data);
  const data6 = await fetchtodayeditquotesTL("Tulsi");
  setquoteeditData(data6.data);
  const data7 = await fetchtodayconvtripsTL("Tulsi");
  setlisttodayconvtripData(data7.data);
  const data8 = await fetchtodaycanctripsTL("Tulsi");
  setlisttodaycanctripData(data8.data);
  const data9 = await fetchtodayhottripsTL("Tulsi");
  setlisttodayhottripData(data9.data);
  const data10 = await fetchtodayfupTL("Tulsi");
  setfupData(data10.data);
  const data11 = await fetchtodaypostponedtripsTL("Tulsi");
  setlisttodaypostponedtripData(data11.data);
  let sd=new Date(DateCalc(-1))
    let ed=new Date(DateCalc(0))
    const data12 = await fetchtripcallbydate(sd, ed, "Tulsi")
    setlistupdatedtripData(data12.data);
    const data13 = await fetchleadcallbydate(sd, ed, "Tulsi")
    setlistupdatedleadData(data13.data);
}catch(err){
  console.log(err)
}

//console.log()
};

const handlefunnelSearch8 = async (e) => {
  try{
  //console.log("ABC")
  const data = await fetchActiveTripsTL("Qausain");

  setfunnelData(data.data);
  const data2 = await fetchtodayassignedleadsTL("Qausain");
  setleadData(data2.data);
  const data3 = await fetchtodaycustTL("Qausain");
  setcustData(data3.data);
  const data4 = await fetchtodaytripsTL("Qausain");
  setlisttodaytripData(data4.data);
  const data5 = await fetchtodayquotesTL("Qausain");
  setquoteData(data5.data);
  const data6 = await fetchtodayeditquotesTL("Qausain");
  setquoteeditData(data6.data);
  const data7 = await fetchtodayconvtripsTL("Qausain");
  setlisttodayconvtripData(data7.data);
  const data8 = await fetchtodaycanctripsTL("Qausain");
  setlisttodaycanctripData(data8.data);
  const data9 = await fetchtodayhottripsTL("Qausain");
  setlisttodayhottripData(data9.data);
  const data10 = await fetchtodayfupTL("Qausain");
  setfupData(data10.data);
  const data11 = await fetchtodaypostponedtripsTL("Qausain");
  setlisttodaypostponedtripData(data11.data);
  let sd=new Date(DateCalc(-1))
    let ed=new Date(DateCalc(0))
    const data12 = await fetchtripcallbydate(sd, ed, "Qausain")
    setlistupdatedtripData(data12.data);
    const data13 = await fetchleadcallbydate(sd, ed, "Qausain")
    setlistupdatedleadData(data13.data);
}catch(err){
  console.log(err)
}

//console.log()
};

const handlefunnelSearch6 = async (e) => {
  try{
  //console.log("ABC")
  const data = await fetchActiveTripsTL("NitinK");

  setfunnelData(data.data);
  const data2 = await fetchtodayassignedleadsTL("NitinK");
  setleadData(data2.data);
  const data3 = await fetchtodaycustTL("NitinK");
  setcustData(data3.data);
  const data4 = await fetchtodaytripsTL("NitinK");
  setlisttodaytripData(data4.data);
  const data5 = await fetchtodayquotesTL("NitinK");
  setquoteData(data5.data);
  const data6 = await fetchtodayeditquotesTL("NitinK");
  setquoteeditData(data6.data);
  const data7 = await fetchtodayconvtripsTL("NitinK");
  setlisttodayconvtripData(data7.data);
  const data8 = await fetchtodaycanctripsTL("NitinK");
  setlisttodaycanctripData(data8.data);
  const data9 = await fetchtodayhottripsTL("NitinK");
  setlisttodayhottripData(data9.data);
  const data10 = await fetchtodayfupTL("NitinK");
  setfupData(data10.data);
  const data11 = await fetchtodaypostponedtripsTL("NitinK");
  setlisttodaypostponedtripData(data11.data);
  let sd=new Date(DateCalc(-1))
    let ed=new Date(DateCalc(0))
    const data12 = await fetchtripcallbydate(sd, ed, "NitinK")
    setlistupdatedtripData(data12.data);
    const data13 = await fetchleadcallbydate(sd, ed, "NitinK")
    setlistupdatedleadData(data13.data);
}catch(err){
  console.log(err)
}

//console.log()
};

const handlefunnelSearch7 = async (e) => {
  try{
  //console.log("ABC")
  const data = await fetchActiveTripsTL("Manish");

  setfunnelData(data.data);
  const data2 = await fetchtodayassignedleadsTL("Manish");
  setleadData(data2.data);
  const data3 = await fetchtodaycustTL("Manish");
  setcustData(data3.data);
  const data4 = await fetchtodaytripsTL("Manish");
  setlisttodaytripData(data4.data);
  const data5 = await fetchtodayquotesTL("Manish");
  setquoteData(data5.data);
  const data6 = await fetchtodayeditquotesTL("Manish");
  setquoteeditData(data6.data);
  const data7 = await fetchtodayconvtripsTL("Manish");
  setlisttodayconvtripData(data7.data);
  const data8 = await fetchtodaycanctripsTL("Manish");
  setlisttodaycanctripData(data8.data);
  const data9 = await fetchtodayhottripsTL("Manish");
  setlisttodayhottripData(data9.data);
  const data10 = await fetchtodayfupTL("Manish");
  setfupData(data10.data);
  const data11 = await fetchtodaypostponedtripsTL("Manish");
  setlisttodaypostponedtripData(data11.data);
  let sd=new Date(DateCalc(-1))
    let ed=new Date(DateCalc(0))
    const data12 = await fetchtripcallbydate(sd, ed, "Manish")
    setlistupdatedtripData(data12.data);
    const data13 = await fetchleadcallbydate(sd, ed, "Manish")
    setlistupdatedleadData(data13.data);
}catch(err){
  console.log(err)
}

//console.log()
};

  const handleQESearch = async (e) => {
   try{
    if (searchData5.start_date && searchData5.end_date) {
      const data = await searchQCbyDate(
        searchData5.start_date,
        searchData5.end_date
      );
      setquoteData2(data.data);
      const data2 = await newsearchQEbyDate(
        searchData5.start_date,
        searchData5.end_date
      );
      setquoteeditData2(data2.data);
      const data3 = await searchTripsbyDate(
        searchData5.start_date,
        searchData5.end_date
      );
      setlisttripData3(data3.data);
      //console.log(data.data)
    } else {
      alert(
        "Please enter all parameters -start date and end date before search"
      );
    }    
  }catch(err){
    console.log(err)
  }
    //console.log()
  };
  const handlefupSearch = async (e) => {
   try{
    if (searchData6.start_date && searchData6.end_date) {
      const data = await fetchfupbydate(
        searchData6.start_date,
        searchData6.end_date
      );
      console.log(data.data)
      setfupData11(data.data);
      // const data2 = await fetchnrfupbydate(
      //   searchData6.start_date,
      //   searchData6.end_date
      // );
      // setfupData12(data2.data);
      
      //console.log(data.data)
    } else {
      alert(
        "Please enter all parameters -start date and end date before search"
      );
    }    
  }catch(err){
    console.log(err)
  }
    //console.log()
  };

  const handlecallSearch=async (e) =>{
    let sd=new Date(DateCalc2(searchData4.start_date, -1))
    let ed=new Date(DateCalc2(searchData4.end_date, -1))
    if(searchData8.type){
      if(searchData8.type=="Trip"){
        const data=await fetchtripcallbydate(sd, ed)
        setcalldatatrips(data.data)
        console.log(data.data.length)
      }else if(searchData8.type=="Lead"){
        const data2=await fetchleadcallbydate(sd, ed)
        setcalldataleads(data2.data)
        console.log(data2.data.length)
      }
    }else{
      const data=await fetchtripcallbydate(sd, ed)
      setcalldatatrips(data.data)
      const data2=await fetchleadcallbydate(sd, ed)
      setcalldataleads(data2.data)
      console.log(data.data.length)
      console.log(data2.data.length)
    }
    const commenteddata=await fetchcommentedbydate(searchData4.start_date, searchData4.end_date)
    console.log(commenteddata.data)
    var temp=removeDuplicates(commenteddata.data, "trip_id")
    setcommentdata(temp)
  }

  const handlecallSearch2=async (e) =>{
    let sd=new Date(DateCalc2(searchData4.start_date, -1))
    let ed=new Date(DateCalc2(searchData4.end_date, -1))
    if(showauditdate){
     const data2=await fetchleadcallbyauditdate(searchData4.start_date, searchData4.end_date)
      console.log(data2.data)
    setcalldataleads2(data2.data)
     const data3=await fetchtripcallbyauditdate(searchData4.start_date, searchData4.end_date)
      console.log(data3.data)
    setcalldatatrips2(data3.data)
    }else{
    const data2=await fetchleadcallbydate(sd, ed)
    // var temp=data2.data.filter(l=>"lead_owner_support" in l)
    //  console.log(data2.data)
    //  if(showsupport){
    //   setcalldataleads2(temp)
    // }else{
    setcalldataleads2(data2.data)
    //}
    const data=await fetchtripcallbydate(sd, ed)
    setcalldatatrips2(data.data)
    
    console.log(data.data)
    }
   
    //console.log(temp)
   
  }

    const handleauditcallSearch2=async (e) =>{
    let sd=new Date(DateCalc2(searchData14.start_date, -1))
    let ed=new Date(DateCalc2(searchData14.end_date, -1))
  
    const data2=await fetchauditleadcallbydate(sd, ed)
    setcalldataleads4(data2.data)
   //console.log(data2.data)
    const data=await fetchaudittripcallbydate2(sd, ed)
      setcalldatatrips4([...data2.data,...data.data])
    
    console.log([...data2.data,...data.data])
  }

  const handlecallSearch4=async (e) =>{
    let sd=new Date(DateCalc2(searchData4.start_date, -1))
    let ed=new Date(DateCalc2(searchData4.end_date, -1))
    if(showauditdate){
     const data2=await fetchtripcallbyauditdate(searchData4.start_date, searchData4.end_date)
      console.log(data2.data)
    setcalldatatrips2(data2.data)
    }else{
    const data=await fetchtripcallbydate(sd, ed)
    setcalldatatrips2(data.data)
    }
    //console.log(data2.data)
  }

  const handlecallSearch4b=async (e) =>{
    let sd=new Date(DateCalc2(searchData14.start_date, -1))
    let ed=new Date(DateCalc2(searchData14.end_date, -1))
    console.log(sd, ed)
    const data=await fetchaudittripcallbydate(sd, ed)
    console.log(data.data)
    setcalldatatrips4(data.data)
   
  }

  const handlecallSearch3=async (e) =>{
    // let sd=new Date(DateCalc2(searchData4.start_date, -1))
    // let ed=new Date(DateCalc2(searchData4.end_date, -1))
  
    const data2=await fetchworkdoneleadsbydate(searchData7.start_date, searchData7.end_date)
    setcalldataleads3(data2.data)
    console.log(data2.data)
    const data=await fetchtripcallbydate(searchData7.start_date, searchData7.end_date)
    setcalldatatrips2(data.data)
  }

  const getqs=(cr)=>{
    var ret=0
    //console.log(cr)
    if(cr.call_type=="FUP Call"){
      var obtainedscore=("opening_script" in cr && cr.opening_script?cr.opening_script:0)
      +("closing_script" in cr && cr.closing_script?cr.closing_script:0)
      +("interruption" in cr && cr.interruption?cr.interruption:0)
      +("rate_of_speech" in cr && cr.rate_of_speech?cr.rate_of_speech:0)
      +("tone" in cr && cr.tone?cr.tone:0)+("language" in cr && cr.language?cr.language:0)+("fillers" in cr && cr.fillers?cr.fillers:0)
      +("guidance" in cr && cr.guidance?cr.guidance:0)+("oh_trust" in cr && cr.oh_trust?cr.oh_trust:0)+("oh_permission" in cr && cr.oh_permission?cr.oh_permission:0)+("oh_price" in cr && cr.oh_price?cr.oh_price:0)+("oh_probing" in cr && cr.oh_probing?cr.oh_probing:0)+("oh_delay" in cr && cr.oh_delay?cr.oh_delay:0)+("closing" in cr && cr.closing?cr.closing:0)+("empathy" in cr && cr.empathy?cr.empathy:0)

    var totalscore=("opening_script" in cr && cr.opening_script!==null?5:0)+("closing_script" in cr && cr.closing_script!==null?5:0)
    +("interruption" in cr && cr.interruption!==null?3:0)+("rate_of_speech" in cr && cr.rate_of_speech!==null?3:0)+
    +("tone" in cr && cr.tone!==null?3:0)+("language" in cr && cr.language!==null?3:0)+("fillers" in cr && cr.fillers!==null?5:0)
    +("guidance" in cr && cr.guidance!==null?20:0)+("oh_trust" in cr && cr.oh_trust!==null?8:0)+("oh_probing" in cr && cr.oh_probing!==null?8:0)+("oh_permission" in cr && cr.oh_permission!==null?8:0)
    +("oh_price" in cr && cr.oh_price!==null?8:0)+("oh_delay" in cr && cr.oh_delay!==null?8:0)+("closing" in cr && cr.closing!==null?10:0)+("empathy" in cr && cr.empathy!==null?3:0)
     
       if(totalscore<30){
        ret=-100
       
       }else{
          ret=obtainedscore && totalscore?(obtainedscore/totalscore).toFixed(2):0
          
       }
      
 
    //return 0
    }else if(cr.call_type=="First Call"){
      var obtainedscore2=("opening_script" in cr && cr.opening_script?cr.opening_script:0)+("closing_script" in cr && cr.closing_script?cr.closing_script:0)
      +("interruption" in cr && cr.interruption?cr.interruption:0)+("rate_of_speech" in cr && cr.rate_of_speech?cr.rate_of_speech:0)
      +("personalization" in cr && cr.personalization?cr.personalization:0)+("tone" in cr && cr.tone?cr.tone:0)
      +("language" in cr && cr.language?cr.language:0)+("fillers" in cr && cr.fillers?cr.fillers:0)+("guidance" in cr && cr.guidance?cr.guidance:0)
      +("rapport" in cr && cr.rapport?cr.rapport:0)+("explanation" in cr && cr.explanation?cr.explanation:0)
      +("basic_information" in cr && cr.basic_information?cr.basic_information:0)+("sales_pitch" in cr && cr.sales_pitch?cr.sales_pitch:0)
      +("hold_script" in cr && cr.hold_script?cr.hold_script:0)+("empathy" in cr && cr.empathy?cr.empathy:0)
      +("active_listening" in cr && cr.active_listening?cr.active_listening:0)

      var totalscore2=100
      if(new Date(cr.start_stamp).getTime()>new Date("2026-06-01").getTime()){
        totalscore2=("opening_script" in cr && cr.opening_script!==null?4:0)+("closing_script" in cr && cr.closing_script!==null?3:0)
    +("interruption" in cr && cr.interruption!==null?3:0)+("rate_of_speech" in cr && cr.rate_of_speech!==null?2:0)+("personalization" in cr && cr.personalization!==null?3:0)
    +("tone" in cr && cr.tone!==null?3:0)+("language" in cr && cr.language!==null?3:0)+("fillers" in cr && cr.fillers!==null?6:0)+("guidance" in cr && cr.guidance!==null?15:0)
    +("rapport" in cr && cr.rapport!==null?17:0)+("explanation" in cr && cr.explanation!==null?10:0)+("basic_information" in cr && cr.basic_information!==null?10:0)
    +("sales_pitch" in cr && cr.sales_pitch!==null?5:0)+("hold_script" in cr && cr.hold_script!==null?3:0)+("empathy" in cr && cr.empathy!==null?6:0)
    +("active_listening" in cr && cr.active_listening!==null?7:0)
      }else{
    totalscore2=("opening_script" in cr && cr.opening_script!==null?4:0)+("closing_script" in cr && cr.closing_script!==null?3:0)
    +("interruption" in cr && cr.interruption!==null?3:0)+("rate_of_speech" in cr && cr.rate_of_speech!==null?2:0)+("personalization" in cr && cr.personalization!==null?3:0)
    +("tone" in cr && cr.tone!==null?3:0)+("language" in cr && cr.language!==null?3:0)+("fillers" in cr && cr.fillers!==null?6:0)+("guidance" in cr && cr.guidance!==null?20:0)
    +("rapport" in cr && cr.rapport!==null?7:0)+("explanation" in cr && cr.explanation!==null?10:0)+("basic_information" in cr && cr.basic_information!==null?10:0)
    +("sales_pitch" in cr && cr.sales_pitch!==null?10:0)+("hold_script" in cr && cr.hold_script!==null?3:0)+("empathy" in cr && cr.empathy!==null?6:0)
    +("active_listening" in cr && cr.active_listening!==null?7:0)
      }

    if(totalscore2<30){
        ret= -100
       
       }else{
          ret= obtainedscore2 && totalscore2?(obtainedscore2/totalscore2).toFixed(2):0
          
      }
  
    } 
    if(cr.outbound_sec=="310"){
      console.log(obtainedscore2,totalscore2)
      console.log(ret)
    }
      
      return ret
    
   
  }
  
  //console.log(quoteeditData);
  //-----------------------------------------dup check code-------------------------------------
  const handledupCheck = async (e) => {
    try{
    const data = await dupcustCheck();

    const data2 = await duptripCheck();

    // const data2b = await duptripnumberCheck();

    const data3 = await dupquoteCheck();

    const data4 = await duphotelCheck();

    const data5 = await dupleadCheck();

    const data6 = await dupcustnumberCheck();

    const data7 = await duptourCheck()

    alert(
      "Cust data:\n" +
        data.data.map((custData) => custData._id) +
        "\nTrip data:\n" +
        data2.data.map((tripData) => tripData._id) +
         "\nHotel data:\n" +
        data4.data.map((hotelData) => hotelData._id)+
        "\nTour data:\n" +
        data7.data.map((tourData) => tourData._id) +
        "\nQuote data:\n" +
        data3.data.map((quoteData) => quoteData._id) +
        "\nLead data:\n" +
        data5.data.map((leadData) => leadData._id) +
        "\nCust number data:\n" +
        data6.data.map((custData) => custData._id)
       
    );
  }catch(err){
    console.log(err)
  }
  };
  //---------------------------payment functions---------------------------------------------------
  // const total = (cpdata) => {
  //   let sum = 0;
  //   if (cpdata.length == 0) {
  //     return sum;
  //   } else {
  //     cpdata.map((item) =>
  //       item.amount
  //         ?  !(item.status == "Refund" || item.status=="Credit Note")
  //           ? (sum = sum + parseInt(item.amount))
  //           : (sum = sum - parseInt(item.amount))
  //         : sum
  //     );
  //     return sum;
  //   }
  // };

  const sptotal = (spdata) => {
    let sum = 0;
    if (spdata.length == 0) {
      return sum;
    } else {
      spdata.map((item) =>
        item.amount
          ?  !(item.status == "Refund" || item.status=="Refund Due" || item.status=="Refund claim by internal team")
            ? (sum = sum + parseInt(item.amount))
            : (sum = sum - parseInt(item.amount))
          : sum
      );
      return sum;
    }
  };

  const sumarray = (arr) => {
    let sum = 0;
    if (arr.length == 0) {
      return sum;
    } else {
      arr.map((item) => (sum = sum + item));
      return sum;
    }
  };

  const gettl=(name)=>{
    if(name){
      var temp=employeelist.filter(e=>e.short_name==name)
      if(temp.length>0){
        return temp[0].reporting_manager
      }else{
        return ""
      }
    }else{
      return ""
    }
  }
  //---------------------------------------------------------declarations----------------------------------------

  const analytics = [];
  const analytics2 = [];
  const analytics3 = [];
  const analytics4 = [];
  const analytics5 = [];
  const analytics6 = [];
  const analytics7 = [];
  const analytics8 = [];
  const analytics9 = [];
  var analytics10 = [];
  var analytics11 = [];
  var analytics12 = [];
  //---------------------------------------------------------created leads----------------------------------------
  if(createdleadData && listtripData){
  for (let i = 0; i < splist.length; i++) {
    var leadtotal = [];
    var splead = [];
    var cd = "abc";
    var tripData2 = [];
    var createdleadData2 = [];
    var cancleadData2 = [];
    var convleadData2 = [];
    var hotleadData2 = [];
    var boleadData2 = [];
    var potentialleadData2 = [];
    var newdest = "";
    if (destData3) {
      if (destData3 !== "All") {
        tripData2 = listtripData.filter(
          (trip) => trip.primary_destination == destData3
        );
        cancleadData2=cancleadData.filter(trip=>trip.primary_destination == destData3)
        convleadData2=convleadData.filter(trip=>trip.primary_destination == destData3)
        boleadData2=boleadData.filter(trip=>trip.primary_destination == destData3)
        hotleadData2=hotleadData.filter(trip=>trip.primary_destination == destData3)
        potentialleadData2=potentialleadData.filter(trip=>trip.primary_destination == destData3)
        if (destData3 == "Indonesia") {
          newdest = "Bali";
        } else {
          newdest = destData3;
        }
        createdleadData2 = createdleadData.filter(
          (lead) => lead.lead_destination == newdest
        );
      } else {
        tripData2 = listtripData;
        createdleadData2 = createdleadData;
        cancleadData2=cancleadData
        convleadData2=convleadData
        boleadData2=boleadData
        hotleadData2=hotleadData
        potentialleadData2=potentialleadData
      }
    } else {
      tripData2 = listtripData;
      createdleadData2 = createdleadData;
      cancleadData2=cancleadData
      convleadData2=convleadData
      boleadData2=boleadData
      hotleadData2=hotleadData
      potentialleadData2=potentialleadData
    }

    if (channelData !== "All") {
      leadtotal = tripData2.filter(
        (trip) =>
          trip.trip_channel == channelData && trip.trip_owner == splist[i]
      );
      if (channelData == "Facebook") {
        cd = "fb";
      } else if (channelData == "Instagram") {
        cd = "ig";
      }
      splead = createdleadData2.filter(
        (lead) =>
          (lead.lead_owner == splist[i] && lead.lead_platform == cd) ||
          (lead.lead_owner == splist[i] && lead.lead_platform == channelData)
      );
      cancleadData2=cancleadData.filter(trip=>trip.trip_channel == channelData && trip.trip_owner == splist[i])
      convleadData2=convleadData.filter(trip=>trip.trip_channel == channelData && trip.trip_owner == splist[i])
      boleadData2=boleadData.filter(trip=>trip.trip_channel == channelData && trip.trip_owner == splist[i])
      hotleadData2=hotleadData.filter(trip=>trip.trip_channel == channelData && trip.trip_owner == splist[i])
      potentialleadData2=potentialleadData.filter(trip=>trip.trip_channel == channelData && trip.trip_owner == splist[i])
      //console.log(splead)
    } else {
      leadtotal = tripData2.filter((trip) => trip.trip_owner == splist[i]);
      splead = createdleadData2.filter((lead) => lead.lead_owner == splist[i]);
      cancleadData2=cancleadData.filter(trip=>trip.trip_owner == splist[i])
        convleadData2=convleadData.filter(trip=>trip.trip_owner == splist[i])
        boleadData2=boleadData.filter(trip=>trip.trip_owner == splist[i])
        hotleadData2=hotleadData.filter(trip=>trip.trip_owner == splist[i])
        potentialleadData2=potentialleadData.filter(trip=>trip.trip_owner == splist[i])
      //console.log(splead)
    }
    // const leadcancelled = leadtotal.filter(
    //   (trip) =>
    //     trip.trip_status == "Cancelled" 
    // );
    // const leadbo = leadtotal.filter(
    //   (trip) =>
    //      trip.trip_status == "Booked Outside"
    // );
    // const leadconverted = leadtotal.filter(
    //   (trip) =>
    //     trip.trip_status == "Converted" ||
    //     trip.trip_status == "Closed" ||
    //     trip.trip_status == "Dropped After Booking"
    // );
    const leadconvertedref = convleadData2.filter(
      (trip) => trip.trip_channel == "Reference"
    );
    // const leadhot = leadtotal.filter((trip) => trip.trip_status == "Hot");
    const leadactive = leadtotal.filter(
      (trip) =>
        trip.trip_status == "Active" ||
        trip.trip_status == "New" ||
        trip.trip_status == "Postponed"
    );
    // const leadprofit = leadconverted.map(
    //   (trip) => total(trip.cust_payments) - sptotal(trip.supplier_payments)
    // );
    // const leadrevenue = leadconverted.map((trip) => total(trip.cust_payments));

    // console.log(splist[i])
    //  console.log("Created Lead")
    //  console.log(splead)
    //  console.log("Created Trips")
    //  console.log(leadtotal)
    //  console.log("Cancelled Trips")
    //  console.log(leadcancelled)
    //  console.log("Hot Trips")
    //  console.log(leadhot)
    //  console.log("Active Trips")
    //  console.log(leadactive)
    //  console.log("Converted Trips")
    //  console.log(leadconverted)
    //  console.log("Reference Converted Trips")
    //  console.log(leadconvertedref)

    const lead = {
      employee: splist[i],
      leadcreated: splead.length,
      created: leadtotal.length,
      potential: potentialleadData2.length,
      cancelled: cancleadData2.length,
      hot: hotleadData2.length,
      active: leadactive.length,
      converted: convleadData2.length,
      bo:boleadData2.length,
      refconverted: leadconvertedref.length,
      l2c_noref: (
        ((convleadData2.length - leadconvertedref.length) /
          (cancleadData2.length +
            convleadData2.length -
            leadconvertedref.length)) *
        100
      ).toFixed(2),
      l2c: (
        (convleadData2.length / (cancleadData2.length + convleadData2.length)) *
        100
      ).toFixed(2),
      // revenue: sumarray(leadrevenue),
      // profit: sumarray(leadprofit),
    };
    analytics.push(lead);
    //console.log(analytics)
  }
}
  const getSumByKey = (arr, key) => {
    return arr.reduce(
      (accumulator, current) => accumulator + Number(current[key]),
      0
    );
  };

  const createdtotal = {
    employee: "Total",
    leadcreated: getSumByKey(analytics, "leadcreated"),
    created: getSumByKey(analytics, "created"),
    potential: getSumByKey(analytics, "potential"),
    cancelled: getSumByKey(analytics, "cancelled"),
    hot: getSumByKey(analytics, "hot"),
    active: getSumByKey(analytics, "active"),
    converted: getSumByKey(analytics, "converted"),
    bo:getSumByKey(analytics, "bo"),
    l2c: (
      (getSumByKey(analytics, "converted") /
        (getSumByKey(analytics, "converted") +
          getSumByKey(analytics, "cancelled"))) *
      100
    ).toFixed(2),
    l2c_noref: (
      ((getSumByKey(analytics, "converted") -
        getSumByKey(analytics, "refconverted")) /
        (getSumByKey(analytics, "converted") -
          getSumByKey(analytics, "refconverted") +
          getSumByKey(analytics, "cancelled"))) *
      100
    ).toFixed(2),
    // revenue: getSumByKey(analytics, "revenue"),
    // profit: getSumByKey(analytics, "profit"),
  };
  //console.log(createdtotal)
  //---------------------------------------------------------converted leads------------------------------------
  if(listconvtripData && listtrip2Data){
  for (let i = 0; i < splist.length; i++) {
    var leadconverted2 = [];
    var leadconvertedref2 = [];
    var leadtotalref2 = [];
    const leadtotal2 = listtrip2Data.filter(
      (trip) => trip.trip_owner == splist[i]
    );
    if (destData !== "All") {
      leadconverted2 = listconvtripData.filter(
        (trip) =>
          trip.trip_owner == splist[i] && trip.primary_destination == destData
      );
      leadconvertedref2 = leadconverted2.filter(
        (trip) => trip.trip_channel == "Reference"
      );
      leadtotalref2 = leadtotal2.filter(
        (trip) =>
          trip.trip_channel == "Reference" &&
          trip.primary_destination == destData
      );
    } else {
      leadconverted2 = listconvtripData.filter(
        (trip) => trip.trip_owner == splist[i]
      );
      leadconvertedref2 = leadconverted2.filter(
        (trip) => trip.trip_channel == "Reference"
      );
      leadtotalref2 = leadtotal2.filter(
        (trip) => trip.trip_channel == "Reference"
      );
    }
    const leadrevenue2 = leadconverted2.map((trip) =>
      total(trip.cust_payments)
    );

    const leadlandrevenue2 = getSumByKey(leadconverted2, "land_sp")
      ? getSumByKey(leadconverted2, "land_sp")
      : 0;

    const leadprofit2 = leadconverted2.map(
      (trip) => total(trip.cust_payments) - sptotal(trip.supplier_payments)
    );

    // console.log(splist[i])
    // console.log("Created Lead")
    // console.log(leadtotal2)
    // console.log("Reference Trips")
    // console.log(leadtotalref2)
    // console.log("Converted Trips")
    // console.log(leadconverted2)
    // console.log("Reference Converted Trips")
    // console.log(leadconvertedref2)

    const lead2 = {
      employee: splist[i],
      converted: leadconverted2.length,
      refconverted: leadconvertedref2.length,
      reftotal: leadtotalref2.length,
      lead: leadtotal2.length,
      t2c: ((leadconverted2.length / leadtotal2.length) * 100).toFixed(2),
      t2c_noref: (
        ((leadconverted2.length - leadconvertedref2.length) /
          (leadtotal2.length - leadtotalref2.length)) *
        100
      ).toFixed(2),
      land_revenue: leadlandrevenue2,
      margin: ((sumarray(leadprofit2) / leadlandrevenue2) * 100).toFixed(2),
      revenue: sumarray(leadrevenue2),
      profit: sumarray(leadprofit2),
    };
    analytics2.push(lead2);
    //console.log(lead2);
  }
  }
  const convertedtotal = {
    employee: "Total",
    t2c: (
      (getSumByKey(analytics2, "converted") / getSumByKey(analytics2, "lead")) *
      100
    ).toFixed(2),
    t2c_noref: (
      ((getSumByKey(analytics2, "converted") -
        getSumByKey(analytics2, "refconverted")) /
        (getSumByKey(analytics2, "lead") -
          getSumByKey(analytics2, "reftotal"))) *
      100
    ).toFixed(2),
    converted: getSumByKey(analytics2, "converted"),
    land_revenue: getSumByKey(analytics2, "land_revenue"),
    margin: (
      (getSumByKey(analytics2, "profit") /
        getSumByKey(analytics2, "land_revenue")) *
      100
    ).toFixed(2),
    revenue: getSumByKey(analytics2, "revenue"),
    profit: getSumByKey(analytics2, "profit"),
  };

  // //---------------------------------------------------------Date calc-----------------------------------
  const todayDate = DateCalc(0);
  const nextDate = DateCalc(1);

  const dayafterDate = DateCalc(2);

  const thirdDate = DateCalc(3);
  const sevenDate = DateCalc(7);

  //---------------------------------------------------------funnel-------------------------------------
  if(funnelData){
  if (destData2 !== "All") {
    for (let i = 0; i < splist.length; i++) {
      const leadtotal3 = funnelData.filter(
        (trip) =>
          trip.trip_owner == splist[i] && trip.primary_destination == destData2
      );
      const leadhot3 = leadtotal3.filter((trip) => trip.trip_status == "Hot");
      const leadactive3 = leadtotal3.filter(
        (trip) => trip.trip_status == "Active" || trip.trip_status == "New"
      );
      const leadactive4 = leadtotal3.filter(
        (trip) =>
          trip.trip_status == "Active" ||
          trip.trip_status == "New" ||
          trip.trip_status == "Hot"
      );
      const leadconveretd3 = leadtotal3.filter(
        (trip) => trip.trip_status == "Converted"
      );
      const leadpostponed3 = leadtotal3.filter(
        (trip) => trip.trip_status == "Postponed"
      );
      const leadfup = leadtotal3.filter(
        (trip) => trip.follow_up && trip.follow_up.length > 0
      );
      const leadfuptoday = leadfup.filter(
        (trip) =>
          trip.follow_up &&
          trip.follow_up[trip.follow_up.length - 1]?.time !== "00:00" &&
          trip.follow_up.length > 0 &&
          (new Date(trip.follow_up[trip.follow_up.length - 1]?.date).getTime() >=
            new Date(todayDate).getTime() &&
            new Date(trip.follow_up[trip.follow_up.length - 1]?.date).getTime() <=
            new Date(nextDate).getTime() &&
            new Date(trip.follow_up[trip.follow_up.length - 1]?.createdAt).getTime() <=
            new Date(todayDate).getTime()) ||
            (new Date(trip.follow_up[trip.follow_up.length - 2]?.date).getTime() >=
              new Date(todayDate).getTime() &&
              new Date(trip.follow_up[trip.follow_up.length - 2]?.date).getTime() <=
              new Date(nextDate).getTime() &&
              new Date(trip.follow_up[trip.follow_up.length - 2]?.createdAt).getTime() <=
              new Date(todayDate).getTime()) ||
              (new Date(trip.follow_up[trip.follow_up.length - 3]?.date).getTime() >=
                new Date(todayDate).getTime() &&
                new Date(trip.follow_up[trip.follow_up.length - 3]?.date).getTime() <=
                new Date(nextDate).getTime() &&
                new Date(trip.follow_up[trip.follow_up.length - 3]?.createdAt).getTime() <=
                new Date(todayDate).getTime()) ||
                (new Date(trip.follow_up[trip.follow_up.length - 4]?.date).getTime() >=
                  new Date(todayDate).getTime() &&
                  new Date(trip.follow_up[trip.follow_up.length - 4]?.date).getTime() <=
                  new Date(nextDate).getTime() &&
                  new Date(trip.follow_up[trip.follow_up.length - 4]?.createdAt).getTime() <=
                  new Date(todayDate).getTime()) ||
                  (new Date(trip.follow_up[trip.follow_up.length - 5]?.date).getTime() >=
                    new Date(todayDate).getTime() &&
                    new Date(trip.follow_up[trip.follow_up.length - 5]?.date).getTime() <=
                    new Date(nextDate).getTime() &&
                    new Date(trip.follow_up[trip.follow_up.length - 5]?.createdAt).getTime() <=
                    new Date(todayDate).getTime())
      );
      const leadfupnextday = leadfup.filter(
        (trip) =>
          trip.follow_up &&
          trip.follow_up[trip.follow_up.length - 1]?.status == "Open" &&
          trip.follow_up[trip.follow_up.length - 1]?.time !== "00:00" &&
          trip.follow_up.length > 0 &&
          new Date(trip.follow_up[trip.follow_up.length - 1]?.date).getTime() <=
            new Date(nextDate).getTime()
      );
      const leadfupdayafter = leadfup.filter(
        (trip) =>
          trip.follow_up &&
          trip.follow_up[trip.follow_up.length - 1]?.status == "Open" &&
          trip.follow_up[trip.follow_up.length - 1]?.time !== "00:00" &&
          trip.follow_up.length > 0 &&
          new Date(trip.follow_up[trip.follow_up.length - 1]?.date).getTime() >
            new Date(nextDate).getTime() &&
          new Date(
            trip.follow_up[trip.follow_up.length - 1]?.date
              .split("T")
              .slice(0, 1)
          ).getTime() <= new Date(dayafterDate).getTime()
      );

      const leadfupthirdday = leadfup.filter(
        (trip) =>
          trip.follow_up &&
          trip.follow_up[trip.follow_up.length - 1]?.status == "Open" &&
          trip.follow_up[trip.follow_up.length - 1]?.time !== "00:00" &&
          trip.follow_up.length > 0 &&
          new Date(trip.follow_up[trip.follow_up.length - 1]?.date).getTime() >
            new Date(dayafterDate).getTime() &&
          new Date(
            trip.follow_up[trip.follow_up.length - 1]?.date
              .split("T")
              .slice(0, 1)
          ).getTime() <= new Date(thirdDate).getTime()
      );

      const leadfup4to7day = leadfup.filter(
        (trip) =>
          trip.follow_up &&
          trip.follow_up[trip.follow_up.length - 1]?.status == "Open" &&
          trip.follow_up[trip.follow_up.length - 1]?.time !== "00:00" &&
          trip.follow_up.length > 0 &&
          new Date(trip.follow_up[trip.follow_up.length - 1]?.date).getTime() >
            new Date(thirdDate).getTime() &&
          new Date(
            trip.follow_up[trip.follow_up.length - 1]?.date
              .split("T")
              .slice(0, 1)
          ).getTime() <= new Date(sevenDate).getTime()
      );

      // console.log(splist[i])
      // console.log("Hot Trips")
      // console.log(leadhot3)
      // console.log("Active Trips + Converted Trips")
      // console.log(leadactive3)
      // console.log("Converted Trips")
      // console.log(leadconveretd3)
      // console.log("Postponed Trips")
      // console.log(leadpostponed3)
      // console.log("Fup D+1")

      // console.log("Fup D+2")
      // console.log(leadfupdayafter)
      // console.log("Fup D+3")
      // console.log(leadfupthirdday)
      //console.log(leadfupthirdday)
      const lead3 = {
        employee: splist[i],
        total:
          leadhot3.length +
          leadactive3.length -
          leadconveretd3.length +
          leadconveretd3.length +
          leadpostponed3.length,
        hot: leadhot3.length,
        active: leadactive3.length,
        converted: leadconveretd3.length,
        postponed: leadpostponed3.length,
        fup_today: leadfuptoday.length,
        fup_nextday: leadfupnextday.length,
        fup_dayafter: leadfupdayafter.length,
        fup_thirdday: leadfupthirdday.length,
        fup_4to7days: leadfup4to7day.length,
        fup_share:
          Math.round(
            ((leadfupnextday.length +
              leadfupdayafter.length +
              leadfupthirdday.length) *
              100) /
              (leadactive3.length + leadhot3.length)
          ) / 100,
        fup_share2:
          Math.round(
            ((leadfupnextday.length +
              leadfupdayafter.length +
              leadfupthirdday.length +
              leadfup4to7day.length) *
              100) /
              (leadactive3.length + leadhot3.length)
          ) / 100,
      };
      analytics3.push(lead3);
    }
  } else {
    for (let i = 0; i < splist.length; i++) {
      const leadtotal3 = funnelData.filter(
        (trip) => trip.trip_owner == splist[i]
      );
      const leadhot3 = leadtotal3.filter((trip) => trip.trip_status == "Hot");
      const leadactive3 = leadtotal3.filter(
        (trip) => trip.trip_status == "Active" || trip.trip_status == "New"
      );
      const leadactive4 = leadtotal3.filter(
        (trip) =>
          trip.trip_status == "Active" ||
          trip.trip_status == "New" ||
          trip.trip_status == "Hot"
      );
      const leadconveretd3 = leadtotal3.filter(
        (trip) => trip.trip_status == "Converted"
      );
      const leadpostponed3 = leadtotal3.filter(
        (trip) => trip.trip_status == "Postponed"
      );
      const leadfup = leadtotal3.filter(
        (trip) => trip.follow_up && trip.follow_up.length > 0
      );
      const leadfuptoday = leadfup.filter(
        (trip) =>
          trip.follow_up &&
          trip.follow_up[trip.follow_up.length - 1]?.time !== "00:00" &&
          trip.follow_up[trip.follow_up.length - 2]?.time !== "00:00" &&
          trip.follow_up.length > 0 &&
          (new Date(trip.follow_up[trip.follow_up.length - 1]?.date).getTime() >=
            new Date(todayDate).getTime() &&
            new Date(trip.follow_up[trip.follow_up.length - 1]?.date).getTime() <=
            new Date(nextDate).getTime() &&
            new Date(trip.follow_up[trip.follow_up.length - 1]?.createdAt).getTime() <
            new Date(todayDate).getTime()) ||
            (new Date(trip.follow_up[trip.follow_up.length - 2]?.date).getTime() >=
              new Date(todayDate).getTime() &&
              new Date(trip.follow_up[trip.follow_up.length - 2]?.date).getTime() <=
              new Date(nextDate).getTime() &&
              new Date(trip.follow_up[trip.follow_up.length - 2]?.createdAt).getTime() <
              new Date(todayDate).getTime()) ||
              (new Date(trip.follow_up[trip.follow_up.length - 3]?.date).getTime() >=
                new Date(todayDate).getTime() &&
                new Date(trip.follow_up[trip.follow_up.length - 3]?.date).getTime() <=
                new Date(nextDate).getTime() &&
                new Date(trip.follow_up[trip.follow_up.length - 3]?.createdAt).getTime() <
                new Date(todayDate).getTime()) ||
                (new Date(trip.follow_up[trip.follow_up.length - 4]?.date).getTime() >=
                  new Date(todayDate).getTime() &&
                  new Date(trip.follow_up[trip.follow_up.length - 4]?.date).getTime() <=
                  new Date(nextDate).getTime() &&
                  new Date(trip.follow_up[trip.follow_up.length - 4]?.createdAt).getTime() <
                  new Date(todayDate).getTime()) ||
                  (new Date(trip.follow_up[trip.follow_up.length - 5]?.date).getTime() >=
                    new Date(todayDate).getTime() &&
                    new Date(trip.follow_up[trip.follow_up.length - 5]?.date).getTime() <=
                    new Date(nextDate).getTime() &&
                    new Date(trip.follow_up[trip.follow_up.length - 5]?.createdAt).getTime() <
                    new Date(todayDate).getTime())
      );
      //console.log(leadfup)
      const leadfupnextday = leadfup.filter(
        (trip) =>
          trip.follow_up &&
          trip.follow_up[trip.follow_up.length - 1]?.status == "Open" &&
          trip.follow_up[trip.follow_up.length - 1]?.time !== "00:00" &&
          trip.follow_up.length > 0 &&
          new Date(trip.follow_up[trip.follow_up.length - 1]?.date).getTime() <=
            new Date(nextDate).getTime()
      );
      const leadfupdayafter = leadfup.filter(
        (trip) =>
          trip.follow_up &&
          trip.follow_up[trip.follow_up.length - 1]?.status == "Open" &&
          trip.follow_up[trip.follow_up.length - 1]?.time !== "00:00" &&
          trip.follow_up.length > 0 &&
          new Date(trip.follow_up[trip.follow_up.length - 1]?.date).getTime() >
            new Date(nextDate).getTime() &&
          new Date(
            trip.follow_up[trip.follow_up.length - 1]?.date
              .split("T")
              .slice(0, 1)
          ).getTime() <= new Date(dayafterDate).getTime()
      );

      const leadfupthirdday = leadfup.filter(
        (trip) =>
          trip.follow_up &&
          trip.follow_up[trip.follow_up.length - 1]?.status == "Open" &&
          trip.follow_up[trip.follow_up.length - 1]?.time !== "00:00" &&
          trip.follow_up.length > 0 &&
          new Date(trip.follow_up[trip.follow_up.length - 1]?.date).getTime() >
            new Date(dayafterDate).getTime() &&
          new Date(
            trip.follow_up[trip.follow_up.length - 1]?.date
              .split("T")
              .slice(0, 1)
          ).getTime() <= new Date(thirdDate).getTime()
      );
      const leadfup4to7day = leadfup.filter(
        (trip) =>
          trip.follow_up &&
          trip.follow_up[trip.follow_up.length - 1]?.status == "Open" &&
          trip.follow_up[trip.follow_up.length - 1]?.time !== "00:00" &&
          trip.follow_up.length > 0 &&
          new Date(trip.follow_up[trip.follow_up.length - 1]?.date).getTime() >
            new Date(thirdDate).getTime() &&
          new Date(
            trip.follow_up[trip.follow_up.length - 1]?.date
              .split("T")
              .slice(0, 1)
          ).getTime() <= new Date(sevenDate).getTime()
      );
      // console.log(splist[i])
      // console.log("Hot Trips")
      // console.log(leadhot3)
      // console.log("Active Trips + Converted Trips")
      // console.log(leadactive3)
      // console.log("Converted Trips")
      // console.log(leadconveretd3)
      // console.log("Postponed Trips")
      // console.log(leadpostponed3)
      // console.log("Fup D+1")
      //console.log(leadfupnextday)
      //console.log(leadfupnextday.length)
      // console.log("Fup D+2")
      // console.log(leadfupdayafter)
      // console.log("Fup D+3")
      // console.log(leadfupthirdday)
      //console.log(leadfupthirdday)
      const lead3 = {
        employee: splist[i],
        total:
          leadhot3.length +
          leadactive3.length -
          leadconveretd3.length +
          leadconveretd3.length +
          leadpostponed3.length,
        hot: leadhot3.length,
        active: leadactive3.length,
        converted: leadconveretd3.length,
        postponed: leadpostponed3.length,
        fup_today: leadfuptoday.length,
        fup_nextday: leadfupnextday.length,
        fup_dayafter: leadfupdayafter.length,
        fup_thirdday: leadfupthirdday.length,
        fup_4to7days: leadfup4to7day.length,
        fup_share:
          Math.round(
            ((leadfupnextday.length +
              leadfupdayafter.length +
              leadfupthirdday.length) *
              100) /
              (leadactive3.length + leadhot3.length)
          ) / 100,
        fup_share2:
          Math.round(
            ((leadfupnextday.length +
              leadfupdayafter.length +
              leadfupthirdday.length +
              leadfup4to7day.length) *
              100) /
              (leadactive3.length + leadhot3.length)
          ) / 100,
      };
      analytics3.push(lead3);
    }
  }
  }
  const funneltotal = {
    employee: "Total",
    total: getSumByKey(analytics3, "total"),
    hot: getSumByKey(analytics3, "hot"),
    active: getSumByKey(analytics3, "active"),
    converted: getSumByKey(analytics3, "converted"),
    postponed: getSumByKey(analytics3, "postponed"),
    fup_today: getSumByKey(analytics3, "fup_today"),
    fup_nextday: getSumByKey(analytics3, "fup_nextday"),
    fup_dayafter: getSumByKey(analytics3, "fup_dayafter"),
    fup_thirdday: getSumByKey(analytics3, "fup_thirdday"),
    fup_4to7days: getSumByKey(analytics3, "fup_4to7days"),
    fup_share:
      Math.round(
        ((getSumByKey(analytics3, "fup_nextday") +
          getSumByKey(analytics3, "fup_dayafter") +
          getSumByKey(analytics3, "fup_thirdday")) *
          100) /
          (getSumByKey(analytics3, "active") + getSumByKey(analytics3, "hot"))
      ) / 100,
    fup_share2:
      Math.round(
        ((getSumByKey(analytics3, "fup_nextday") +
          getSumByKey(analytics3, "fup_dayafter") +
          getSumByKey(analytics3, "fup_thirdday") +
          getSumByKey(analytics3, "fup_4to7days")) *
          100) /
          (getSumByKey(analytics3, "active") + getSumByKey(analytics3, "hot"))
      ) / 100,
  };
  // // //console.log(abhishekfupnextday)
  //-------------------------------------------daily funnel---- ----------------------------------------
  var fupData2 = [];
  var fupDatalead = [];
  // var fupDataamit3 = 0;
  // var fupDataabhishek3 = 0;
  var i, j;
  // const d=new Date().toLocaleString("en-IN")
  // const d1=formatDate2(d)

  // console.log(new Date(todayDate))
  if(funnelData || loadfunnel){
    //console.log("ABC")
  if (destData2 !== "All") {
    for (let k = 0; k < splist.length; k++) {
      var fupDatalead3 = 0;

      for (i = 0; i < fupData.length; i++) {
        if (
          fupData[i].trip_owner == splist[k] &&
          fupData[i].primary_destination == destData2
        ) {
          // var fupDatalead3=0
          if (fupData[i].follow_up !== undefined) {
            for (j = 0; j < fupData[i].follow_up.length; j++) {
              //console.log(new Date(fupData[i].follow_up[j].updatedAt).getTime())
              if (fupData[i].follow_up[j].updatedAt !== undefined) {
                if (
                  fupData[i].follow_up[j].notes.length >= 3 &&
                  new Date(fupData[i].follow_up[j].createdAt).getTime() >=
                    new Date(todayDate).getTime()
                ) {
                  if (j !== 0 && fupData[i].trip_owner == splist[k]) {
                    if (
                      fupData[i].follow_up[j - 1].date.length > 0 &&
                      fupData[i].follow_up[j - 1].time.length > 0
                    ) {
                      var fupleadtime =
                        fupData[i].follow_up[j - 1].date +
                        "T" +
                        fupData[i].follow_up[j - 1].time;
                      fupDatalead3 =
                        fupDatalead3 +
                        Math.abs(
                          new Date(
                            fupData[i].follow_up[j].createdAt
                          ).getTime() - new Date(fupleadtime).getTime()
                        );
                    }
                  }
                  fupData2.push(fupData[i]);
                  //console.log(fupData2)
                }
              }
            }
          }
        }
      }

      fupDatalead.push(fupDatalead3);
      //console.log(splist[k],fupDatalead);
    }

    for (let i = 0; i < splist.length; i++) {
      const leadlead4 = leadData.filter(
        (lead) =>
          lead.lead_owner == splist[i] && lead.lead_destination == destData2
      );
      const totalleadlead4 = totalleads.filter(
        (lead) =>
          lead.lead_owner == splist[i] && lead.lead_destination == destData2
      );
      const potleadlead4 = leadlead4.filter(
        (lead) =>
          "potential" in lead && lead.potential
      );
      var sumttl = 0;
      for (let k = 0; k < leadlead4.length; k++) {
        if (leadlead4[k].work_complete_date) {
          sumttl =
            sumttl +
            (new Date(leadlead4[k].work_complete_date).getTime() -
              new Date(leadlead4[k].assignedAt).getTime()) /
              (60 * 1000);
        }
      }
      const leadttl4 = sumttl / leadlead4.length;
      //   .filter((cust) => cust.follow_up)
      //   .filter((cust) => cust.follow_up.owner == splist[i]);
      const leadcust4 = 0;
      const leadtrips4 = listtodaytripData.filter(
        (trip) =>
          trip.trip_owner == splist[i] && trip.primary_destination == destData2
      );
      const leadquotes4 = quoteData.filter(
        (quote) =>
          quote.trip_owner == splist[i] &&
          quote.primary_destination == destData2
      );
      const leadeditquotes4 = quoteeditData.filter(
        (quote) =>
          quote.trip_owner == splist[i] &&
          quote.primary_destination == destData2 &&
          new Date(quote.updatedAt).getTime()>new Date(quote.createdAt).getTime()
      );
      const leadconvtrips4 = listtodayconvtripData.filter(
        (trip) =>
          trip.trip_owner == splist[i] && trip.primary_destination == destData2
      );
      const leadcanctrips4 = listtodaycanctripData.filter(
        (trip) =>
          trip.trip_owner == splist[i] && trip.primary_destination == destData2
      );
      const leadpostponedtrips4 = listtodaypostponedtripData.filter(
        (trip) =>
          trip.trip_owner == splist[i] && trip.primary_destination == destData2
      );
      const leadhottrips4 = listtodayhottripData.filter(
        (trip) =>
          trip.trip_owner == splist[i] && trip.primary_destination == destData2
      );
      const leadfup4 = fupData2.filter(
        (trip) =>
          trip.trip_owner == splist[i] && trip.primary_destination == destData2
      );
      const leadfuptime4 = Math.round(
        fupDatalead[i] / (60 * 1000 * leadfup4.length)
      );

      let sumtalktime=0, sumcalled=0, sumanswered=0, effcalls=0, ut=[], ul=[]
      const updatedtrips=listupdatedtripData.filter(trip=>trip.trip_owner == splist[i] && trip.primary_destination == destData2) ;
      //const updatedtrips2=listupdatedtripData.filter(trip=>trip.trip_owner == splist[i]) ;
      // if(splist[i]=="Sidharth"){
      //   console.log(updatedtrips)
      //   //console.log(updatedtrips2)
      // }
      for(let i=0; i<updatedtrips.length; i++){
       
     
            sumcalled++
          
            if(updatedtrips[i].callrecord.call_status=="answered"){
              sumanswered++
              sumtalktime=sumtalktime+parseInt(updatedtrips[i].callrecord.outbound_sec)
              if(parseInt(updatedtrips[i].callrecord.outbound_sec)>120){
                effcalls++
              }
            }
            
          
          
        
      }
      const updatedleads=listupdatedleadData.filter(lead=>lead.lead_owner == splist[i] && lead.lead_destination == destData2) ;
      for(let i=0; i<updatedleads.length; i++){
       
         
            sumcalled++
            
            if(updatedleads[i].callrecord.call_status=="answered"){
              sumanswered++
              sumtalktime=sumtalktime+parseInt(updatedleads[i].callrecord.outbound_sec)
              if(parseInt(updatedleads[i].callrecord.outbound_sec)>120){
                effcalls++
              }
           
          
       
      }
      }

      ut=removeDuplicates(updatedtrips, "trip_id")
      ul=removeDuplicates(updatedleads, "lead_id")
      const lead4 = {
        employee: splist[i],
        daily_lead: leadlead4.length,
        total_lead: totalleadlead4.length,
        daily_pot_lead:potleadlead4.length,
        daily_cust: leadcust4.length,
        daily_trips: leadtrips4.length,
        daily_quotes: leadquotes4.length,
        daily_edit_quotes: (leadeditquotes4.length+leadquotes4.length-leadtrips4.length)<0?leadeditquotes4.length:leadeditquotes4.length+leadquotes4.length-leadtrips4.length,
        daily_conv_trips: leadconvtrips4.length,
        daily_postponed_trips: leadpostponedtrips4.length,
        daily_canc_trips: leadcanctrips4.length,
        daily_hot_trips: leadhottrips4.length,
        daily_fup: leadfup4.length + leadcanctrips4.length,
        avg_lead_time: leadttl4,
        avg_fup_time: leadfuptime4,
        qe_fup_ratio:Math.round((leadeditquotes4.length+leadquotes4.length-leadtrips4.length)/(leadfup4.length + leadcanctrips4.length)*100),
        daily_trips_unique:ut.length,
        daily_leads_unique:ul.length,
        daily_called: sumcalled,
        daily_answered: sumanswered,
        daily_talktime: Math.round(sumtalktime/60),
        daily_eff_calls:effcalls,
      };
      analytics4.push(lead4);
    }
  } else {
    for (let k = 0; k < splist.length; k++) {
      var fupDatalead3 = 0;

      for (i = 0; i < fupData.length; i++) {
        if (fupData[i].trip_owner == splist[k]) {
          // var fupDatalead3=0
          if (fupData[i].follow_up !== undefined) {
            for (j = 0; j < fupData[i].follow_up.length; j++) {
              //console.log(new Date(fupData[i].follow_up[j].updatedAt).getTime())
              if (fupData[i].follow_up[j].updatedAt !== undefined) {
                if (
                  "notes" in fupData[i].follow_up[j] && fupData[i].follow_up[j].notes.length >= 3 &&
                  new Date(fupData[i].follow_up[j].createdAt).getTime() >=
                    new Date(todayDate).getTime()
                ) {
                  if (j !== 0 && fupData[i].trip_owner == splist[k]) {
                    if (
                      fupData[i].follow_up[j - 1].date && fupData[i].follow_up[j - 1].date.length > 0 &&
                      fupData[i].follow_up[j - 1].time && fupData[i].follow_up[j - 1].time.length > 0
                    ) {
                      var fupleadtime =
                        fupData[i].follow_up[j - 1].date +
                        "T" +
                        fupData[i].follow_up[j - 1].time;
                      fupDatalead3 =
                        fupDatalead3 +
                        Math.abs(
                          new Date(
                            fupData[i].follow_up[j].createdAt
                          ).getTime() - new Date(fupleadtime).getTime()
                        );
                    }

                    // if(splist[k]=="Abhishek")
                    // {
                    //   //console.log(new Date(fupleadtime).getTime())
                    //   if(isNaN(new Date(fupleadtime).getTime())){
                    //     console.log(fupData[i].trip_id)
                    //   }
                    // }
                  }

                  fupData2.push(fupData[i]);
                  //console.log(fupData2)
                }
              }
            }
          }
        }
      }

      fupDatalead.push(fupDatalead3);
      //console.log(fupDatalead);
    }

    for (let i = 0; i < splist.length; i++) {
      const leadlead4 = leadData.filter((lead) => lead.lead_owner == splist[i]);
      const totalleadlead4 = totalleads.filter((lead) => lead.lead_owner == splist[i]);
      const potleadlead4 = leadlead4.filter(
        (lead) =>
          "potential" in lead && lead.potential
      );

      var sumttl2 = 0;
      for (let k = 0; k < leadlead4.length; k++) {
        if (leadlead4[k].work_complete_date) {
          sumttl2 =
            sumttl2 +
            (new Date(leadlead4[k].work_complete_date).getTime() -
              new Date(leadlead4[k].assignedAt).getTime()) /
              (60 * 1000);
          //console.log(new Date(leadlead4[k].work_complete_date).getTime()-new Date(leadlead4[k].assignedAt).getTime())
        }
      }
      const leadttl4 = Math.round(sumttl2 / leadlead4.length);
      // if(splist[i]=="Abhishek"){
      //   //console.log(leadttl4)
      // }

      const leadcust4 = custData
        .filter((cust) => cust.follow_up)
        .filter((cust) => cust.follow_up.owner == splist[i]);
      // if(splist[i]=="Tarun"){
      //     console.log(leadcust4)
      //   }
      const leadtrips4 = listtodaytripData.filter(
        (trip) => trip.trip_owner == splist[i]
      );
      // if(splist[i]=="Abhishek"){
      //       console.log(leadtrips4)
      //     }
      const leadquotes4 = quoteData.filter(
        (quote) => quote.trip_owner == splist[i]
      );
      // if(splist[i]=="Tarun"){
      //   console.log(leadquotes4)
      // }
      const leadeditquotes4 = quoteeditData.filter(
        (quote) => quote.trip_owner == splist[i]  && new Date(quote.updatedAt).getTime()>new Date(quote.createdAt).getTime()
      );
      // if(splist[i]=="Aman"){
      //   console.log(leadeditquotes4)
      // }
      //console.log(leadeditquotes4)
      const leadconvtrips4 = listtodayconvtripData.filter(
        (trip) => trip.trip_owner == splist[i]
      );
      const leadcanctrips4 = listtodaycanctripData.filter(
        (trip) => trip.trip_owner == splist[i]
      );
      const leadpostponedtrips4 = listtodaypostponedtripData.filter(
        (trip) => trip.trip_owner == splist[i]
      );
      const leadhottrips4 = listtodayhottripData.filter(
        (trip) => trip.trip_owner == splist[i]
      );
      const leadfup4 = fupData2.filter((trip) => trip.trip_owner == splist[i]);
      const leadfuptime4 = Math.round(
        fupDatalead[i] / (60 * 1000 * leadfup4.length)
      );

      let sumtalktime=0, sumcalled=0, sumanswered=0, effcalls=0, ut=[], ul=[]
      const updatedtrips=listupdatedtripData.filter(trip=>trip.trip_owner == splist[i]) ;
      //const updatedtrips2=listupdatedtripData.filter(trip=>trip.trip_owner == splist[i]) ;
      // if(splist[i]=="Hitesh"){
      //   console.log(updatedtrips)
      //   //console.log(updatedtrips2)
      // }
      for(let i=0; i<updatedtrips.length; i++){
       
     
            sumcalled++
          
            if(updatedtrips[i].callrecord.call_status=="answered"){
              sumanswered++
              sumtalktime=sumtalktime+parseInt(updatedtrips[i].callrecord.outbound_sec)
              if(parseInt(updatedtrips[i].callrecord.outbound_sec)>120){
                effcalls++
              }
            }
            
          
          
        
      }
      const updatedleads=listupdatedleadData.filter(lead=>lead.lead_owner == splist[i]) ;
      for(let i=0; i<updatedleads.length; i++){
       
         
            sumcalled++
            
            if(updatedleads[i].callrecord.call_status=="answered"){
              sumanswered++
              sumtalktime=sumtalktime+parseInt(updatedleads[i].callrecord.outbound_sec)
              if(parseInt(updatedleads[i].callrecord.outbound_sec)>120){
                effcalls++
              }
           
          
       
      }
      }

      ut=removeDuplicates(updatedtrips, "trip_id")
      ul=removeDuplicates(updatedleads, "lead_id")
      //console.log(ul)
      const lead4 = {
        employee: splist[i],
        daily_lead: leadlead4.length,
        total_lead: totalleadlead4.length,
        daily_pot_lead:potleadlead4.length,
        daily_cust: leadcust4.length,
        daily_trips: leadtrips4.length,
        daily_quotes: leadquotes4.length,
        //daily_edit_quotes: (leadeditquotes4.length+leadquotes4.length-leadtrips4.length)<0?leadeditquotes4.length:leadeditquotes4.length+leadquotes4.length-leadtrips4.length,
        daily_edit_quotes: leadeditquotes4.length,
        daily_conv_trips: leadconvtrips4.length,
        daily_postponed_trips: leadpostponedtrips4.length,
        daily_canc_trips: leadcanctrips4.length,
        daily_hot_trips: leadhottrips4.length,
        daily_fup: leadfup4.length + leadcanctrips4.length,
        avg_lead_time: leadttl4,
        avg_fup_time: leadfuptime4,
        qe_fup_ratio:(leadeditquotes4.length+leadquotes4.length-leadtrips4.length)<0?Math.round((leadeditquotes4.length)/(leadfup4.length + leadcanctrips4.length)*100):Math.round((leadeditquotes4.length+leadquotes4.length-leadtrips4.length)/(leadfup4.length + leadcanctrips4.length)*100),
        daily_trips_unique:ut.length,
        daily_leads_unique:ul.length,
        daily_called: sumcalled,
        daily_answered: sumanswered,
        daily_talktime: Math.round(sumtalktime/60),
        daily_eff_calls:effcalls,
      };
      analytics4.push(lead4);
    }
  }
  }
  const dailyfunneltotal = {
    employee: "Total",
    daily_lead: getSumByKey(analytics4, "daily_lead"),
    total_lead: getSumByKey(analytics4, "total_lead"),
    daily_pot_lead: getSumByKey(analytics4, "daily_pot_lead"),
    daily_cust: getSumByKey(analytics4, "daily_cust"),
    daily_trips: getSumByKey(analytics4, "daily_trips"),
    daily_quotes: getSumByKey(analytics4, "daily_quotes"),
    daily_edit_quotes: getSumByKey(analytics4, "daily_edit_quotes"),
    daily_conv_trips: getSumByKey(analytics4, "daily_conv_trips"),
    daily_canc_trips: getSumByKey(analytics4, "daily_canc_trips"),
    daily_postponed_trips: getSumByKey(analytics4, "daily_postponed_trips"),
    daily_hot_trips: getSumByKey(analytics4, "daily_hot_trips"),
    daily_fup: getSumByKey(analytics4, "daily_fup"),
    avg_lead_time: (
      getSumByKey(analytics4, "avg_lead_time") / splist.length
    ).toFixed(2),
    avg_fup_time: (
      getSumByKey(analytics4, "avg_fup_time") / splist.length
    ).toFixed(2),
    qe_fup_ratio:Math.round(getSumByKey(analytics4, "daily_edit_quotes")/getSumByKey(analytics4, "daily_fup")*100),
    daily_trips_unique:getSumByKey(analytics4, "daily_trips_unique"),
    daily_leads_unique:getSumByKey(analytics4, "daily_leads_unique"),
    daily_called: getSumByKey(analytics4, "daily_called"),
    daily_answered: getSumByKey(analytics4, "daily_answered"),
    daily_talktime: getSumByKey(analytics4, "daily_talktime"),
    daily_eff_calls:getSumByKey(analytics4, "daily_eff_calls"),
  };
  //---------------------------------------------closed trips---------------------------------------------

  for (let i = 0; i < splist.length; i++) {
    var leadclosed2 = [];

    if (destData !== "All") {
      leadclosed2 = listclosedtripData.filter(
        (trip) =>
          trip.trip_owner == splist[i] && trip.primary_destination == destData
      );
    } else {
      leadclosed2 = listclosedtripData.filter(
        (trip) => trip.trip_owner == splist[i]
      );
    }
    const leadreview = leadclosed2.filter(
      (trip) =>
        trip.trip_review_score !== null && trip.trip_review_score !== undefined
    );

    const leadreviewscore =
      getSumByKey(leadreview, "trip_review_score") / leadreview.length;

    // console.log(splist[i])
    // console.log("Closed Trips")
    // console.log(leadclosed2)
    // console.log("Reviewed Trips")
    // console.log(leadreview)

    const lead5 = {
      employee: splist[i],
      closed_trips: leadclosed2.length,
      review_score: leadreviewscore.toFixed(2),
      has_review: leadreview.length,
      review_percentage: (leadreview.length / leadclosed2.length).toFixed(2),
    };

    analytics5.push(lead5);
  }
  //console.log(listclosedtripData)

  const closedtotal = {
    employee: "Total",
    closed_trips: getSumByKey(analytics5, "closed_trips"),
    review_score: (
      getSumByKey(analytics5, "review_score") / splist.length
    ).toFixed(2),
    has_review: getSumByKey(analytics5, "has_review"),
    review_percentage: (
      getSumByKey(analytics5, "has_review") /
      getSumByKey(analytics5, "closed_trips")
    ).toFixed(2),
  };

  //---------------------------------------------hot trips---------------------------------------------
  if(listhottripData){
  for (let i = 0; i < splist.length; i++) {
    var leadhot2 = listhottripData.filter(
      (trip) => trip.trip_owner == splist[i]
    );

    const leadconverted3 = leadhot2.filter(
      (trip) =>
        trip.trip_status == "Converted" ||
        trip.trip_status == "Closed" ||
        trip.trip_status == "Dropped After Booking"
    );

    const lead6 = {
      employee: splist[i],
      converted_trips: leadconverted3.length,
      hot_trips: leadhot2.length,
      h2c: (leadconverted3.length / leadhot2.length).toFixed(2),
    };

    analytics6.push(lead6);
  }
  //console.log(listclosedtripData)
  }
  const hottotal = {
    employee: "Total",
    converted_trips: getSumByKey(analytics6, "converted_trips"),
    hot_trips: getSumByKey(analytics6, "hot_trips"),
    h2c: (
      getSumByKey(analytics6, "converted_trips") /
      getSumByKey(analytics6, "hot_trips")
    ).toFixed(2),
  };
//-------------------------------------------------quote edit-------------------------------------------
if(quoteeditData2.length>0 && quoteData2.length>0 && listtripData3.length>0){
  if(searchData5.destination && searchData5.destination!=="All"){
    listtripData3=listtripData3.filter(trip => trip.primary_destination==searchData5.destination )
    quoteData2=quoteData2.filter(quote => quote.primary_destination==searchData5.destination )
    quoteeditData2=quoteeditData2.filter(quote => quote.primary_destination==searchData5.destination )
  }
  for (let i = 0; i < splist.length; i++) {
    const tc=listtripData3.filter(trip => trip.trip_owner==splist[i] )
    var totalttt=0
    for(let i=0; i < tc.length; i++) {
      totalttt+=(new Date(tc[i].trip_start_date).getTime()-new Date(tc[i].createdAt).getTime())/(1000*60*60*24)
    }
    const qc=quoteData2.filter(quote => quote.trip_owner==splist[i] )
    const qe=quoteeditData2.filter(quote => quote.trip_owner==splist[i] )
    let qe2=qc.length>tc.length?qe.length+qc.length-tc.length:qe.length
    const tempobj={
      employee: splist[i],
      trips_created:tc.length,
      quotes_created:qc.length,
      quotes_edited:qe.length,
      calc_quotes_edited:qe2,
      qe_perc:(qe2/tc.length).toFixed(2),
      time_to_travel:Math.round(totalttt/tc.length)
    }
    //console.log(tempobj)
    analytics7.push(tempobj)
  }
  const totalobj={
    employee:"Total",
    trips_created:getSumByKey(analytics7, "trips_created"),
    quotes_created:getSumByKey(analytics7, "quotes_created"),
    quotes_edited:getSumByKey(analytics7, "quotes_edited"),
    calc_quotes_edited:getSumByKey(analytics7, "calc_quotes_edited"),
    qe_perc:(getSumByKey(analytics7, "calc_quotes_edited")/getSumByKey(analytics7, "trips_created")).toFixed(2),
    time_to_travel:Math.round((getSumByKey(analytics7, "time_to_travel"))/splist.length),
  }
  analytics7.push(totalobj)
}
//-----------------------------------fup data----------------------------------------------------------
if(fupData11.length>0){
  var progtrip=[]
  if(searchData6.destination !=="All"){
    fupData11=fupData11.filter(trip=>trip.primary_destination==searchData6.destination)
  }
  for (let i = 0; i < splist.length; i++) {
    const tc=fupData11.filter(trip=> trip.trip_owner==splist[i])
    
    //console.log(tc)//const tc2=fupData12.filter(trip=> trip.trip_owner==splist[i])
    let fupsum=0, fupnrsum=0, fupnormal=0, fupprog=0, fupmanual=0, fuppost=0, fupcanc=0
    for(let j=0;j<tc.length;j++) {
      if('follow_up' in tc[j]){
        for(let k=0;k<tc[j].follow_up.length;k++){
          if(new Date(tc[j].follow_up[k].createdAt).getTime()>=new Date(searchData6.start_date).getTime() && new Date(tc[j].follow_up[k].createdAt).getTime()<=new Date(searchData6.end_date).getTime()){
            fupsum++
          }
          if(new Date(tc[j].follow_up[k].createdAt).getTime()>=new Date(searchData6.start_date).getTime() && new Date(tc[j].follow_up[k].createdAt).getTime()<=new Date(searchData6.end_date).getTime() && (tc[j].follow_up[k].fupautonote=="Call not picked and no response on Whatsapp" || tc[j].follow_up[k].fupautonote=="No response after multiple follow ups"
        || tc[j].follow_up[k].fupautonote=="Will call you back if we are interested" || tc[j].follow_up[k].fupautonote=="Plan on hold" || tc[j].follow_up[k].fupautonote=="Asked to call later after a week" || tc[j].follow_up[k].fupautonote=="Asked to call later"
        || tc[j].follow_up[k].fupautonote=="Asked to call later after a few days" || tc[j].follow_up[k].fupautonote=="System fup - WA msg sent -Fup-3" || tc[j].follow_up[k].fupautonote=="System fup - WA msg sent -Fup-4" || tc[j].follow_up[k].fupautonote=="Will contact you on my own")){
          fupnrsum+=1
        }
        if(new Date(tc[j].follow_up[k].createdAt).getTime()>=new Date(searchData6.start_date).getTime() && new Date(tc[j].follow_up[k].createdAt).getTime()<=new Date(searchData6.end_date).getTime() && (tc[j].follow_up[k].fupautonote=="Call not picked. WA sent" || tc[j].follow_up[k].fupautonote=="Yet to view quote"
        || tc[j].follow_up[k].fupautonote=="Will let you know" || tc[j].follow_up[k].fupautonote=="Call not picked"
        || tc[j].follow_up[k].fupautonote=="Quote shared" || tc[j].follow_up[k].fupautonote=="System fup - WA msg sent -Fup-1" || tc[j].follow_up[k].fupautonote=="" || tc[j].follow_up[k].fupautonote=="System fup - WA msg sent -Fup-2" || tc[j].follow_up[k].fupautonote=="System fup - WA msg sent -Generic Fup-1" || tc[j].follow_up[k].fupautonote=="System fup - WA msg sent -Generic Fup-2"|| tc[j].follow_up[k].fupautonote=="Okay with package. Will tell the final decision" || tc[j].follow_up[k].fupautonote=="Data entry only" || tc[j].follow_up[k].fupautonote=="Need to share first quote" || tc[j].follow_up[k].fupautonote=="Call not needed. Msg dropped"  || tc[j].follow_up[k].fupautonote=="Extra attempt to be made")){
          fupnormal+=1
        }
        if(new Date(tc[j].follow_up[k].createdAt).getTime()>=new Date(searchData6.start_date).getTime() && new Date(tc[j].follow_up[k].createdAt).getTime()<=new Date(searchData6.end_date).getTime() && (tc[j].follow_up[k].fupautonote=="Asked to add flights. Shared quote with flights" || tc[j].follow_up[k].fupautonote=="Need changes. Need to share updated quote"
        || tc[j].follow_up[k].fupautonote=="Needed changes. Shared updated quote" || tc[j].follow_up[k].fupautonote=="Will let you know tomorrow"
        || tc[j].follow_up[k].fupautonote=="Will let you know within 2-3 days" || tc[j].follow_up[k].fupautonote=="Need more time-client is positive" || tc[j].follow_up[k].fupautonote=="Will let you know within a week" || tc[j].follow_up[k].fupautonote=="Our quote is costly. Shared other options" || tc[j].follow_up[k].fupautonote=="Budget issue. Will let us know" || tc[j].follow_up[k].fupautonote=="Budget issue. Shared other options" || tc[j].follow_up[k].fupautonote=="Comparing packages with other agencies" || tc[j].follow_up[k].fupautonote=="Everything finalized. Awaiting payment" ||  tc[j].follow_up[k].fupautonote=="Asked to call at a specific time" || tc[j].follow_up[k].fupautonote=="Discussion going on over WA" || tc[j].follow_up[k].fupautonote=="Waiting for rates")){
          fupprog+=1
          const temp=tc[j].trip_id+" "+tc[j].trip_owner
          progtrip.push(temp)
        }
        if(new Date(tc[j].follow_up[k].createdAt).getTime()>=new Date(searchData6.start_date).getTime() && new Date(tc[j].follow_up[k].createdAt).getTime()<=new Date(searchData6.end_date).getTime() && (tc[j].follow_up[k].fupautonote=="Fup done manually" )){
          fupmanual+=1
        }
        if(new Date(tc[j].follow_up[k].createdAt).getTime()>=new Date(searchData6.start_date).getTime() && new Date(tc[j].follow_up[k].createdAt).getTime()<=new Date(searchData6.end_date).getTime() && (tc[j].follow_up[k].fupautonote=="Need to share voucher or tickets" || tc[j].follow_up[k].fupautonote=="Need to share insurance" || tc[j].follow_up[k].fupautonote=="Need to confirm booking with supplier" || tc[j].follow_up[k].fupautonote=="Need to make payment to supplier")){
          fuppost+=1
        }
        if( new Date(tc[j].follow_up[k].createdAt).getTime()>=new Date(searchData6.start_date).getTime() && new Date(tc[j].follow_up[k].createdAt).getTime()<=new Date(searchData6.end_date).getTime() &&(tc[j].follow_up[k].fupautonote=="Asked to postpone" || tc[j].follow_up[k].fupautonote=="Plan on hold")){
          fupcanc+=1
        }
        if( new Date(tc[j].follow_up[k].createdAt).getTime()>=new Date(searchData6.start_date).getTime() && new Date(tc[j].follow_up[k].createdAt).getTime()<=new Date(searchData6.end_date).getTime() &&(tc[j].follow_up[k].fupautonote=="Manual Cancellation" || tc[j].follow_up[k].fupautonote=="Asked to cancel-on whatsapp" || tc[j].follow_up[k].fupautonote=="Asked to cancel-on call" || tc[j].follow_up[k].fupautonote=="System fup - WA msg sent -Asked to cancel-on whatsapp" || tc[j].follow_up[k].fupautonote=="System fup - WA msg sent -Asked to cancel-on call")){
          fupcanc+=1
        }
        }
        
      }
     
    }
    
   
  const tempobj={
    employee: splist[i],
    fups_created:fupsum,
    nr_fups_created:fupnrsum,
    ne_perc:Math.round(fupnrsum/fupsum*100),
    fupnormal:fupnormal,
    fupnormal_perc:Math.round(fupnormal/fupsum*100),
    fupprog:fupprog,
    fupprog_perc:Math.round(fupprog/fupsum*100),
    fupmanual:fupmanual,
    fupmanual_perc:Math.round(fupmanual/fupsum*100),
    fuppost:fuppost,
    fuppost_perc:Math.round(fuppost/fupsum*100),
    total_perc:Math.round(fupnrsum/fupsum*100)+Math.round(fupnormal/fupsum*100)+Math.round(fupprog/fupsum*100)+Math.round(fupmanual/fupsum*100)+Math.round(fuppost/fupsum*100)
  }
  // if(splist[i]=="Aakansha"){
  //      console.log(fupsum)
  //      console.log(tempobj)
  //      console.log(tc)
  //   }
  
  analytics8.push(tempobj)
  }

const totalobj={
  employee:"Total",
  fups_created:getSumByKey(analytics8, "fups_created"),
  nr_fups_created:getSumByKey(analytics8, "nr_fups_created"),
  ne_perc:Math.round(getSumByKey(analytics8, "nr_fups_created")/getSumByKey(analytics8, "fups_created")*100),
  fupnormal:getSumByKey(analytics8, "fupnormal"),
  fupnormal_perc:Math.round(getSumByKey(analytics8, "fupnormal")/getSumByKey(analytics8, "fups_created")*100),
  fupprog:getSumByKey(analytics8, "fupprog"),
  fupprog_perc:Math.round(getSumByKey(analytics8, "fupprog")/getSumByKey(analytics8, "fups_created")*100),
  fupmanual:getSumByKey(analytics8, "fupmanual"),
  fupmanual_perc:Math.round(getSumByKey(analytics8, "fupmanual")/getSumByKey(analytics8, "fups_created")*100),
  fuppost:getSumByKey(analytics8, "fuppost"),
  fuppost_perc:Math.round(getSumByKey(analytics8, "fuppost")/getSumByKey(analytics8, "fups_created")*100),
  total_perc:Math.round(getSumByKey(analytics8, "nr_fups_created")/getSumByKey(analytics8, "fups_created")*100)+Math.round(getSumByKey(analytics8, "fupnormal")/getSumByKey(analytics8, "fups_created")*100)+Math.round(getSumByKey(analytics8, "fupprog")/getSumByKey(analytics8, "fups_created")*100)+Math.round(getSumByKey(analytics8, "fupmanual")/getSumByKey(analytics8, "fups_created")*100)+Math.round(getSumByKey(analytics8, "fuppost")/getSumByKey(analytics8, "fups_created")*100)
}
analytics8.push(totalobj)
}

//-----------------------------------------------call record data----------------------------------
var callresultobject=[], newcalldatatrips=[], newupdatedleads=[]

if(calldatatrips.length > 0 || calldataleads.length>0) {
  for(let i = 0; i < splist3.length; i++) {
    let sumtalktime=0, sumcalled=0, sumanswered=0, sumeffcalls=0, updatedtrips=[],updatedleads=[]
      // if(showsupport){
      //   updatedtrips=calldatatrips.filter(trip=>trip.trip_owner == splist3[i] ) ;
      //   updatedleads=calldataleads.filter(lead=>lead.lead_owner == splist3[i] && "lead_owner_support" in lead) ;
      // }else{
      updatedtrips=calldatatrips.filter(trip=>trip.trip_owner == splist3[i] ) ;
      updatedleads=calldataleads.filter(lead=>lead.lead_owner == splist3[i] ) ;
      // }
      updatedtrips=removeDuplicatesmulti(updatedtrips, "callrecord", "answered_agent_name", "start_stamp", "duration")
      updatedleads=removeDuplicatesmulti(updatedleads, "callrecord", "answered_agent_name", "start_stamp", "duration")
      updatedtrips=removeExistingFromArray2multi(updatedleads, updatedtrips, "callrecord", "answered_agent_name", "start_stamp", "duration")
      

      var ut=[], ul=[]
    if(updatedtrips.length>0){
      //console.log("Here")
      for(let i=0; i<updatedtrips.length; i++){
        if(ssfilter=="Only Sales"){
           if(!sslist.includes(updatedtrips[i].callrecord.answered_agent_name)){
              sumcalled++
            if(updatedtrips[i].callrecord.call_status=="answered"){
              sumanswered++
              sumtalktime=sumtalktime+parseInt(updatedtrips[i].callrecord.outbound_sec)
              if(parseInt(updatedtrips[i].callrecord.outbound_sec)>120){
                sumeffcalls++
              }
            }
           }
        }else if(ssfilter=="Only SS"){
          if(sslist.includes(updatedtrips[i].callrecord.answered_agent_name)){
              sumcalled++
            if(updatedtrips[i].callrecord.call_status=="answered"){
              sumanswered++
              sumtalktime=sumtalktime+parseInt(updatedtrips[i].callrecord.outbound_sec)
              if(parseInt(updatedtrips[i].callrecord.outbound_sec)>120){
                sumeffcalls++
              }
            }
           }
        }
        else{
            sumcalled++
            if(updatedtrips[i].callrecord.call_status=="answered"){
              sumanswered++
              sumtalktime=sumtalktime+parseInt(updatedtrips[i].callrecord.outbound_sec)
              if(parseInt(updatedtrips[i].callrecord.outbound_sec)>120){
                sumeffcalls++
              }
            } }
}
ut=removeDuplicates(updatedtrips, "trip_id")
//console.log(ut)
       }

       if(updatedleads.length>0){
        //console.log("There")
for(let i=0; i<updatedleads.length; i++){
if(ssfilter=="Only Sales"){
           if(!sslist.includes(updatedleads[i].callrecord.answered_agent_name)){
              sumcalled++
            if(updatedleads[i].callrecord.call_status=="answered"){
              sumanswered++
              sumtalktime=sumtalktime+parseInt(updatedleads[i].callrecord.outbound_sec)
              if(parseInt(updatedleads[i].callrecord.outbound_sec)>120){
                sumeffcalls++
              }
            }
           }
        }else if(ssfilter=="Only SS"){
          if(sslist.includes(updatedleads[i].callrecord.answered_agent_name)){
              sumcalled++
            if(updatedleads[i].callrecord.call_status=="answered"){
              sumanswered++
              sumtalktime=sumtalktime+parseInt(updatedleads[i].callrecord.outbound_sec)
              if(parseInt(updatedleads[i].callrecord.outbound_sec)>120){
                sumeffcalls++
              }
            }
           }
        }
        else{

       sumcalled++
      if(updatedleads[i].callrecord.call_status=="answered"){
        sumanswered++
        sumtalktime=sumtalktime+parseInt(updatedleads[i].callrecord.outbound_sec)
        if(parseInt(updatedleads[i].callrecord.outbound_sec)>120){
          //console.log(updatedleads[i].lead_id)
          sumeffcalls++
        } 
      }
}
}
 ul=removeDuplicates(updatedleads, "lead_id")
 //console.log(ul)
}
var spcomment=commentdata.filter(trip=>trip.trip_owner==splist3[i])
//console.log(spcomment)
const lead5 = {
  employee: splist3[i],
  daily_trips_unique:ut.length,
  daily_leads_unique:ul.length,
  daily_called: sumcalled,
  daily_answered: sumanswered,
  daily_talktime: (sumtalktime),
  avg_talk_time: (sumtalktime/sumanswered).toFixed(1),
  answered_per:(sumanswered/sumcalled)>0?(sumanswered/sumcalled).toFixed(2):0,
  daily_eff_calls: sumeffcalls,
  eff_calls_per_answered: (sumeffcalls/sumanswered).toFixed(1),
  comment_number:spcomment.length,
};
analytics9.push(lead5);
  }
  //console.log(analytics9)
  var finallist=[], updatedtrips2=[...calldatatrips], updatedleads2=[...calldataleads]
  updatedtrips2=removeDuplicatesmulti(updatedtrips2, "callrecord", "answered_agent_name", "start_stamp", "duration")
  updatedleads2=removeDuplicatesmulti(updatedleads2, "callrecord", "answered_agent_name", "start_stamp", "duration")
  updatedtrips2=removeExistingFromArray2multi(updatedleads2, updatedtrips2, "callrecord", "answered_agent_name", "start_stamp", "duration")
  if(searchData8.owner){
    updatedtrips2=updatedtrips2.filter(trip=>trip.trip_owner == searchData8.owner ) ;
    updatedleads2=updatedleads2.filter(lead=>lead.lead_owner == searchData8.owner ) 
  }
  if(ssfilter=="Only Sales"){
    updatedtrips2=updatedtrips2.filter(t=>!sslist.includes(t.callrecord.answered_agent_name))
    updatedleads2=updatedleads2.filter(t=>!sslist.includes(t.callrecord.answered_agent_name))
  }
   if(ssfilter=="Only SS"){
    updatedtrips2=updatedtrips2.filter(t=>sslist.includes(t.callrecord.answered_agent_name))
    updatedleads2=updatedleads2.filter(t=>sslist.includes(t.callrecord.answered_agent_name))
  }
  if(searchData8.type){
    if(searchData8.type=="Lead"){
      finallist=[...updatedleads2]
    }
    if(searchData8.type=="Trip"){
      finallist=[...updatedtrips2]
    } 
  }else{
    finallist=[...updatedleads2,...updatedtrips2]
  }
  
  const result22=groupBy(finallist, v=>new Date(v.callrecord.start_stamp).getHours());
  const totalanswered=finallist.filter(v=>v.callrecord.call_status=="answered")
  const totaleffective=finallist.filter(v=>v.callrecord.call_status=="answered" && parseInt(v.callrecord.outbound_sec)>120)
  //console.log(finallist.length)
  //const trytemp=finallist.filter(v=>new Date(v.callrecord.start_stamp).getHours());
  //console.log(trytemp.length)
  //console.log(result22)
  let x=1
    for (let [key, value] of result22) {
      
      const answered=value.filter(v=>v.callrecord.call_status=="answered")
      const effective=value.filter(v=>v.callrecord.call_status=="answered" && parseInt(v.callrecord.outbound_sec)>120)
      const temp={
        id:x,
        hour:key,
        called: value.length,
        answered:answered.length+" ("+(answered.length/value.length*100).toFixed(1)+"%)",
        effective:effective.length+" ("+(effective.length/value.length*100).toFixed(1)+"%)",
      }
      callresultobject=[...callresultobject,temp]
      x++
      }
    const totaltemp={
      id:callresultobject.length+1,
      hour:"Total",
      called: finallist.length,
      answered:totalanswered.length+" ("+(totalanswered.length/finallist.length*100).toFixed(1)+"%)",
      effective:totaleffective.length+" ("+(totaleffective.length/finallist.length*100).toFixed(1)+"%)",
    }
    callresultobject=[...callresultobject,totaltemp]
  //console.log(callresultobject)
}
const dailycalltotal = {
  employee: "Total",
  daily_trips_unique:getSumByKey(analytics9, "daily_trips_unique"),
  daily_leads_unique:getSumByKey(analytics9, "daily_leads_unique"),
  daily_called: getSumByKey(analytics9, "daily_called"),
  daily_answered: getSumByKey(analytics9, "daily_answered"),
  daily_talktime: getSumByKey(analytics9, "daily_talktime"),
  avg_talk_time: (getSumByKey(analytics9, "daily_talktime")/getSumByKey(analytics9, "daily_answered")).toFixed(1),
  answered_per:(getSumByKey(analytics9, "daily_answered")/getSumByKey(analytics9, "daily_called")).toFixed(2),
  daily_eff_calls: getSumByKey(analytics9, "daily_eff_calls"),
  eff_calls_per_answered: (getSumByKey(analytics9, "daily_eff_calls")/getSumByKey(analytics9, "daily_answered")).toFixed(1),
  comment_number: getSumByKey(analytics9, "comment_number"),
};
//-----------------------------------------------fc call record data----------------------------------
if(calldataleads2.length > 0 && calldatatrips2.length > 0) {
  var ul2=removeDuplicatesmulti(calldataleads2, "callrecord", "answered_agent_name", "start_stamp", "duration")
  var ut2=removeDuplicatesmulti(calldatatrips2, "callrecord", "answered_agent_name", "start_stamp", "duration")
  ut2=removeExistingFromArray2multi(ul2, ut2, "callrecord", "answered_agent_name", "start_stamp", "duration")
  if(showattempted){
    analytics10=[...ul2]
  
  
  var temp2=ut2.filter(trip=>new Date(trip.createdAt).getTime()>new Date(trip.callrecord.start_stamp).getTime())
  analytics10=[...analytics10,...temp2]
  }else{
  analytics10=ul2.filter(lead=>parseInt(lead.callrecord.outbound_sec)>0)
  
  
  var temp2=ut2.filter(trip=>new Date(trip.createdAt).getTime()>new Date(trip.callrecord.start_stamp).getTime() && parseInt(trip.callrecord.outbound_sec)>0)
  analytics10=[...analytics10,...temp2]
  }

  if(searchData4.owner){
    analytics10=analytics10.filter(lead=>lead.lead_owner==searchData4.owner || lead.trip_owner==searchData4.owner)
  }
  if(searchData4.support_owner){
    analytics10=analytics10.filter(lead=>lead.callrecord.answered_agent_name==searchData4.support_owner)
  }
  if(showsupport){

  }else{
    analytics10=analytics10.filter(l=>"callrecord" in l && !(sslist.includes(l.callrecord.answered_agent_name) ))
  }

  
  // var score=200
  // for(i=0;i<splist3.length;i++){
  //   // const tempscore=auditscore.filter(emp=>emp.name==splist3[i])
  //   // if(tempscore.length>0){
  //   //   score=tempscore[0].score
  //   // }
  //   const spcalls=analytics10.filter(lead=>lead.lead_owner==splist3[i])
  //   const spcalls2=calldatatrips2.filter(trip=>trip.trip_owner==splist3[i])
  //   var usefulspcalls=[]
  //   if(spcalls.length>0){
  //   usefulspcalls=[...usefulspcalls,...spcalls.filter(lead=>Number(lead.callrecord.outbound_sec)>100 && Number(lead.callrecord.outbound_sec)<400)]
  //   }
  //   if(spcalls2.length>0){
  //   usefulspcalls=[...usefulspcalls,...spcalls2.filter(lead=>Number(lead.callrecord.outbound_sec)>100 && Number(lead.callrecord.outbound_sec)<400)]
  //   }
  // //

  // }
  // for(let i=0;i<analytics10.length;i++) {
  //   const temp2=temp.filter(lead=>lead.lead_id==analytics10[i].lead_id && Number(analytics10[i].callrecord.outbound_sec)>100 && Number(analytics10[i].callrecord.outbound_sec)<400)
  //   //console.log(temp2)
  //   if(temp2.length>0 && Number(temp2[0].callrecord.outbound_sec)>100 && Number(temp2[0].callrecord.outbound_sec)<400) {
  //     analytics10[i].audit=true
  //   }else{
  //     analytics10[i].audit=false
  //   }
  // }
 //setauditcalls(temp)
}

//console.log(splist)
//console.log(auditcalls)
  //-------------------------------------------fc check----------------------------------------

function removeDuplicatescomplex(array) {
  const result = new Map();

  for (const obj of array) {
    const existing = result.get(obj.lead_id);

    if (!existing) {
      result.set(obj.lead_id, obj);
      continue;
    }

    const existingHasTripId = Object.prototype.hasOwnProperty.call(existing, "trip_id");
    const currentHasTripId = Object.prototype.hasOwnProperty.call(obj, "trip_id");

    // If existing has trip_id but current doesn't, keep current
    if (existingHasTripId && !currentHasTripId) {
      result.set(obj.lead_id, obj);
    }

    // Otherwise keep existing
  }

  return [...result.values()];
}
  var analytics14=[]
  if(calldataleads3.length>0 && calldatatrips2.length > 0){
    
    analytics11=calldataleads3.filter(lead=>newgetqualitylead(lead) !=="Iron" && newgetqualitylead(lead) !=="Copper" && newgetqualitylead(lead) !=="Silver")
    
    analytics11=analytics11.filter(l=>"callrecord" in l && l.callrecord.length>0)
    var temp22=calldatatrips2.filter(trip=>new Date(trip.createdAt).getTime()>new Date(trip.callrecord.start_stamp).getTime())
    analytics11=[...analytics11,...temp22]
    console.log(analytics11)
    if(searchData7.owner){
      analytics11=analytics11.filter(lead=>lead.lead_owner==searchData7.owner || lead.trip_owner==searchData7.owner)
    }
       analytics11 = analytics11.map(item => ({
  ...item,
  callrecord: Array.isArray(item.callrecord)?item.callrecord:[item.callrecord],
  lead_id:"lead_id" in item?item.lead_id:("lead" in item?item.lead.lead_id:""),
}));
console.log(analytics11)
    analytics11=removeDuplicatescomplex(analytics11)
 console.log(analytics11) 
    analytics11 = analytics11.map(item => ({
  ...item,
  callrecord: item.callrecord.filter(
    call => !(sslist.includes(call.answered_agent_name) )
  )
}));
console.log(analytics11)
    for(let i=0;i<analytics11.length;i++){
      var fc=Array.isArray(analytics11[i].callrecord)?(analytics11[i].callrecord.length==1?analytics11[i].callrecord[analytics11[i].callrecord.length-1].outbound_sec:""):analytics11[i].callrecord.outbound_sec
      if(fc && Number(fc)>20){

      }else{
      var tempobj={
        lead_id: "lead_id" in analytics11[i]?analytics11[i].lead_id:("lead" in analytics11[i]?analytics11[i].lead.lead_id:""),
        name: "lead_name" in analytics11[i]?analytics11[i].lead_name:analytics11[i].cust_name,
        lead_owner: "lead_owner" in analytics11[i]?analytics11[i].lead_owner:analytics11[i].trip_owner,
        call1:Array.isArray(analytics11[i].callrecord)?(analytics11[i].callrecord.length>0?analytics11[i].callrecord[analytics11[i].callrecord.length-1].start_stamp:""):analytics11[i].callrecord.start_stamp,
        call2:Array.isArray(analytics11[i].callrecord)?(analytics11[i].callrecord.length>1?analytics11[i].callrecord[analytics11[i].callrecord.length-2].start_stamp:""):"Called from trip",
        call3:Array.isArray(analytics11[i].callrecord)?(analytics11[i].callrecord.length>2?analytics11[i].callrecord[analytics11[i].callrecord.length-3].start_stamp:""):"Called from trip",  
        canc_reason:"canc_reason" in analytics11[i]?analytics11[i].canc_reason:"",
        skip_second_call:"skip_second_call" in analytics11[i]?analytics11[i].skip_second_call:"",
      }
      analytics14=[...analytics14,tempobj]
    }
    }
  }
  //console.log(analytics14)
  //--------------------------------------------------fup call---------------------------------------------
  if(calldatatrips2.length > 0){
    if(showattempted){
      analytics12=[...calldatatrips2]
    }else{
      analytics12=calldatatrips2.filter(trip=>parseInt(trip.callrecord.outbound_sec)>0)
    }
    
    if(searchData4.owner){
      analytics12=analytics12.filter(trip=>trip.trip_owner==searchData4.owner)
    }
    
    for (let i=0;i<analytics12.length;i++){
      if(parseInt(analytics12[i].callrecord.outbound_sec)>120 && analytics12[i].trip_id%3==0){
        analytics12[i].audit=true
      }else{
        analytics12[i].audit=false
      }
    }
    //console.log(analytics12)
  }
  //-------------------------------------------datagrid creation----------------------------------------
  if (analytics.length !== 0) {
    analytics.push(createdtotal);
  }

  if (analytics2.length !== 0) {
    analytics2.push(convertedtotal);
  }

  if (analytics3.length !== 0) {
    analytics3.push(funneltotal);
  }

  if (analytics4.length !== 0) {
    analytics4.push(dailyfunneltotal);
  }

  if (analytics5.length !== 0) {
    analytics5.push(closedtotal);
  }

  if (analytics6.length !== 0) {
    analytics5.push(hottotal);
  }

  if (analytics9.length !== 0) {
    analytics9.push(dailycalltotal);
  }

  var analytics15=[]
  // if(calldataleads4.length>1){
  //   for(let i=0;i<splist.length;i++){
  //      var temp={
  //       lead_owner:splist[i],
  //       tl:gettl(splist[i]),
  //      }
  //     var spcalls=calldataleads4.filter(l=>l.lead_owner==splist[i])
  //     if(spcalls.length>0){
  //     temp={
  //       lead_owner:splist[i],
  //       total:spcalls.length,
  //       effective: spcalls.reduce((acc, current)=>{if(parseInt(current.callrecord.outbound_sec)>120){return acc+1}else{return acc}},0),
  //       talk_time: spcalls.reduce((acc, current)=>{return acc+parseInt(current.callrecord.outbound_sec)},0),
  //       qs: spcalls.reduce((acc, current)=>{if(Number.isInteger(Number(getqs(current.callrecord))*100) && Number(getqs(current.callrecord))>0){return acc+(Number(getqs(current.callrecord)))}else{return acc}},0),
  //       tl:gettl(splist[i]),
  //     }
  //   }
  //     analytics15=[...analytics15, temp]
  //   }
  // }
  //console.log(calldatatrips4)
    if(calldatatrips4.length>1){
     for(let i=0;i<splist.length;i++){
       var temp20={
        lead_owner:splist[i],
        tl:gettl(splist[i]),
       }
      var spfupcalls=calldatatrips4.filter(l=>l.trip_owner==splist[i] || l.lead_owner==splist[i])
      if(spfupcalls.length>0){
      temp20={
        lead_owner:splist[i],
        total:spfupcalls.length,
        effective: spfupcalls.reduce((acc, current)=>{if(parseInt(current.callrecord.outbound_sec)>120){return acc+1}else{return acc}},0),
        talk_time: spfupcalls.reduce((acc, current)=>{return acc+parseInt(current.callrecord.outbound_sec)},0),
        qs: spfupcalls.reduce((acc, current)=>{if(Number.isInteger(Number(getqs(current.callrecord))*100) && Number(getqs(current.callrecord))>0){return acc+(Number(getqs(current.callrecord)))}else{return acc}},0),
        tl:gettl(splist[i]),
      }
    }
      analytics15=[...analytics15, temp20]
    }
  }
  //console.log(analytics15)

    const analyticsdatalistdisplay14 = analytics15.map((dailydata) => ({
    id: analytics15.indexOf(dailydata),
    total:dailydata.total,
    lead_owner: dailydata.lead_owner,
    talk_time: dailydata.talk_time,
    effective: dailydata.effective,
    qs:(dailydata.qs/dailydata.total).toFixed(2),
    tl:dailydata.tl,
    
  }));

  const analyticsdatalistdisplay = analytics.map((tripdata) => ({
    employee: tripdata.employee,
    id: analytics.indexOf(tripdata),
    created_leads: tripdata.leadcreated,
    potential_leads: tripdata.potential,
    created_trips: tripdata.created,
    cancelled_trips: tripdata.cancelled,
    bo_trips: tripdata.bo,
    active_trips: tripdata.active,
    hot_trips: tripdata.hot,
    converted_trips: tripdata.converted,
    closed_l2c: tripdata.l2c,
    closed_l2c_noref: tripdata.l2c_noref,
    
  }));

  const analyticsdatalistdisplay2 = analytics2.map((tripdata) => ({
    employee: tripdata.employee,
    id: analytics2.indexOf(tripdata),
    t2c: tripdata.t2c,
    closed_l2c_noref: tripdata.t2c_noref,
    converted_trips: tripdata.converted,
    margin: tripdata.margin,
    land_revenue: tripdata.land_revenue,
    revenue: tripdata.revenue,
    profit: tripdata.profit,
  }));

  const analyticsdatalistdisplay3 = analytics3.map((tripdata) => ({
    employee: tripdata.employee,
    id: analytics3.indexOf(tripdata),
    total_trips: tripdata.total,
    active_trips: tripdata.active,
    hot_trips: tripdata.hot,
    active_hot:tripdata.active+tripdata.hot,
    converted_trips: tripdata.converted,
    postponed_trips: tripdata.postponed,
    fup_today:tripdata.fup_today,
    fup_nextday: tripdata.fup_nextday,
    fup_dayafter: tripdata.fup_dayafter,
    fup_thirdday: tripdata.fup_thirdday,
    fup_4to7days: tripdata.fup_4to7days,
    fup_share: tripdata.fup_share,
    fup_share2: tripdata.fup_share2,
  }));

  //console.log(analyticsdatalistdisplay3)
  const analyticsdatalistdisplay4 = analytics4.map((dailydata) => ({
    employee: dailydata.employee,
    id: analytics4.indexOf(dailydata),
    daily_lead: dailydata.daily_lead,
    total_lead: dailydata.total_lead,
    daily_pot_lead:dailydata.daily_pot_lead,
    daily_cust: dailydata.daily_cust,
    daily_trips: dailydata.daily_trips,
    daily_quotes: dailydata.daily_quotes,
    daily_edit_quotes: dailydata.daily_edit_quotes,
    daily_conv_trips: dailydata.daily_conv_trips,
    daily_canc_trips: dailydata.daily_canc_trips,
    daily_postponed_trips: dailydata.daily_postponed_trips,
    daily_hot_trips: dailydata.daily_hot_trips,
    daily_fup: dailydata.daily_fup,
    avg_fup_time: dailydata.avg_fup_time,
    avg_lead_time: dailydata.avg_lead_time,
    qe_fup_ratio: dailydata.qe_fup_ratio,
    daily_trips_unique: dailydata.daily_trips_unique,
    daily_leads_unique: dailydata.daily_leads_unique,
    daily_called: dailydata.daily_called,
    daily_answered: dailydata.daily_answered,
    daily_talktime: dailydata.daily_talktime,
    daily_eff_calls: dailydata.daily_eff_calls,
  }));
  //console.log(analyticsdatalistdisplay4)
  const analyticsdatalistdisplay5 = analytics5.map((dailydata) => ({
    employee: dailydata.employee,
    id: analytics5.indexOf(dailydata),
    closed_trips: dailydata.closed_trips,
    review_score: dailydata.review_score,
    has_review: dailydata.has_review,
    review_percentage: dailydata.review_percentage,
  }));

  const analyticsdatalistdisplay6 = analytics6.map((dailydata) => ({
    employee: dailydata.employee,
    id: analytics6.indexOf(dailydata),
    hot_trips: dailydata.hot_trips,
    h2c: dailydata.h2c,
    converted_trips: dailydata.converted_trips,
  }));

  const analyticsdatalistdisplay7 = analytics7.map((dailydata) => ({
    employee: dailydata.employee,
    id: analytics7.indexOf(dailydata),
    trips_created:dailydata.trips_created,
    quotes_created:dailydata.quotes_created,
    quotes_edited:dailydata.quotes_edited,
    calc_quotes_edited:dailydata.calc_quotes_edited,
    qe_perc:dailydata.qe_perc,
    time_to_travel:dailydata.time_to_travel,
  }));

  const analyticsdatalistdisplay8 = analytics8.map((dailydata) => ({
    employee: dailydata.employee,
    id: analytics8.indexOf(dailydata),
    fups_created:dailydata.fups_created,
    nr_fups_created:dailydata.nr_fups_created,
    ne_perc:dailydata.ne_perc,
    fupnormal:dailydata.fupnormal,
    fupnormal_perc:dailydata.fupnormal_perc,
    fupprog:dailydata.fupprog,
    fupprog_perc:dailydata.fupprog_perc,
    fupmanual:dailydata.fupmanual,
    fupmanual_perc:dailydata.fupmanual_perc,
    fuppost:dailydata.fuppost,
    fuppost_perc:dailydata.fuppost_perc,
    total_perc:dailydata.total_perc,
  }));

  const analyticsdatalistdisplay9 = analytics9.map((dailydata) => ({
    employee: dailydata.employee,
    id: analytics9.indexOf(dailydata),
    daily_trips_unique: dailydata.daily_trips_unique,
    daily_leads_unique: dailydata.daily_leads_unique,
    daily_called: dailydata.daily_called,
    daily_answered: dailydata.daily_answered,
    daily_talktime: Math.round(dailydata.daily_talktime/60),
    answered_per: dailydata.answered_per,
    daily_eff_calls: dailydata.daily_eff_calls,
    avg_talk_time: (dailydata.daily_talktime/(dailydata.daily_answered)).toFixed(2),
    eff_calls_per_answered: (dailydata.daily_eff_calls/dailydata.daily_answered).toFixed(2),
    comment_number:dailydata.comment_number,
  }));

  analytics10=removeDuplicatesmulti(analytics10, "callrecord", "answered_agent_name", "start_stamp", "duration")
  const analyticsdatalistdisplay10 = analytics10.map((dailydata) => ({
    lead_id: "lead_id" in dailydata?dailydata.lead_id:("lead" in dailydata && "lead_id" in dailydata.lead?dailydata.lead.lead_id:""),
    id: analytics10.indexOf(dailydata),
    name: "lead_name" in dailydata?dailydata.lead_name:dailydata.cust_name,
    dest:"lead_destination" in dailydata?dailydata.lead_destination:dailydata.primary_destination,
    lead_owner: "lead_owner" in dailydata?dailydata.lead_owner:dailydata.trip_owner,
    talk_time: parseInt(dailydata.callrecord.outbound_sec),
    effective: parseInt(dailydata.callrecord.outbound_sec)>120?true:false,
    disconnected_by:dailydata.callrecord.hangup_cause,
    caller:dailydata.callrecord.answered_agent_name,
    customer:dailydata.callrecord.call_to_number+" ("+dailydata.callrecord.duration+")",
    call_time:dailydata.callrecord.start_stamp,
    quality:"lead_id" in dailydata?newgetqualitylead(dailydata):getquality(dailydata.lead.lead_status, dailydata.lead.time_to_book, dailydata.trip_channel, dailydata.trip_start_date,dailydata.lead.quality_upgrade,null),
     qs:getqs(dailydata.callrecord),
     audit_date:dailydata.callrecord.audit_date,
     tl:"lead_owner" in dailydata?gettl(dailydata.lead_owner):gettl(dailydata.trip_owner),
     opening_script:parseInt(dailydata.callrecord.opening_script)?Number((parseInt(dailydata.callrecord.opening_script)/4).toFixed(2)):"",
    closing_script:parseInt(dailydata.callrecord.closing_script)?Number((parseInt(dailydata.callrecord.closing_script)/3).toFixed(2)):"",
    hold_script:parseInt(dailydata.callrecord.hold_script)?Number((parseInt(dailydata.callrecord.hold_script)/3).toFixed(2)):"",
    interruption:parseInt(dailydata.callrecord.interruption)?Number((parseInt(dailydata.callrecord.interruption)/3).toFixed(2)):"",
    rate_of_speech:parseInt(dailydata.callrecord.rate_of_speech)?Number((parseInt(dailydata.callrecord.rate_of_speech)/2).toFixed(2)):"",
    personalization: parseInt(dailydata.callrecord.personalization)?Number((parseInt(dailydata.callrecord.personalization)/3).toFixed(2)):"",
    tone:parseInt(dailydata.callrecord.tone)?Number((parseInt(dailydata.callrecord.tone)/3).toFixed(2)):"",
    language:parseInt(dailydata.callrecord.language)?Number((parseInt(dailydata.callrecord.language)/3).toFixed(2)):"",
    fillers:parseInt(dailydata.callrecord.fillers)?Number((parseInt(dailydata.callrecord.fillers)/6).toFixed(2)):"",
    active_listening:parseInt(dailydata.callrecord.active_listening)?Number((parseInt(dailydata.callrecord.active_listening)/7).toFixed(2)):"",
    rapport:new Date(dailydata.callrecord.start_stamp).getTime()>new Date("2026-06-01").getTime()?(parseInt(dailydata.callrecord.rapport)?Number((parseInt(dailydata.callrecord.rapport)/17).toFixed(2)):""):(parseInt(dailydata.callrecord.rapport)?Number((parseInt(dailydata.callrecord.rapport)/7).toFixed(2)):""),
    empathy:parseInt(dailydata.callrecord.empathy)?Number((parseInt(dailydata.callrecord.empathy)/6).toFixed(2)):"",
    basic_information:parseInt(dailydata.callrecord.basic_information)?Number((parseInt(dailydata.callrecord.basic_information)/10).toFixed(2)):"",
    explanation:parseInt(dailydata.callrecord.explanation)?Number((parseInt(dailydata.callrecord.explanation)/10).toFixed(2)):"",
    guidance:new Date(dailydata.callrecord.start_stamp).getTime()>new Date("2026-06-01").getTime()?(parseInt(dailydata.callrecord.guidance)?Number((parseInt(dailydata.callrecord.guidance)/15).toFixed(2)):""):(parseInt(dailydata.callrecord.guidance)?Number((parseInt(dailydata.callrecord.guidance)/20).toFixed(2)):""),
    sales_pitch:new Date(dailydata.callrecord.start_stamp).getTime()>new Date("2026-06-01").getTime()?(parseInt(dailydata.callrecord.sales_pitch)?Number((parseInt(dailydata.callrecord.sales_pitch)/5).toFixed(2)):""):(parseInt(dailydata.callrecord.sales_pitch)?Number((parseInt(dailydata.callrecord.sales_pitch)/10).toFixed(2)):""),
    // closing:parseInt(dailydata.callrecord.closing)?Number((parseInt(dailydata.callrecord.closing)/4).toFixed(2)):"",
    // oh_delay:parseInt(dailydata.callrecord.oh_delay)?Number((parseInt(dailydata.callrecord.oh_delay)/4).toFixed(2)):"",
    // oh_price:parseInt(dailydata.callrecord.oh_price)?Number((parseInt(dailydata.callrecord.oh_price)/4).toFixed(2)):"",
    // oh_probing:parseInt(dailydata.callrecord.oh_probing)?Number((parseInt(dailydata.callrecord.oh_probing)/4).toFixed(2)):"",
    // oh_permission:parseInt(dailydata.callrecord.oh_permission)?Number((parseInt(dailydata.callrecord.oh_permission)/4).toFixed(2)):"",
    // oh_trust:parseInt(dailydata.callrecord.oh_trust)?Number((parseInt(dailydata.callrecord.oh_trust)/4).toFixed(2)):"",
    improvement:dailydata.callrecord.improvement,
    description:dailydata.callrecord.description,
    
  }));

  //console.log(analyticsdatalistdisplay10)
  analytics12=removeDuplicatesmulti(analytics12, "callrecord", "answered_agent_name", "start_stamp", "duration")
  const analyticsdatalistdisplay12 = analytics12.map((dailydata) => ({
    lead_id: dailydata.trip_id,
    id: analytics12.indexOf(dailydata),
    name: dailydata.cust_name,
    dest:dailydata.lead_destination,
    lead_owner: dailydata.trip_owner,
    talk_time: parseInt(dailydata.callrecord.outbound_sec),
    effective: parseInt(dailydata.callrecord.outbound_sec)>120?true:false,
    disconnected_by:dailydata.callrecord.hangup_cause,
    audit:dailydata.audit,
    caller:dailydata.callrecord.answered_agent_name,
    customer:dailydata.callrecord.call_to_number+" ("+dailydata.callrecord.duration+")",
    call_time:dailydata.callrecord.start_stamp,
    qs:"callrecord" in dailydata && "call_type" in dailydata.callrecord?getqs(dailydata.callrecord):"",
    audit_date:dailydata.callrecord.audit_date,
     tl:gettl(dailydata.trip_owner),
         opening_script:parseInt(dailydata.callrecord.opening_script)?Number((parseInt(dailydata.callrecord.opening_script)/5).toFixed(2)):"",
    closing_script:parseInt(dailydata.callrecord.closing_script)?Number((parseInt(dailydata.callrecord.closing_script)/5).toFixed(2)):"",
    // hold_script:parseInt(dailydata.callrecord.hold_script)?Number((parseInt(dailydata.callrecord.hold_script)/3).toFixed(2)):"",
    interruption:parseInt(dailydata.callrecord.interruption)?Number((parseInt(dailydata.callrecord.interruption)/3).toFixed(2)):"",
    rate_of_speech:parseInt(dailydata.callrecord.rate_of_speech)?Number((parseInt(dailydata.callrecord.rate_of_speech)/3).toFixed(2)):"",
    // personalization: parseInt(dailydata.callrecord.personalization)?Number((parseInt(dailydata.callrecord.personalization)/3).toFixed(2)):"",
    tone:parseInt(dailydata.callrecord.tone)?Number((parseInt(dailydata.callrecord.tone)/3).toFixed(2)):"",
    language:parseInt(dailydata.callrecord.language)?Number((parseInt(dailydata.callrecord.language)/3).toFixed(2)):"",
    fillers:parseInt(dailydata.callrecord.fillers)?Number((parseInt(dailydata.callrecord.fillers)/5).toFixed(2)):"",
    // active_listening:parseInt(dailydata.callrecord.active_listening)?Number((parseInt(dailydata.callrecord.active_listening)/7).toFixed(2)):"",
    // rapport:parseInt(dailydata.callrecord.rapport)?Number((parseInt(dailydata.callrecord.rapport)/7).toFixed(2)):"",
    empathy:parseInt(dailydata.callrecord.empathy)?Number((parseInt(dailydata.callrecord.empathy)/3).toFixed(2)):"",
    // basic_information:parseInt(dailydata.callrecord.basic_information)?Number((parseInt(dailydata.callrecord.basic_information)/10).toFixed(2)):"",
    // explanation:parseInt(dailydata.callrecord.explanation)?Number((parseInt(dailydata.callrecord.explanation)/10).toFixed(2)):"",
    guidance:parseInt(dailydata.callrecord.guidance)?Number((parseInt(dailydata.callrecord.guidance)/20).toFixed(2)):"",
    // sales_pitch:parseInt(dailydata.callrecord.sales_pitch)?Number((parseInt(dailydata.callrecord.sales_pitch)/10).toFixed(2)):"",
    closing:parseInt(dailydata.callrecord.closing)?Number((parseInt(dailydata.callrecord.closing)/10).toFixed(2)):"",
    oh_delay:parseInt(dailydata.callrecord.oh_delay)?Number((parseInt(dailydata.callrecord.oh_delay)/8).toFixed(2)):"",
    oh_price:parseInt(dailydata.callrecord.oh_price)?Number((parseInt(dailydata.callrecord.oh_price)/8).toFixed(2)):"",
    oh_probing:parseInt(dailydata.callrecord.oh_probing)?Number((parseInt(dailydata.callrecord.oh_probing)/8).toFixed(2)):"",
    oh_permission:parseInt(dailydata.callrecord.oh_permission)?Number((parseInt(dailydata.callrecord.oh_permission)/8).toFixed(2)):"",
    oh_trust:parseInt(dailydata.callrecord.oh_trust)?Number((parseInt(dailydata.callrecord.oh_trust)/8).toFixed(2)):"",
    improvement:dailydata.callrecord.improvement,
    description:dailydata.callrecord.description,
  }));

  const analyticsdatalistdisplay11 = analytics14.map((dailydata) => ({
    lead_id: dailydata.lead_id,
    id: analytics14.indexOf(dailydata),
    name: dailydata.name,
    lead_owner: dailydata.lead_owner,
    call1:dailydata.call1,
    call2:dailydata.call2,
    call3:dailydata.call3, 
    canc_reason:dailydata.canc_reason,
    skip_second_call: dailydata.skip_second_call,
  }));


  ////-------------------------------------------looping function ----------------------------------------

  ////------------------------------------------ConvwithoutHot-----------------------------------------------
  const convwithouthot = async () => {
    try{
    const thirtydaysago = DateCalc(-30);
    const todaydate = DateCalc(0);
    const data = await searchconvTripsbyDate(thirtydaysago, todaydate);
    console.log(data)
    // var list = [];
    // var uniq = [];
    // if (data.data.length !== 0) {
    //   for (let i = 0; i < data.data.length; i++) {
    //     var select = [];
    //     const sh = data.data[i].status_history
    //       ? data.data[i].status_history
    //       : false;
    //     if (sh) {
    //       select = sh.map((status) =>
    //         status.new_status == "Hot" ? true : false
    //       );
    //       for (let j = 0; j < select.length; j++) {
    //         if (select[j] == false) {
    //           list.push(data.data[i].trip_id);
    //         }
    //       }
    //     }
    //     // console.log(list)
    //     uniq = [...new Set(list)];
    //     // console.log(uniq)
    //   }
    //   // console.log(finaltriplist)
    //   alert(
    //     "Trips converted without being marked Hot:\n" + uniq.map((trip) => trip)
    //   );
    // } else {
    //   alert("No trips found");
    // }
  }catch(err){
    console.log(err)
  }
  };

  ////-------------------------------------------email ----------------------------------------
  var now = new Date();
  //console.log(now)
  const emaillist = [
    "amit.singh@jetovacations.com",
    "abhishek.sharma@jetovacations.com",
    // "narpal.singh@jetovacations.com",
  ];
  init("user_DawJtilWyUWk4z5iay4qV");
  function sendmail() {
    handlefunnelSearch();
    //console.log("working")
    for (let i = 0; i < analytics4.length; i++) {
      var templateParams = {
        email: emaillist[i],
        today_date: now.toString(),
        today_time: now
          .toLocaleString("en-IN")
          .toString()
          .split(",")
          .slice(1, 2),
        to_name: analytics4[i].employee,
        la: analytics4[i].daily_lead,
        cc: analytics4[i].daily_cust,
        tc: analytics4[i].daily_trips,
        canct: analytics4[i].daily_canc_trips,
        convt: analytics4[i].daily_conv_trips,
        hott: analytics4[i].daily_hot_trips,
        qc: analytics4[i].daily_quotes,
        qe: analytics4[i].daily_edit_quotes,
        fup: analytics4[i].daily_fup,
        //   };
      };

      emailjs.send("gmail", "template_su5aekc", templateParams).then(
        function (response) {
          console.log("SUCCESS!", response.status, response.text);
        },
        function (error) {
          console.log("FAILED...", error);
        }
      );
    }
  }
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  
  const handletripdateanalytics=async()=>{
    try{
    let startdate= prompt("Enter start date in format yyyy-mm-dd:");
    let enddate= prompt("Enter end date in format yyyy-mm-dd:");
    let param= prompt("Enter 1 for all, enter 2 for HQ leads or enter 3 for Converted trips");
    let resultobject={}
    var leadarr=[], triparr=[]
    if(param==3){
      const data2 = await searchconvTripsbyDate(
        startdate, enddate
      );
      const temp2=removeDuplicates2(data2.data, "trip_id")
      triparr=[...temp2]
      for(let i=0;i<triparr.length; i++){
        var temp=triparr[i];
        temp.diff=(new Date(triparr[i].trip_start_date).getTime()-new Date(triparr[i].createdAt).getTime())/(1000*60*60*24);
        if(temp.diff<=15){
          temp.category="Less or equal to 15"
        }else if(temp.diff>15 && temp.diff<=30){
          temp.category="Between 16 and 30"
        }else if(temp.diff>30 && temp.diff<60){
          temp.category="Between 31 and 60"
        }else if(temp.diff>60 && temp.diff<90){
          temp.category="Between 61 and 90"
        }else if(temp.diff>90 && temp.diff<120){
          temp.category="Between 91 and 120"
        }else if(temp.diff>120 && temp.diff<180){
          temp.category="Between 120 and 180"
        }else{
          temp.category="Greater than 180"
        }
        triparr[i]=temp
      }
      const result2=groupBy(triparr, v=>v.category)
      for (let [key, value] of result2) {
        //console.log(key + " = " + value.length);
        resultobject[key]="Percentage:"+Math.round(value.length/leadarr.length*100)+" || Number:"+value.length
        }
        alert(JSON.stringify(resultobject, null, 4));

    }else{
      const data2 = await searchLeadsbyDate(
        startdate, enddate
      );
      if(param==1){
        leadarr=[...data2.data]
      }else if(param==2){
        leadarr=data2.data.filter(lead=>newgetqualitylead(lead) !=="Iron" && newgetqualitylead(lead) !=="Copper" && newgetqualitylead(lead) !=="Silver")
      }
      for(let i=0;i<leadarr.length; i++){
        var temp=leadarr[i];
        temp.diff=(new Date(leadarr[i].lead_travel_date).getTime()-new Date(leadarr[i].createdAt).getTime())/(1000*60*60*24);
        if(temp.diff<=15){
          temp.category="Less or equal to 15"
        }else if(temp.diff>15 && temp.diff<=30){
          temp.category="Between 16 and 30"
        }else if(temp.diff>30 && temp.diff<60){
          temp.category="Between 31 and 60"
        }else if(temp.diff>60 && temp.diff<90){
          temp.category="Between 61 and 90"
        }else if(temp.diff>90 && temp.diff<120){
          temp.category="Between 91 and 120"
        }else if(temp.diff>120 && temp.diff<180){
          temp.category="Between 120 and 180"
        }else{
          temp.category="Greater than 180"
        }
        leadarr[i]=temp
      }
  
      //console.log(leadarr)
      const result2=groupBy(leadarr, v=>v.category)
      for (let [key, value] of result2) {
        //console.log(key + " = " + value.length);
        resultobject[key]="Percentage:"+Math.round(value.length/leadarr.length*100)+" || Number:"+value.length
        }
        alert(JSON.stringify(resultobject, null, 4));
    }
    
   
    

   
    }catch(err){
      console.log(err)
    }
  }

  const handleleadcancelanalytics=async()=>{
    try{
    let startdate= prompt("Enter start date in format yyyy-mm-dd:");
    let enddate= prompt("Enter end date in format yyyy-mm-dd:");
    let resultobject={}
    const data2 = await searchLeadsbyDate(
      startdate, enddate
    );

    const result2=groupBy(data2.data, v=>v.canc_reason)
    for (let [key, value] of result2) {
      //console.log(key + " = " + value.length);
      resultobject[key]="Percentage:"+Math.round(value.length/data2.data.length*100)+" || Number:"+value.length
      }
      alert(JSON.stringify(resultobject, null, 4));
    }catch(err){
      console.log(err)
    }
  }

  const handleipanalytics=async()=>{
    try{
    let startdate= prompt("Enter start date in format yyyy-mm-dd:");
    let enddate= prompt("Enter end date in format yyyy-mm-dd:");
    let resultobject={}
    const data2 = await searchLeadsbyDate(
      startdate, enddate
    );

    //const data4=data2.data.filter(lead => lead.lead_platform=="Meta" && lead.canc_reason && lead.canc_reason_notes !=="Duplicate" && lead.canc_reason_notes !=="duplicate")
    const data4=data2.data.filter(lead => lead.ip && lead.current_url !=="https://www.jetovacations.com/quoterequestpoptin" && lead.current_url !=="https://www.jetovacations.com/quoterequestsource")
    const result2=groupBy(data4, v=>v.ip)
    for (let [key, value] of result2) {
      if(value.length>2){//console.log(key + " = " + value.length);
      resultobject[key]=value.length
      }
      }
      alert(JSON.stringify(resultobject, null, 4));
    }catch(err){
      console.log(err)
    }
  }

  const handleconvanalytics=async()=>{
    try{
    let startdate= prompt("Enter start date in format yyyy-mm-dd:");
    let enddate= prompt("Enter end date in format yyyy-mm-dd:");
    let resultobject={}
    let resultobject2={}
    const data = await searchconvTripsbyDate(
      startdate, enddate
    );
    //console.log(data.data)
    //const data4=data2.data.filter(lead => lead.lead_platform=="Meta" && lead.canc_reason && lead.canc_reason_notes !=="Duplicate" && lead.canc_reason_notes !=="duplicate")
    const data3=data.data.filter(trip => "booking" in trip && "transfer_state" in trip.booking)
 
    const result2=groupBy(data3, v=>v.booking.transfer_state)
    for (let [key, value] of result2) {
      resultobject[key]=value.length
      resultobject2[key]=Math.round(value.length/data3.length*100)
      }
      alert(JSON.stringify(resultobject, null, 4));
      alert(JSON.stringify(resultobject2, null, 4))
    }catch(err){
      console.log(err)
    }
  }

  const handlehotanalytics=async()=>{
    try{
    let startdate= prompt("Enter start date in format yyyy-mm-dd:");
    let enddate= prompt("Enter end date in format yyyy-mm-dd:");
    let resultobject={}
    let resultobject2={}
    const data = await searchhotTripsbyDate(
      startdate, enddate
    );
    //const data4=data2.data.filter(lead => lead.lead_platform=="Meta" && lead.canc_reason && lead.canc_reason_notes !=="Duplicate" && lead.canc_reason_notes !=="duplicate")
    const data3=data.data.filter(trip => trip.lead)
    const data4=data3.filter(trip => trip.lead.lead_status)
    const result2=groupBy(data4, v=>v.lead.lead_status)
    for (let [key, value] of result2) {
      resultobject[key]=value.length
      resultobject2[key]=Math.round(value.length/data4.length*100)
      }
      alert(JSON.stringify(resultobject, null, 4));
      alert(JSON.stringify(resultobject2, null, 4))
    }catch(err){
      console.log(err)
    }
  }

  const handlecancanalytics=async()=>{
    try{
    let typetrip= prompt("Enter 1 for total and 2 for Hot");
    let startdate= prompt("Enter start date in format yyyy-mm-dd:");
    let enddate= prompt("Enter end date in format yyyy-mm-dd:");
    let mode=prompt("Enter 1 for sales person wise report, 2 for destination wise report, 3 for total")
    var data
    if(typetrip==1){
    data = await searchcancTripsbyDate(
      startdate, enddate
      //"2023-03-01","2023-04-01"
    );
  }else{
    data = await searchhotTripsbyDate(
      startdate, enddate
      //"2023-03-01","2023-04-01"
    );
  }
    console.log(data.data.length)
    //const data4=data2.data.filter(lead => lead.lead_platform=="Meta" && lead.canc_reason && lead.canc_reason_notes !=="Duplicate" && lead.canc_reason_notes !=="duplicate")
    //const data3=data.data.filter(trip => trip.trip_canc_reason_short=="Demand cannot be met")
    //const data3=data.data.filter(trip => trip.trip_canc_reason_short=="No response")
    if(mode==1){
    for(let i=0; i<splist.length; i++) {
      let resultobject={}
      console.log(splist[i])
    const data3=data.data.filter(trip => trip.canc_reason && trip.trip_owner==splist[i])
    console.log(data3)
    //const result2=groupBy(data3, v=>new Date(v.trip_start_date).getMonth())
    if(data3.length>0){
    const result2=groupBy(data3, v=>v.canc_reason)
    for (let [key, value] of result2) {
      // const temp={
      //   name:
      // }
      resultobject[key]=Math.round(value.length/data3.length*100)
      }
      console.log(resultobject)
      // alert(splist[i]);
      // alert(JSON.stringify(resultobject, null, 4));
    }
    }
  }else if(mode==2){
    for(let i=0; i<dest.length; i++) {
      let resultobject={}
      console.log(dest[i])
    const data3=data.data.filter(trip => trip.canc_reason && trip.primary_destination==dest[i])
    console.log(data3)
    //const result2=groupBy(data3, v=>new Date(v.trip_start_date).getMonth())
    if(data3.length>0){
    const result2=groupBy(data3, v=>v.canc_reason)
    for (let [key, value] of result2) {
      // const temp={
      //   name:
      // }
      resultobject[key]=Math.round(value.length/data3.length*100)
      }
      console.log(resultobject)
      // alert(splist[i]);
      // alert(JSON.stringify(resultobject, null, 4));
    }
    }
  }else{
    let resultobject={}
    const data3=data.data.filter(trip => trip.canc_reason)
    console.log(data3.length)
    if(data3.length>0){
    const result2=groupBy(data3, v=>v.canc_reason)
    //console.log(result2)
    for (let [key, value] of result2) {
      // const temp={
      //   name:
      // }
      resultobject[key]=Math.round(value.length/data3.length*100)
      }
      console.log(resultobject)
    }
  }
    }catch(err){
      console.log(err)
    }
  }

  const handleboanalytics=async()=>{
    try{
    let startdate= prompt("Enter start date in format yyyy-mm-dd:");
    let enddate= prompt("Enter end date in format yyyy-mm-dd:");
    let resultobject={}
    const data = await searchboTripsbyDate(
      startdate, enddate
      //"2022-12-01","2022-12-31"
    );
    //const data4=data2.data.filter(lead => lead.lead_platform=="Meta" && lead.canc_reason && lead.canc_reason_notes !=="Duplicate" && lead.canc_reason_notes !=="duplicate")
    //const data3=data.data.filter(trip => trip.trip_canc_reason_short=="Demand cannot be met")
    //const data3=data.data.filter(trip => trip.trip_canc_reason_short)
    const result2=groupBy(data.data, v=>v.primary_destination)
    for (let [key, value] of result2) {
      //resultobject[key]=value.length
      resultobject[key]=Math.round(value.length/data.data.length*100)
      }
      alert(JSON.stringify(resultobject, null, 4));
    }catch(err){
      console.log(err)
    }
  }

  const handlesourceanalytics=async()=>{
    try{
    let startdate= prompt("Enter start date in format yyyy-mm-dd:");
    let enddate= prompt("Enter end date in format yyyy-mm-dd:");
    let cat= prompt("Enter 1 for total and 2 for destination wise");
    let resultobject={}
    const data2 = await searchLeadsbyDate(
      startdate, enddate
      //"2022-10-01","2022-12-31"
    );
    if(cat==1){
    //const data4=data2.data.filter(lead => lead.lead_platform=="Meta" && lead.canc_reason && lead.canc_reason_notes !=="Duplicate" && lead.canc_reason_notes !=="duplicate")
    const data4=data2.data.filter(lead => lead.lead_source_airport)
    const result2=groupBy(data4, v=>v.lead_source_airport)
    for (let [key, value] of result2) {
      //resultobject[key]=value.length
      resultobject[key]=value.length+" ("+Math.round(value.length/data4.length*100)+")"
      }
      alert(JSON.stringify(resultobject, null, 4));
    }else{
      for(let i=0; i<dest.length; i++) {
        const data4=data2.data.filter(lead => lead.lead_source_airport && lead.lead_destination==dest[i])
        const result2=groupBy(data4, v=>v.lead_source_airport)
        for (let [key, value] of result2) {
          //resultobject[key]=value.length
          resultobject[key]=value.length+" ("+Math.round(value.length/data4.length*100)+")"
          }
          console.log(resultobject)
      }
    }
    // const data = await searchconvTripsbyDate(
    //   "2022-10-01",
    //   "2022-12-30"
    // );
    // const data3=data.data.filter(lead => lead.lead && lead.lead.lead_status) 
    // const result=groupBy(data3, v=>v.lead.lead_status)
    //setcreatedleadData(data2.data);
  }catch(err){
    console.log(err)
  }
    //console.log(result)
  }

  const handlepaxanalytics=async()=>{
    try{
    let startdate= prompt("Enter start date in format yyyy-mm-dd:");
    let enddate= prompt("Enter end date in format yyyy-mm-dd:");
    let param= prompt("Enter 1 for all, enter 2 for HQ leads, enter 3 for Converted trips or enter 4 for Destination leads created");
    if(param==4){
      let dest= prompt("Enter destination:");
      let resultobject={}
      const data2 = await searchLeadsbyDate(
        startdate, enddate
        //"2022-10-01","2022-12-31"
      );
  
      //const data4=data2.data.filter(lead => lead.lead_platform=="Meta" && lead.canc_reason && lead.canc_reason_notes !=="Duplicate" && lead.canc_reason_notes !=="duplicate")
      const data4=data2.data.filter(lead => lead.number_adults && lead.lead_destination==dest)
      const result2=groupBy(data4, v=>v.number_adults)
      for (let [key, value] of result2) {
        //resultobject[key]=value.length
        resultobject[key]=value.length+" ("+Math.round(value.length/data4.length*100)+"%)"
        }
        alert(JSON.stringify(resultobject, null, 4));
    }else if(param==3){
      let resultobject={}
      const data2 = await searchconvTripsbyDate(
        startdate, enddate
        //"2022-10-01","2022-12-31"
      );
  
      //const data4=data2.data.filter(lead => lead.lead_platform=="Meta" && lead.canc_reason && lead.canc_reason_notes !=="Duplicate" && lead.canc_reason_notes !=="duplicate")
      const data4=data2.data.filter(lead => lead.number_adults)
      const result2=groupBy(data4, v=>v.number_adults)
      for (let [key, value] of result2) {
        //resultobject[key]=value.length
        resultobject[key]=value.length+" ("+Math.round(value.length/data4.length*100)+"%)"
        }
        alert(JSON.stringify(resultobject, null, 4));

    }else{

      let resultobject={}
      const data2 = await searchLeadsbyDate(
        startdate, enddate
        //"2022-10-01","2022-12-31"
      );
  
      //const data4=data2.data.filter(lead => lead.lead_platform=="Meta" && lead.canc_reason && lead.canc_reason_notes !=="Duplicate" && lead.canc_reason_notes !=="duplicate")
      const data4=data2.data.filter(lead => lead.lead_pax)
      const result2=groupBy(data4, v=>v.lead_pax)
      for (let [key, value] of result2) {
        //resultobject[key]=value.length
        resultobject[key]=value.length+" ("+Math.round(value.length/data4.length*100)+"%)"
        }
        alert(JSON.stringify(resultobject, null, 4));
    }
   
    // const data = await searchconvTripsbyDate(
    //   "2022-10-01",
    //   "2022-12-30"
    // );
    // const data3=data.data.filter(lead => lead.lead && lead.lead.lead_status) 
    // const result=groupBy(data3, v=>v.lead.lead_status)
    //setcreatedleadData(data2.data);
  }catch(err){
    console.log(err)
  }
    //console.log(result)
  }

  const handlebudgetanalytics=async()=>{
    try{
    let startdate= prompt("Enter start date in format yyyy-mm-dd:");
    let enddate= prompt("Enter end date in format yyyy-mm-dd:");
    let param= prompt("Enter 1 for all, enter 2 for HQ leads or enter 3 for Destination leads created");
    let param2= prompt("Enter 1 for all, enter 2 for With Flight and enter 3 for Without Flight");
    if(param==3){
      let dest= prompt("Enter destination:");
      let resultobject={}
      const data2 = await searchLeadsbyDate(
        startdate, enddate
        //"2022-10-01","2022-12-31"
      );
  
      //const data4=data2.data.filter(lead => lead.lead_platform=="Meta" && lead.canc_reason && lead.canc_reason_notes !=="Duplicate" && lead.canc_reason_notes !=="duplicate")
      var data4=data2.data.filter(lead => lead.lead_budget && lead.lead_budget!=="" && lead.lead_destination==dest)
      if(param2==1){
        data4=data4.filter(lead=>lead.lead_budget.contains("without flight"))
      }else if(param2==2){
        data4=data4.filter(lead=>lead.lead_budget.contains("with flight"))
      }
      const result2=groupBy(data4, v=>v.lead_budget)
      for (let [key, value] of result2) {
        //resultobject[key]=value.length
        resultobject[key]=value.length+" ("+Math.round(value.length/data4.length*100)+"%)"
        }
        alert(JSON.stringify(resultobject, null, 4));
    }else{

      let resultobject={}
      const data2 = await searchLeadsbyDate(
        startdate, enddate
        //"2022-10-01","2022-12-31"
      );
  
      //const data4=data2.data.filter(lead => lead.lead_platform=="Meta" && lead.canc_reason && lead.canc_reason_notes !=="Duplicate" && lead.canc_reason_notes !=="duplicate")
      var data4=data2.data.filter(lead => lead.lead_budget && lead.lead_budget!=="")
      if(param2==1){
        data4=data4.filter(lead=>lead.lead_budget.contains("without flight"))
      }else if(param2==2){
        data4=data4.filter(lead=>lead.lead_budget.contains("with flight"))
      }
      const result2=groupBy(data4, v=>v.lead_budget)
      for (let [key, value] of result2) {
        //resultobject[key]=value.length
        resultobject[key]=value.length+" ("+Math.round(value.length/data4.length*100)+"%)"
        }
        alert(JSON.stringify(resultobject, null, 4));
    }
   
    // const data = await searchconvTripsbyDate(
    //   "2022-10-01",
    //   "2022-12-30"
    // );
    // const data3=data.data.filter(lead => lead.lead && lead.lead.lead_status) 
    // const result=groupBy(data3, v=>v.lead.lead_status)
    //setcreatedleadData(data2.data);
  }catch(err){
    console.log(err)
  }
    //console.log(result)
  }

  const fupanalytics=async()=>{
    try{
    const data2 = await fetchtodayfup()
    let fup=[]
    let resultobject={}
    // const f = data2.data.filter(
    //   (tripdata) =>
    //     tripdata.follow_up.filter(
    //       (fup) => fup.fupautonote=="Call not picked and no response on Whatsapp" && fup.status == "Open"
    //     ).length > 0
    // );
    for (let i=0; i<data2.data.length; i++){
      if(data2.data[i].follow_up){
        for(let j=0;j<data2.data[i].follow_up.length;j++){
          if(data2.data[i].follow_up[j].status=="Open"){
            fup.push(data2.data[i].follow_up[j])
          }
        }
      }
    }
    // const data4=data2.data.filter(lead => lead.lead_platform=="Meta" && lead.canc_reason && lead.canc_reason_notes !=="Duplicate" && lead.canc_reason_notes !=="duplicate")
    const result2=groupBy(fup, v=>v.notes)
    for (let [key, value] of result2) {
      //console.log(key + " = " + value.length);
      resultobject[key]=value.length
      }
    // const data = await searchconvTripsbyDate(
    //   "2022-10-01",
    //   "2022-12-30"
    // );
    // const data3=data.data.filter(lead => lead.lead && lead.lead.lead_status) 
    // const result=groupBy(data3, v=>v.lead.lead_status)
    //setcreatedleadData(data2.data);
    alert(JSON.stringify(resultobject, null, 4));
  }catch(err){
    console.log(err)
  }
    //console.log(result)
  }

  const overrideanalytics=async()=>{
    try{
      let startdate= prompt("Enter start date in format yyyy-mm-dd:");
      let enddate= prompt("Enter end date in format yyyy-mm-dd:");
      const data2=await fetchfupbydate(startdate, enddate)
    const data=await overrideTripsbyDate(startdate, enddate)
    console.log(data.data)
    let text=""
      for(let i=0;i<splist.length;i++){
        text=text+splist[i]+"\n"
        const temp=data.data.filter(t=>t.trip_owner==splist[i])
        const temp3=data2.data.filter(t=>t.trip_owner==splist[i])
        text=text+"Total Trips: "+temp3.length+" || "
        text=text+"Total Override Trips: "+temp.length+" || "
        text=text+"Total Override Trips %: "+Math.round(temp.length/temp3.length*100)+" || "
        const temp2=data.data.filter(t=>t.trip_owner==splist[i] && (t.follow_up.fupautonote=="Discussion going on over WA" || t.follow_up.fupautonote=="Waiting for rates" || t.follow_up.fupautonote=="Asked to call at a specific time"))
        text=text+"Invalid Reasons: "+(temp.length-temp2.length)+" || "
        text=text+"Invalid %: "+Math.round((temp.length-temp2.length)/temp.length*100)+"\n"
      }
      console.log(text)
      alert(text)
  }catch(err){
    console.log(err)
  }
  }

  const hotfupanalytics=async()=>{
    try{
    let startdate= prompt("Enter start date in format yyyy-mm-dd:");
    let enddate= prompt("Enter end date in format yyyy-mm-dd:");
    const data2 = await searchhotTripsbyDate(
      startdate,
      enddate
    );
    let resultobject={}
    let fup=[]
    for (let i=0; i<data2.data.length; i++){
      if(data2.data[i].follow_up){
        for(let j=0;j<data2.data[i].follow_up.length;j++){
          if(data2.data[i].follow_up[j].status=="Open"){
            fup.push(data2.data[i].follow_up[j])
          }
        }
      }
    }
    // const data4=data2.data.filter(lead => lead.lead_platform=="Meta" && lead.canc_reason && lead.canc_reason_notes !=="Duplicate" && lead.canc_reason_notes !=="duplicate")
    const result2=groupBy(fup, v=>v.notes)
    for (let [key, value] of result2) {
      //console.log(key + " = " + value.length);
      resultobject[key]=value.length
      }
    // const data = await searchconvTripsbyDate(
    //   "2022-10-01",
    //   "2022-12-30"
    // );
    // const data3=data.data.filter(lead => lead.lead && lead.lead.lead_status) 
    // const result=groupBy(data3, v=>v.lead.lead_status)
    //setcreatedleadData(data2.data);
    alert(JSON.stringify(resultobject, null, 4));
  }catch(err){
    console.log(err)
  }
    //console.log(result)
  }

  const handlerefleads = async (e) => {
    try{
    let startdate= prompt("Enter start date in format yyyy-mm-dd:");
    let enddate= prompt("Enter end date in format yyyy-mm-dd:");
    const data2 = await fetchReftrips(
      startdate,
      enddate
    ); 
   
    const refconv=data2.data.filter(trip =>  (trip.trip_status=="Converted"||trip.trip_status=="Closed"))  
    alert("Referral leads:"+data2.data.length+"\nReferral Converted leads:"+refconv.length+"\nReferral L2C:"+(refconv.length/data2.data.length).toFixed(2))
  }catch(err){
    console.log(err)
  }
    //console.log()
  };

  const handleprogSearch=()=>{
    alert(progtrip)
  }

  function groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
         const key = keyGetter(item);
         const collection = map.get(key);
         if (!collection) {
             map.set(key, [item]);
         } else {
             collection.push(item);
         }
    });
    return map;
}

const loaddata=async()=>{
  try{
  const data=await fetchpotentialhot()
  console.log(data.data)
  var hot=data.data.filter(q=> q.trip_status=="Active" && (new Date(q.trip_start_date).getTime()-new Date().getTime())/(1000*60*60*24*7)>1)
  var hot2=hot.filter(h=> ("edit_count" in h) && h.edit_count>2)
  console.log(hot2)
  var hot3 = hot2.map(function(i) {
    return i.trip_id;
  });
  var hot4=removeDuplicates3(hot3)
  //console.log(hot3)
  alert(hot4.toString())
}catch(err){
  console.log(err)
}
}

function removeDuplicates3(arr) {
  return arr.filter((item, 
      index) => arr.indexOf(item) === index);
}

const loadqe=async()=>{
  try{
  let enddate=DateCalc(0)
  let startdate=DateCalc(-1)
  let finarr=[]
  const data=await newsearchQEbyDate(startdate, enddate)
  for(let i=0; i<splist.length; i++) {
    var hot2=data.data.filter(q=> q.trip_status=="Active" && q.trip_owner==splist[i])
    var hot3 = hot2.map(function(i) {
      return i.trip_id;
    });
    var hot4=removeDuplicates(hot3)
    const tempobj={
      name:splist[i],
      trips:hot4.toString()
    }
    finarr.push(tempobj)
  }
  
  // var hot2=hot.filter(h=> ("edit_count" in h) && h.edit_count>2)
  // console.log(hot2)
 
  //console.log(hot3)
  alert(JSON.stringify(finarr))
}catch(err){
  console.log(err)
}
}

const handleecanalytics=async() => {
  let leadarr2=[], triparr2=[]
  const data12 = await fetchupdatedtodaytrips();
      setlistupdatedtripData(data12.data);
      console.log(data12.data.length);
      // for(let i=0;i<500;i++){
      //   console.log(data12.data[i])
      // }
      const updatedtrips=data12.data.filter(trip=> "callrecord" in trip && trip.callrecord.length>0) ;
      console.log(updatedtrips.length)
      for(let i=0; i<updatedtrips.length; i++){
        for(let j=0; j<updatedtrips[i].callrecord.length;j++){
          if(new Date(updatedtrips[i].callrecord[j].start_stamp).getTime()>=new Date(todayDate).getTime()){
            // if(i<5){
            //   console.log(updatedtrips[i])
            // }
           
            if(updatedtrips[i].callrecord[j].call_status=="answered"){
              if(parseInt(updatedtrips[i].callrecord[j].outbound_sec)>120){
                //console.log(updatedtrips[i].trip_id)
                const temp={
                  owner:updatedtrips[i].trip_owner,
                  id:updatedtrips[i].trip_id
                }
                triparr2=[...triparr2,temp]
              }
            }
            
          }
          
       
  }
}
      console.log(triparr2)
      settriparr(triparr2)
      setopen7(true)

      const data13 = await fetchtodayupdatedleads();
      setlistupdatedleadData(data13.data);
      console.log(data13.data.length);
      const updatedleads=data13.data.filter(lead=> "callrecord" in lead && lead.callrecord.length>0) ;
for(let i=0; i<updatedleads.length; i++){
  for(let j=0; j<updatedleads[i].callrecord.length;j++){
    if(new Date(updatedleads[i].callrecord[j].start_stamp).getTime()>=new Date(todayDate).getTime()){
  
      if(updatedleads[i].callrecord[j].call_status=="answered"){
     
        if(parseInt(updatedleads[i].callrecord[j].outbound_sec)>120){
          const temp={
            owner:updatedleads[i].lead_owner,
            id:updatedleads[i].lead_id,
          }
          // triparr=[...triparr,temp]
          leadarr2=[...leadarr2,temp]
        }
      }
      
    }
    
 
}
}
console.log(leadarr2)
setleadarr(leadarr2)
    
}

const handleClose7=()=>{
  setopen7(false)
}

const handlepotSearch = async (e) => {
  try{
    let startdate= prompt("Enter start date in format yyyy-mm-dd:");
    let enddate= prompt("Enter end date in format yyyy-mm-dd:");
  if (startdate && enddate) {
    const data = await searchpotentialTripsbyDate(
      startdate,
      enddate,
    );
    alert(data.data.length)
    const temp=data.data.filter(trip=>trip.trip_status=="Converted" || trip.trip_status=="Closed" || trip.trip_status=="Dropped After Booking")
    alert(temp.length)
    alert((temp.length)/(data.data.length)*100)

    console.log(data.data)
  } else {
    alert(
      "Please enter all parameters -destination, start date and end date before search"
    );
  }
}catch(err){
  console.log(err)
}
};

const handlecalldataSearch=async (e) =>{
  try{
  let startdate= prompt("Enter start date in format yyyy-mm-dd:");
  let enddate= prompt("Enter end date in format yyyy-mm-dd:");
  var  triparr=[]
  const data=await fetchtripcallbydate(startdate, enddate)
  console.log(data.data.length)
  for(let i=0; i<data.data.length; i++){
    if(data.data[i].callrecord.call_status=="answered"){
      if(parseInt(data.data[i].callrecord.outbound_sec)>120){
        triparr=[...triparr, data.data[i]]
      }
    } 
  }
  console.log(triparr.length)
  const triparr2=removeDuplicates(triparr, "trip_id")
  alert(triparr2.length)
  const temp=triparr2.filter(trip=>trip.trip_status=="Converted" || trip.trip_status=="Closed" || trip.trip_status=="Dropped After Booking")
  alert(temp.length)
  alert((temp.length)/(triparr2.length)*100)
}catch(err){
  console.log(err)
}
}

const handlefirstcalldataSearch=async (e) =>{
  try{
  let startdate= prompt("Enter start date in format yyyy-mm-dd:");
  let enddate= prompt("Enter end date in format yyyy-mm-dd:");
  var  leadarr=[]
  const data=await fetchleadcallbydate(startdate, enddate)
  for(let i=0; i<data.data.length; i++){
    if(data.data[i].callrecord.call_status=="answered"){
      if(parseInt(data.data[i].callrecord.outbound_sec)>120){
        leadarr=[...leadarr, data.data[i].lead_id]
      }
    } 
  }
  //console.log(leadarr)
  alert(leadarr.length)
  const newenddate=DateCalc2(startdate, 90)
  //console.log(newenddate)
  const data2=await searchconvTripsbyDate(startdate, newenddate)
  //console.log(data2.data)
  const temp=data2.data.filter(trip=>"lead" in trip && "lead_id" in trip.lead)
  var convleadarr=[]
  for(let i=0;i<temp.length;i++){
    convleadarr=[...convleadarr, temp[i].lead.lead_id]
  }
  //console.log(convleadarr)
  var finalarr=[]
  for(let i=0;i<leadarr.length;i++){
    if(convleadarr.includes(leadarr[i])){
      finalarr=[...finalarr, leadarr[i]]
    }
  }
  //console.log(finalarr)
  alert(finalarr.length/leadarr.length*100)
}catch(err){
  console.log(err)
}
}

const handleqedata=async()=>{
 try{
  let startdate= prompt("Enter start date in format yyyy-mm-dd:");
  let enddate= prompt("Enter end date in format yyyy-mm-dd:");

  const data=await searchTripsbyDate(startdate, enddate)
  //console.log(data.data)
  const filterdata=data.data.filter(trip=> "quote" in trip && trip.quote.length>0 && (trip.trip_status=="Cancelled" || trip.trip_status=="Closed" || trip.trip_status=="Converted" || trip.trip_status=="Dropped After Booking" || trip.trip_status=="Booked Outside"))
  console.log(filterdata)
  var triparr=[]
  for(let i=0;i<filterdata.length;i++){
     //for(let i=0;i<5;i++){
    let sum=0
    for(let j=0;j<filterdata[i].quote.length;j++){
      const quoteData=await fetchQuotebyId(filterdata[i].quote[j])
      //console.log(quoteData.data)
      //console.log(i)
      if(quoteData.data.edit_count){
        sum=sum+quoteData.data.edit_count
      }
    }
    const temp={
      count:sum,
      status: data.data[i].trip_status,
      id:data.data[i].trip_id,

    }
  
    triparr=[...triparr, temp]
  }

    console.log(triparr)

    let finarr=[]
   for(let i=0;i<16;i++){
    let sumcanc=0, sumconv=0
    var arr=triparr.filter(data=> data.count==i)
    if(arr.length>0){
      for(let j=0;j<arr.length;j++){
        if(arr[j].status=="Cancelled" || arr[j].status=="Booked Outside"){
          sumcanc++
        }else if(arr[j].status=="Converted" || arr[j].status=="Closed" || arr[j].status=="Dropped After Booking"){
          sumconv++
        }
      }
      const temp={
        count:i,
        conv:sumconv,
        canc:sumcanc,
        conv_per:sumconv/(sumconv+sumcanc),
        canc_per:sumcanc/(sumconv+sumcanc),
      }
      finarr=[...finarr, temp]
    }
   
  }
  console.log(finarr)
 }catch(err){
  console.log(err)
 }
}

const sampleanalytics=async()=>{
  try{
    let startdate= prompt("Enter start date in format yyyy-mm-dd:");
    let enddate= prompt("Enter end date in format yyyy-mm-dd:");

    const data = await searchQCbyDate(
      startdate, enddate);
    console.log(data.data.length)
    const sample=data.data.filter(q=>q.sample_package=="Yes")
    let finarr=[]
    for(let i=0; i<splist.length; i++) {
      var total=data.data.filter(q=> q.trip_owner==splist[i])
      var sq=sample.filter(q=> q.trip_owner==splist[i])
      const tempobj={
        name: splist[i],
        total:total.length,
        sample:sq.length,
        sample_perc:(sq.length/total.length).toFixed(2),
      }
      finarr.push(tempobj)
    }
    
    // var hot2=hot.filter(h=> ("edit_count" in h) && h.edit_count>2)
    // console.log(hot2)
   console.log(finarr)
    //console.log(hot3)
    alert(JSON.stringify(finarr))



  }catch(err){
    console.log(err)
   }
}


const gridcelldoubleclick=(id)=>{
  window.open("/lead/" + id, '_blank');
  //console.log("/custdataentry/"+id);
}

const gridcellclicklead = (id) => {
  window.open("/lead/" + id, "_blank");
  //console.log("/custdataentry/"+id);
};

const gridcellclick = (id) => {
  window.open("/tripdataentry/" + id, "_blank");
  //console.log("/custdataentry/"+id);
};

const findpayment=async()=>{
let a=prompt("Enter Amount:")
const data=await findtripbypayment(a)

console.log(data.data)
}

const getluxurytrips=async()=>{
  const data=await getluxury()
  //console.log(data.data)
  const temp=removeDuplicates2(data.data)
  const temp2=temp.toString()
  await gmailSend("care@jetovacations.com", ["debayan.ghosh@jetovacations.com"], "List of luxury trips", temp.join(", "))
}

const gettripl2c=async()=>{
   try{
    let startdate= prompt("Enter start date in format yyyy-mm-dd:");
    let enddate= prompt("Enter end date in format yyyy-mm-dd:");
    let triptype=prompt("Enter 1 for All, 2 for Hot")
    var data=[]
  if (startdate && enddate) {
    if(triptype=="1"){
    data = await searchTripsbyDate(
      startdate,
      enddate,
    );
  }else{
    data = await searchhotTripsbyDate(
      startdate,
      enddate,
    );
  }
  let numberofdays= prompt("Enter number of days");
  var within=0, without=0
  var convtrips=data.data.filter(trip=>trip.trip_status=="Converted" || trip.trip_status=="Closed" )
    for(let i=0;i<convtrips.length;i++){
      console.log(getconvdate(convtrips[i]))
      console.log((new Date(getconvdate(convtrips[i])).getTime()-new Date(convtrips[i].createdAt).getTime())/(1000*60*60*24*Number(numberofdays)))
      if((new Date(getconvdate(convtrips[i])).getTime()-new Date(convtrips[i].createdAt).getTime())/(1000*60*60*24*Number(numberofdays))<1){
        within++
      }else{
        without++
      }
    }
    console.log(data.data.length)
    console.log(convtrips.length)
    console.log(within/data.data.length*100)
    console.log(without/data.data.length*100)
  }

    }catch(err){
  console.log(err)
    }
}

const fetchactive=async()=>{
  let sd=prompt("Enter date in YYYY-MM-DD format:")
  const fetchactive=await fetchactivetripscount(sd)
  console.log(fetchactive.data)
}

  return (
    <Box sx={{ width: "100%" }}>
      {role && cuser && splist.length > 0 ? (
        <div>
        <Dialog
        fullWidth
        maxWidth="xl"
        open={open7}
        onClose={handleClose7}
      >
      <h3> Trips-{triparr.length}</h3>
      {triparr.map(data=> 
      <p>   {data.owner} -- {data.id}</p>
      )}
      <br></br>
      <h3> Leads-{leadarr.length}</h3>
      {leadarr.map(data=> 
      <p>   {data.owner} -- {data.id}</p>
      )}
      </Dialog>
        <Drawer anchor="left" open={drawer} onClose={()=>setdrawer(false)}>
        <div>
          {analyticsdatalistdisplay3.map(data =>
          <div>
            {data.employee}
            <br></br>
            <ul>
              {data.employee !=="Total" && data.total_trips<100?(<li>Funnel size too low</li>):("")}
              {data.employee !=="Total" && data.total_trips>140?(<li>Funnel size too high</li>):("")}
              {data.hot_trips<(data.active_trips*8/100)?(<li>Hot trips too low</li>):("")}
              {data.hot_trips>(data.active_trips*12/100)?(<li>Hot trips too high</li>):("")}
              {data.postponed_trips<(data.active_trips*2/100)?(<li>Postponed trips too low</li>):("")}
              {data.postponed_trips>(data.active_trips*5/100)?(<li>Postponed trips too high</li>):("")}
              {data.fup_nextday<(data.active_trips*40/100)?(<li>FUPs tomorrow too low</li>):("")}
              {data.fup_share<0.8?(<li>3 day Fup too low</li>):("")}
              {data.fup_share>1?(<li>3 day Fup too high</li>):("")}
              {data.fup_share2<0.95?(<li>7 day Fup too low</li>):("")}
              {data.fup_share2>1.2?(<li>7 day Fup too high</li>):("")}
            </ul>
            <hr></hr>
          </div>
          )}
          <br></br>
          {analyticsdatalistdisplay4.map(data =>
          <div>
            {data.employee}
            <br></br>
            <ul>
            {data.employee !=="Total" && data.daily_lead<8?(<li>Leads assigned too low</li>):("")}
            {data.employee !=="Total" && data.daily_lead>15?(<li>Leads assigned too high</li>):("")}
            {data.daily_cust<(data.daily_lead*85/100)?(<li>Customer created too low</li>):("")}
            {data.daily_cust>(data.daily_lead*120/100)?(<li>Customer created too high</li>):("")}
            {data.daily_trips<(data.daily_lead*80/100)?(<li>Trips created too low</li>):("")}
            {data.daily_trips>(data.daily_lead*120/100)?(<li>Trips created too high</li>):("")}
            {data.employee !=="Total" && data.daily_canc_trips<8?(<li>Cancelled trips too low</li>):("")}
            {data.employee !=="Total" && data.daily_canc_trips>20?(<li>Cancelled trips too high</li>):("")}
            {data.daily_quotes<(data.daily_trips*95/100)?(<li>Quotes created too low</li>):("")}
            {data.daily_quotes>(data.daily_trips*125/100)?(<li>Quotes created too high</li>):("")}
            {data.daily_edit_quotes<(data.daily_fup*5/100)?(<li>Quotes edited too low</li>):("")}
            {data.daily_edit_quotes>(data.daily_fup*15/100)?(<li>Quotes edited too high</li>):("")}
            {data.employee !=="Total" && data.daily_fup<80?(<li>Fups taken too low</li>):("")}
            {data.employee !=="Total" && data.daily_fup>120?(<li>Fups taken too high</li>):("")}
            {data.daily_hot_trips<(data.daily_edit_quotes*10/100)?(<li>Hot marked too low</li>):("")}
            {data.daily_hot_trips>(data.daily_edit_quotes*20/100)?(<li>Hot marked too high</li>):("")}
            </ul>
            <hr></hr>
          </div>
          )}
          </div>
        </Drawer>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              centered
            >
              <Tab label="General View" {...a11yProps(0)} />
              <Tab label="Sidharth" {...a11yProps(1)} />
              <Tab label="Hitesh" {...a11yProps(2)} />
              <Tab label="Yadvinder" {...a11yProps(3)} />
              <Tab label="Tulsi" {...a11yProps(4)} />
              <Tab label="Tarun" {...a11yProps(5)} />
              <Tab label="NitinK" {...a11yProps(6)} />
              <Tab label="Manish" {...a11yProps(7)} />
              <Tab label="Qausain" {...a11yProps(8)} />
              {/* <Tab label="Sightseeing Descriptions" {...a11yProps(2)} /> */}
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
            <Paper variant="outlined" className={classes.paper} elevation={10}>
            {role !=="Sales"?(
            <div align="center">
         
            <Tooltip title="Opens new page where you can search trips by status, owner and update date">
            <Button
                  href="/searchtrip"
                  variant="outlined"
                  color="Primary"
                  className={classes.button}
                >
                  Search Trips
                </Button>

                </Tooltip>
                <Tooltip title="Get luxury trips">
            <Button
                   onClick={preventDoubleClick(getluxurytrips)}
                  variant="outlined"
                  color="Primary"
                  className={classes.button}
                >
                  Get Luxury
                </Button>
                
                </Tooltip>
                 <Tooltip title="Get conv % within x days">
            <Button
                   onClick={preventDoubleClick(gettripl2c)}
                  variant="outlined"
                  color="Primary"
                  className={classes.button}
                >
                  Get Trip L2C
                </Button>
                
                </Tooltip>
                 <Tooltip title="Get snapshot of past funnel">
            <Button
                   onClick={fetchactive}
                  variant="outlined"
                  color="Primary"
                  className={classes.button}
                >
                  Past Funnel
                </Button>
                
                </Tooltip>
                <Tooltip title="Show customer list">
                 <Button href="/listcustdata" variant="outlined"  color="primary" className={classes.button}>View Customer</Button>
                </Tooltip>
                <Tooltip title="Show breakup of leads based on source airports (% wise)">
                <Button
                  onClick={handlesourceanalytics}
                  variant="outlined"
                  color="Primary"
                  className={classes.button}
                >
                  Lead Source
                </Button>

                </Tooltip>
                <Tooltip title="Show trip id of payment amounts">
                <Button
                  onClick={findpayment}
                  variant="outlined"
                  color="Primary"
                  className={classes.button}
                >
                  Find Payment
                </Button>

                </Tooltip>
                <Tooltip title="Show breakup of leads based on number of adults (% wise)">
                <Button
                  onClick={handlepaxanalytics}
                  variant="outlined"
                  color="Primary"
                  className={classes.button}
                >
                  Lead Pax
                </Button>
                </Tooltip>
                <Tooltip title="Show breakup of converted trips by transfer state">
                <Button
                  onClick={handleconvanalytics}
                  variant="outlined"
                  color="Primary"
                  className={classes.button}
                >
                  Converted Analytics
                </Button>
                </Tooltip>
                <Tooltip title="Show breakup of cancelled leads by cancellation reason (% wise)">
                <Button
                  onClick={handlecancanalytics}
                  variant="outlined"
                  color="Primary"
                  className={classes.button}
                >
                  Cancelled Analytics
                </Button>
                </Tooltip>
                <Tooltip title="Show breakup of bo leads by destination (% wise)">
                <Button
                  onClick={handleboanalytics}
                  variant="outlined"
                  color="Primary"
                  className={classes.button}
                >
                  BO Analytics
                </Button>
                </Tooltip>
                <Tooltip title="Show breakup of active trips within specified dates by fup notes ">
                <Button
                  onClick={fupanalytics}
                  variant="outlined"
                  color="Primary"
                  className={classes.button}
                >
                  Fup Analytics
                </Button>
                </Tooltip>
                <Tooltip title="Show breakup of leads by their cancellation reason">
                <Button
                  onClick={handleleadcancelanalytics}
                  variant="outlined"
                  color="Primary"
                  className={classes.button}
                >
                  Lead Cancel Analytics
                </Button>
                </Tooltip>
                <Tooltip title="Show breakup of hot trips within specified dates by fup notes ">
                <Button
                  onClick={hotfupanalytics}
                  variant="outlined"
                  color="Primary"
                  className={classes.button}
                >
                  Hot Fup Analytics
                </Button>
                </Tooltip>
                <Tooltip title="Show ids of duplicate entries in customers, trips, hotels, leads etc.">
                <Button
                  onClick={handledupCheck}
                  align="right"
                  color="Primary"
                  variant="outlined"
                  className={classes.button2}
                >
                  Duplicate Check
                </Button>
                </Tooltip>
                <Tooltip title="Show # of reference trips, their converted numbers and L2C within dates mentioned">
                <Button
                  onClick={handlerefleads}
                  align="right"
                  color="Primary"
                  variant="outlined"
                  className={classes.button2}
                >
                  Referral Leads
                </Button>
                </Tooltip>
                {/* <Tooltip title="Show % of leads in each quality bracket">
                <Button
                  onClick={handleleadanalytics}
                  align="right"
                  color="Primary"
                  variant="outlined"
                  className={classes.button2}
                >
                  Lead quality breakup
                </Button> */}
                {/* </Tooltip> */}
                <Tooltip title="Show trips ids which have potential to be marked as Hot">
                <Button
                  onClick={loaddata}
                  align="right"
                  color="Primary"
                  variant="outlined"
                  className={classes.button2}
                >
                  Potential Hot
                </Button>
                </Tooltip>
                <Tooltip title="Show trips ids of quotes edited yesterday by salespersons">
                <Button
                  onClick={loadqe}
                  align="right"
                  color="Primary"
                  variant="outlined"
                  className={classes.button2}
                >
                  QE yesterday
                </Button>
                </Tooltip>
                <Tooltip title="Show percentage of sample quotes by each sales person">
                <Button
                  onClick={sampleanalytics}
                  align="right"
                  color="Primary"
                  variant="outlined"
                  className={classes.button2}
                >
                 Sample %
                </Button>
                </Tooltip>
                {/* <Tooltip title="Show breakup of converted leads based on ops status">
                <Button
                  onClick={convstatusanalytics}
                  align="right"
                  color="Primary"
                  variant="outlined"
                  className={classes.button2}
                >
                 Converted status breakup
                </Button>
                </Tooltip> */}
                <Tooltip title="Show breakup of leads based on budget mentioned">
                <Button
                  onClick={handlebudgetanalytics}
                  align="right"
                  color="Primary"
                  variant="outlined"
                  className={classes.button2}
                >
                 Lead Budget Breakup
                </Button>
                </Tooltip>
                <Tooltip title="Show % of trips where fup override was used">
                <Button
                  onClick={overrideanalytics}
                  align="right"
                  color="Primary"
                  variant="outlined"
                  className={classes.button2}
                >
                 Override Analytics
                </Button>
                </Tooltip>
                {role=="Admin"?(
                  <Tooltip title="Show leads division based on ip">
                <Button
                  onClick={handleipanalytics}
                  align="right"
                  color="Primary"
                  variant="outlined"
                  className={classes.button2}
                >
                  IP Breakup
                </Button>
                </Tooltip>
                ):("")}

                {role=="Admin"?(
                  <Tooltip title="Show trip ids of effective calls">
                <Button
                  onClick={handleecanalytics}
                  align="right"
                  color="Primary"
                  variant="outlined"
                  className={classes.button2}
                >
                  Effective Calls
                </Button>
                </Tooltip>
                ):("")}
                {role=="Admin"?(
                  <Tooltip title="Show potential leads l2c">
                <Button
                  onClick={handlepotSearch}
                  align="right"
                  color="Primary"
                  variant="outlined"
                  className={classes.button2}
                >
                  Potential L2C
                </Button>
                </Tooltip>
                ):("")}
                {role=="Admin"?(
                  <Tooltip title="Show trips with effective calls l2c">
                <Button
                  onClick={handlecalldataSearch}
                  align="right"
                  color="Primary"
                  variant="outlined"
                  className={classes.button2}
                >
                  Effective Calls L2C
                </Button>
                </Tooltip>
                ):("")}
                {role=="Admin"?(
                  <Tooltip title="Show l2c of leads with effective calls">
                <Button
                  onClick={handlefirstcalldataSearch}
                  align="right"
                  color="Primary"
                  variant="outlined"
                  className={classes.button2}
                >
                FC Effective L2C
                </Button>
                </Tooltip>
                ):("")}
                {role=="Admin"?(
                  <Tooltip title="Show l2c of ceratin number of quote edits">
                <Button
                  onClick={handleqedata}
                  align="right"
                  color="Primary"
                  variant="outlined"
                  className={classes.button2}
                >
                QE L2C
                </Button>
                </Tooltip>
                ):("")}
                
            </div>
            ):("")}
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Daily Report
              </Typography>
              <div align="center">
              {funnelData.length>1?(<Button
                  onClick={() =>setdrawer(true)}
                  color="primary"
                  variant="contained"
                  className={classes.button}
                >
                  Insights
                </Button>):("")}
                <Button
                  onClick={preventDoubleClick(handlefunnelSearch)}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Current status{" "}
                </Button>
                
                {/* <Button
            onClick={sendmail}
            color="secondary"
            variant="outlined"
            className={classes.button}
          >
            Send mail{" "}
          </Button> */}
                
                <FormControl
                  style={{
                    minWidth: 450,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 5,
                  }}
                >
                  <InputLabel id="primary destination">
                    Primary Destination
                  </InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField}
                    labelId="primary destination"
                    onChange={(e) => setdestData2(e.target.value)}
                  >
                    {dest.map((dest) => {
                      return <MenuItem value={dest}>{dest}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </div>
              {analyticsdatalistdisplay3.length > 0 ? (
                <div style={{ height: 700, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay3}
                    columns={columns3}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
              <div align="center">
              <FormControl
                  style={{
                    minWidth: 450,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 5,
                  }}
                >
                  <InputLabel id="primary destination">
                    Primary Destination
                  </InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField}
                    labelId="primary destination"
                    onChange={(e) => setdestData2(e.target.value)}
                  >
                    {dest.map((dest) => {
                      return <MenuItem value={dest}>{dest}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              <Button
                  onClick={preventDoubleClick(newhandlefunnelSearch)}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Load
                </Button>
              </div>
            

              {analyticsdatalistdisplay4.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay4}
                    columns={columns4}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
            {cuser=="Debayan"?(
            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Closed Trips - NPS
              </Typography>
              <div align="center">
                <TextField
                  variant="outlined"
                  type="date"
                  label="Closed On or after"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData3({
                      ...searchData3,
                      start_date: e.target.value,
                    })
                  }
                />

                <TextField
                  variant="outlined"
                  type="date"
                  label="Closed On or before"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData3({ ...searchData3, end_date: e.target.value })
                  }
                />
                <FormControl
                  style={{
                    minWidth: 450,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 5,
                  }}
                >
                  <InputLabel id="primary destination">
                    Primary Destination
                  </InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField}
                    labelId="primary destination"
                    onChange={(e) => setdestData(e.target.value)}
                  >
                    {dest.map((dest) => {
                      return <MenuItem value={dest}>{dest}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
                <Button
                  onClick={preventDoubleClick(handleclosedSearch)}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Search
                </Button>
              </div>
              {analyticsdatalistdisplay5.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay5}
                    columns={columns5}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
            ):("")}
           
             <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Call Record Data
              </Typography>
                {/* <FormControlLabel control={<Switch  onChange={()=>setssfilter(!ssfilter)} color="secondary" />} label="Remove SS" /> */}
                <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="owner">SS Data</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="owner"
              value={ssfilter}
              onChange={(e) =>
                setssfilter(e.target.value )
              }
            >
            <MenuItem value={"All"}>All</MenuItem>
            <MenuItem value={"Only Sales"}>Only Sales</MenuItem>
            <MenuItem value={"Only SS"}>Only SS</MenuItem>
            </Select>
          </FormControl>
              <div align="center">
                <TextField
                  variant="outlined"
                  type="date"
                  label="Call On or after"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData4({
                      ...searchData4,
                      start_date: e.target.value,
                    })
                  }
                />

                <TextField
                  variant="outlined"
                  type="date"
                  label="Call On or before"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData4({ ...searchData4, end_date: e.target.value })
                  }
                />

                <Button
                  onClick={preventDoubleClick(handlecallSearch)}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Search
                </Button>
              </div>
              {analyticsdatalistdisplay9.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay9}
                    columns={columns9}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
              <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="owner">Owner</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="owner"
              value={searchData8.owner}
              onChange={(e) =>
                setsearchData8({ ...searchData8, owner: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
             {splist2.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
             
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="type">Type</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="type"
              value={searchData8.type}
              onChange={(e) =>
                setsearchData8({ ...searchData8, type: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={"Trip"}>Trip</MenuItem>
            <MenuItem value={"Lead"}>Lead</MenuItem>
            
             
            </Select>
          </FormControl>
              {callresultobject.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={callresultobject}
                    columns={columns12}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper> 

            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                FC Call record details
              </Typography>
             
              <FormControlLabel control={<Switch  onChange={()=>setshowsupport(!showsupport)} color="primary" />} label="Search by Support team" />
             
              <FormControlLabel control={<Switch  onChange={()=>setshowattempted(!showattempted)} color="secondary" />} label="Search by Attempted" />
          
              <FormControlLabel control={<Switch  onChange={()=>setshowauditdate(!showauditdate)} color="secondary" />} label="Search by Audit Date" />
              <div align="center">
                <TextField
                  variant="outlined"
                  type="date"
                  label="Call On or after"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData4({
                      ...searchData4,
                      start_date: e.target.value,
                    })
                  }
                />

                <TextField
                  variant="outlined"
                  type="date"
                  label="Call On or before"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData4({ ...searchData4, end_date: e.target.value })
                  }
                />

                <Button
                  onClick={preventDoubleClick(handlecallSearch2)}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Search
                </Button>
                {/* <Button
                  onClick={preventDoubleClick(handleauditcallSearch2)}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Audit Search
                </Button> */}
                {showsupport?(
                  <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="owner">Support Owner</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="owner"
              value={searchData4.support_owner}
              onChange={(e) =>
                setsearchData4({ ...searchData4, support_owner: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
             {splist4.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
             
            </Select>
          </FormControl>
                ):(
                  <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="owner">Lead Owner</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="owner"
              value={searchData4.owner}
              onChange={(e) =>
                setsearchData4({ ...searchData4, owner: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
             {splist2.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
             
            </Select>
          </FormControl>
                )}
                
              </div>
               {analyticsdatalistdisplay10.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay10} headers={headers}>Download CSV</CSVLink>
                   </div>
                ):("")}
              {analyticsdatalistdisplay10.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay10}
                    columns={columns10}
                    autoPageSize
                    onCellDoubleClick={(getValue) =>
              gridcellclicklead(getValue.row.lead_id)
            }
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>

            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                FUP Call record details
              </Typography>
              <div align="center">
              <FormControlLabel control={<Switch  onChange={()=>setshowattempted(!showattempted)} color="secondary" />} label="Search by Attempted" />
              <FormControlLabel control={<Switch  onChange={()=>setshowauditdate(!showauditdate)} color="secondary" />} label="Search by Audit Date" />
                <TextField
                  variant="outlined"
                  type="date"
                  label="Call On or after"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData4({
                      ...searchData4,
                      start_date: e.target.value,
                    })
                  }
                />

                <TextField
                  variant="outlined"
                  type="date"
                  label="Call On or before"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData4({ ...searchData4, end_date: e.target.value })
                  }
                />

                <Button
                  onClick={preventDoubleClick(handlecallSearch4)}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Search
                </Button>
                 {/* <Button
                  onClick={preventDoubleClick(handlecallSearch4b)}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Audit Search
                </Button> */}
                <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="owner">Trip Owner</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="owner"
              value={searchData4.owner}
              onChange={(e) =>
                setsearchData4({ ...searchData4, owner: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
             {splist2.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
             
            </Select>
          </FormControl>
              </div>
               {analyticsdatalistdisplay12.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay12} headers={headers}>Download CSV</CSVLink>
                   </div>
                ):("")}
              {analyticsdatalistdisplay12.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay12}
                    columns={columns10b}
                    autoPageSize
                    onCellDoubleClick={(getValue) =>
              gridcellclick(getValue.row.lead_id)
            }
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>

             <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Audit Details
              </Typography>
              <div align="center">
              <FormControlLabel control={<Switch  onChange={()=>setshowfupaudit(!showfupaudit)} color="secondary" />} label="Search by FUP" />
                <TextField
                  variant="outlined"
                  type="date"
                  label="Call On or after"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData14({
                      ...searchData14,
                      start_date: e.target.value,
                    })
                  }
                />

                <TextField
                  variant="outlined"
                  type="date"
                  label="Call On or before"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData14({ ...searchData14, end_date: e.target.value })
                  }
                />

                <Button
                  onClick={showfupaudit?preventDoubleClick(handlecallSearch4b):preventDoubleClick(handleauditcallSearch2)}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Search
                </Button>
              </div>
               {analyticsdatalistdisplay14.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay14} headers={headers14}>Download CSV</CSVLink>
                   </div>
                ):("")}
              {analyticsdatalistdisplay14.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay14}
                    columns={columns14}
                    autoPageSize
                   
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>

            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                FC Check
              </Typography>
              <div align="center">
                <TextField
                  variant="outlined"
                  type="date"
                  label="Work done or after"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData7({
                      ...searchData7,
                      start_date: e.target.value,
                    })
                  }
                />

                <TextField
                  variant="outlined"
                  type="date"
                  label="Work done or before"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData7({ ...searchData7, end_date: e.target.value })
                  }
                />

                <Button
                  onClick={preventDoubleClick(handlecallSearch3)}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Search
                </Button>
                <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="owner">Lead Owner</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="owner"
              value={searchData7.owner}
              onChange={(e) =>
                setsearchData7({ ...searchData7, owner: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
             {splist2.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
             
            </Select>
          </FormControl>
              </div>
              {analyticsdatalistdisplay11.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay11}
                    columns={columns11}
                    autoPageSize
                    onCellDoubleClick={(getValue)=>gridcelldoubleclick(getValue.row.lead_id)}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>

            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Quote Edit Data
              </Typography>
              <div align="center">
                <TextField
                  variant="outlined"
                  type="date"
                  label="Date On or after"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData5({
                      ...searchData5,
                      start_date: e.target.value,
                    })
                  }
                />

                <TextField
                  variant="outlined"
                  type="date"
                  label="Date On or before"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData5({ ...searchData5, end_date: e.target.value })
                  }
                />
                <FormControl
                  style={{
                    minWidth: 450,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 5,
                  }}
                >
                  <InputLabel id="primary destination">
                    Primary Destination
                  </InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField}
                    labelId="primary destination"
                    onChange={(e) => setsearchData5({...searchData5, destination:e.target.value})}
                  >
                    {dest.map((dest) => {
                      return <MenuItem value={dest}>{dest}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
                {/* <FormControl
                  style={{
                    minWidth: 450,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 5,
                  }}
                >
                  <InputLabel id="status">
                    Lead status
                  </InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField}
                    labelId="status"
                    onChange={(e) => setsearchData5({...searchData5, Lead_status:e.target.value})}
                  >
                    
                    <MenuItem value="Looking for information only. Will plan later">Looking for information only. Will plan later</MenuItem>
                    <MenuItem value="Thinking about going on a trip but nothing has been decided yet">Thinking about going on a trip but nothing has been decided yet</MenuItem>
                    <MenuItem value="Definitely going on a trip. Planning in progress">Definitely going on a trip. Planning in progress</MenuItem>
                    <MenuItem value="Travel date, destination and people travelling all finalized. Just looking for a package">Travel date, destination and people travelling all finalized. Just looking for a package</MenuItem>
                  </Select>
                </FormControl> */}
                <Button
                  onClick={preventDoubleClick(handleQESearch)}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Search
                </Button>
              </div>
              {analyticsdatalistdisplay7.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay7}
                    columns={columns7}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>

            <Paper variant="outlined" className={classes.paper} elevation={10}>
              
            <Tooltip title="NR: Call not picked and no response on Whatsapp, No response after multiple follow ups, Will call you back if we are interested, Plan on hold,Asked to call later after a week, Asked to call later, Asked to call later after a few days,System fup - WA msg sent -Fup-3, System fup - WA msg sent -Fup-4 || Normal:Call not picked. WA sent, Yet to view quote, Will let you know, Call not picked, Quote shared, System fup - WA msg sent -Fup-1, System fup - WA msg sent -Fup-2 || Prog: Asked to add flights. Shared quote with flights, Need changes. Need to share updated quote, Needed changes. Shared updated quote, Will let you know tomorrow, Will let you know within 2-3 days, Will let you know within a week, Our quote is costly. Shared other options, Budget issue. Will let us know, Budget issue. Shared other options, Comparing packages with other agencies, Everything finalized. Awaiting payment|| Manual:Fup done manually || Post:Need to share voucher or tickets, Need to share insurance, Need to confirm booking with supplier, Need to make payment to supplier"><Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
              
                {" "}
                Fup Data
              </Typography></Tooltip>
              
              <div align="center">
                <TextField
                  variant="outlined"
                  type="date"
                  label="Date On or after"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData6({
                      ...searchData6,
                      start_date: e.target.value,
                    })
                  }
                />

                <TextField
                  variant="outlined"
                  type="date"
                  label="Date On or before"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData6({ ...searchData6, end_date: e.target.value })
                  }
                />
                <FormControl
                  style={{
                    minWidth: 450,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 5,
                  }}
                >
                  <InputLabel id="primary destination">
                    Primary Destination
                  </InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField}
                    labelId="primary destination"
                    onChange={(e) => setsearchData6({...searchData6, destination:e.target.value})}
                  >
                    {dest.map((dest) => {
                      return <MenuItem value={dest}>{dest}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
                
                <Button
                  onClick={preventDoubleClick(handlefupSearch)}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Search
                </Button>
                {analyticsdatalistdisplay8.length > 0 ?(
                  <Button
                  onClick={preventDoubleClick(handleprogSearch)}
                  color="primary"
                  variant="contained"
                  className={classes.button}
                >
                  Show Prog
                </Button>
                ):("")}
                
              </div>
              {analyticsdatalistdisplay8.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay8}
                    columns={columns8}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Daily Report
              </Typography>
              <div align="center">
                <Button
                  onClick={preventDoubleClick(handlefunnelSearch1)}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Current status{" "}
                </Button>
               
                <FormControl
                  style={{
                    minWidth: 450,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 5,
                  }}
                >
                  <InputLabel id="primary destination">
                    Primary Destination
                  </InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField}
                    labelId="primary destination"
                    onChange={(e) => setdestData2(e.target.value)}
                  >
                    {dest.map((dest) => {
                      return <MenuItem value={dest}>{dest}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </div>
              {analyticsdatalistdisplay3.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay3}
                    columns={columns3}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
              <div align="center">
              <FormControl
                  style={{
                    minWidth: 450,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 5,
                  }}
                >
                  <InputLabel id="primary destination">
                    Primary Destination
                  </InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField}
                    labelId="primary destination"
                    onChange={(e) => setdestData2(e.target.value)}
                  >
                    {dest.map((dest) => {
                      return <MenuItem value={dest}>{dest}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              <Button
                  onClick={preventDoubleClick(newhandlefunnelSearch1)}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Load
                </Button>
              </div>

              {analyticsdatalistdisplay4.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay4}
                    columns={columns4}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Daily Report
              </Typography>
              <div align="center">
                <Button
                  onClick={preventDoubleClick(handlefunnelSearch2)}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Current status{" "}
                </Button>
                
               
                <FormControl
                  style={{
                    minWidth: 450,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 5,
                  }}
                >
                  <InputLabel id="primary destination">
                    Primary Destination
                  </InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField}
                    labelId="primary destination"
                    onChange={(e) => setdestData2(e.target.value)}
                  >
                    {dest.map((dest) => {
                      return <MenuItem value={dest}>{dest}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </div>
              {analyticsdatalistdisplay3.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay3}
                    columns={columns3}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}

              <div align="center">
              <FormControl
                  style={{
                    minWidth: 450,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 5,
                  }}
                >
                  <InputLabel id="primary destination">
                    Primary Destination
                  </InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField}
                    labelId="primary destination"
                    onChange={(e) => setdestData2(e.target.value)}
                  >
                    {dest.map((dest) => {
                      return <MenuItem value={dest}>{dest}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              <Button
                  onClick={preventDoubleClick(newhandlefunnelSearch2)}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Load
                </Button>
              </div>

              {analyticsdatalistdisplay4.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay4}
                    columns={columns4}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
          </TabPanel>
          <TabPanel value={value} index={3}>
            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Daily Report
              </Typography>
              <div align="center">
                <Button
                  onClick={preventDoubleClick(handlefunnelSearch3)}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Current status{" "}
                </Button>
                
               
                <FormControl
                  style={{
                    minWidth: 450,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 5,
                  }}
                >
                  <InputLabel id="primary destination">
                    Primary Destination
                  </InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField}
                    labelId="primary destination"
                    onChange={(e) => setdestData2(e.target.value)}
                  >
                    {dest.map((dest) => {
                      return <MenuItem value={dest}>{dest}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </div>
              {analyticsdatalistdisplay3.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay3}
                    columns={columns3}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}

              <div align="center">
              <FormControl
                  style={{
                    minWidth: 450,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 5,
                  }}
                >
                  <InputLabel id="primary destination">
                    Primary Destination
                  </InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField}
                    labelId="primary destination"
                    onChange={(e) => setdestData2(e.target.value)}
                  >
                    {dest.map((dest) => {
                      return <MenuItem value={dest}>{dest}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              <Button
                  onClick={preventDoubleClick(newhandlefunnelSearch3)}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Load
                </Button>
              </div>

              {analyticsdatalistdisplay4.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay4}
                    columns={columns4}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
          </TabPanel>
          <TabPanel value={value} index={4}>
            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Daily Report
              </Typography>
              <div align="center">
                <Button
                  onClick={preventDoubleClick(handlefunnelSearch4)}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Current status{" "}
                </Button>
                
               
                <FormControl
                  style={{
                    minWidth: 450,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 5,
                  }}
                >
                  <InputLabel id="primary destination">
                    Primary Destination
                  </InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField}
                    labelId="primary destination"
                    onChange={(e) => setdestData2(e.target.value)}
                  >
                    {dest.map((dest) => {
                      return <MenuItem value={dest}>{dest}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </div>
              {analyticsdatalistdisplay3.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay3}
                    columns={columns3}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}

              <div align="center">
              <FormControl
                  style={{
                    minWidth: 450,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 5,
                  }}
                >
                  <InputLabel id="primary destination">
                    Primary Destination
                  </InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField}
                    labelId="primary destination"
                    onChange={(e) => setdestData2(e.target.value)}
                  >
                    {dest.map((dest) => {
                      return <MenuItem value={dest}>{dest}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              <Button
                  onClick={newhandlefunnelSearch4}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Load
                </Button>
              </div>

              {analyticsdatalistdisplay4.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay4}
                    columns={columns4}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
          </TabPanel>
          <TabPanel value={value} index={5}>
            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Daily Report
              </Typography>
              <div align="center">
                <Button
                  onClick={handlefunnelSearch5}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Current status{" "}
                </Button>
                
               
                <FormControl
                  style={{
                    minWidth: 450,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 5,
                  }}
                >
                  <InputLabel id="primary destination">
                    Primary Destination
                  </InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField}
                    labelId="primary destination"
                    onChange={(e) => setdestData2(e.target.value)}
                  >
                    {dest.map((dest) => {
                      return <MenuItem value={dest}>{dest}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </div>
              {analyticsdatalistdisplay3.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay3}
                    columns={columns3}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}

              <div align="center">
              <FormControl
                  style={{
                    minWidth: 450,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 5,
                  }}
                >
                  <InputLabel id="primary destination">
                    Primary Destination
                  </InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField}
                    labelId="primary destination"
                    onChange={(e) => setdestData2(e.target.value)}
                  >
                    {dest.map((dest) => {
                      return <MenuItem value={dest}>{dest}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              <Button
                  onClick={newhandlefunnelSearch5}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Load
                </Button>
              </div>

              {analyticsdatalistdisplay4.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay4}
                    columns={columns4}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
          </TabPanel>
          <TabPanel value={value} index={6}>
            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Daily Report
              </Typography>
              <div align="center">
                <Button
                  onClick={handlefunnelSearch5}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Current status{" "}
                </Button>
                
               
                <FormControl
                  style={{
                    minWidth: 450,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 5,
                  }}
                >
                  <InputLabel id="primary destination">
                    Primary Destination
                  </InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField}
                    labelId="primary destination"
                    onChange={(e) => setdestData2(e.target.value)}
                  >
                    {dest.map((dest) => {
                      return <MenuItem value={dest}>{dest}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </div>
              {analyticsdatalistdisplay3.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay3}
                    columns={columns3}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}

              <div align="center">
              <FormControl
                  style={{
                    minWidth: 450,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 5,
                  }}
                >
                  <InputLabel id="primary destination">
                    Primary Destination
                  </InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField}
                    labelId="primary destination"
                    onChange={(e) => setdestData2(e.target.value)}
                  >
                    {dest.map((dest) => {
                      return <MenuItem value={dest}>{dest}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              <Button
                  onClick={newhandlefunnelSearch6}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Load
                </Button>
              </div>

              {analyticsdatalistdisplay4.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay4}
                    columns={columns4}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
          </TabPanel>
          <TabPanel value={value} index={7}>
            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Daily Report
              </Typography>
              <div align="center">
                <Button
                  onClick={handlefunnelSearch5}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Current status{" "}
                </Button>
                
               
                <FormControl
                  style={{
                    minWidth: 450,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 5,
                  }}
                >
                  <InputLabel id="primary destination">
                    Primary Destination
                  </InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField}
                    labelId="primary destination"
                    onChange={(e) => setdestData2(e.target.value)}
                  >
                    {dest.map((dest) => {
                      return <MenuItem value={dest}>{dest}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </div>
              {analyticsdatalistdisplay3.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay3}
                    columns={columns3}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}

              <div align="center">
              <FormControl
                  style={{
                    minWidth: 450,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 5,
                  }}
                >
                  <InputLabel id="primary destination">
                    Primary Destination
                  </InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField}
                    labelId="primary destination"
                    onChange={(e) => setdestData2(e.target.value)}
                  >
                    {dest.map((dest) => {
                      return <MenuItem value={dest}>{dest}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              <Button
                  onClick={newhandlefunnelSearch6}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Load
                </Button>
              </div>

              {analyticsdatalistdisplay4.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay4}
                    columns={columns4}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
          </TabPanel>
          <TabPanel value={value} index={8}>
            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Daily Report
              </Typography>
              <div align="center">
                <Button
                  onClick={handlefunnelSearch8}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Current status{" "}
                </Button>
                
               
                <FormControl
                  style={{
                    minWidth: 450,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 5,
                  }}
                >
                  <InputLabel id="primary destination">
                    Primary Destination
                  </InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField}
                    labelId="primary destination"
                    onChange={(e) => setdestData2(e.target.value)}
                  >
                    {dest.map((dest) => {
                      return <MenuItem value={dest}>{dest}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </div>
              {analyticsdatalistdisplay3.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay3}
                    columns={columns3}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}

              <div align="center">
              <FormControl
                  style={{
                    minWidth: 450,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 5,
                  }}
                >
                  <InputLabel id="primary destination">
                    Primary Destination
                  </InputLabel>
                  <Select
                    displayEmpty
                    classname={classes.textField}
                    labelId="primary destination"
                    onChange={(e) => setdestData2(e.target.value)}
                  >
                    {dest.map((dest) => {
                      return <MenuItem value={dest}>{dest}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              <Button
                  onClick={newhandlefunnelSearch8}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Load
                </Button>
              </div>

              {analyticsdatalistdisplay4.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay4}
                    columns={columns4}
                    autoPageSize
                    // pageSize={10}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>
          </TabPanel>
        </div>
      ) : (
        "Loading..."
      )}
    </Box>
  );
};

export default Analyticsdata;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
